// Code generated by the Encore v1.54.0 client generator. DO NOT EDIT.

// Disable eslint, jshint, and jslint for this file.
/* eslint-disable */
/* jshint ignore:start */
/*jslint-disable*/

/**
 * BaseURL is the base URL for calling the Encore application's API.
 */
export type BaseURL = string

export const Local: BaseURL = "http://localhost:4000"

/**
 * Environment returns a BaseURL for calling the cloud environment with the given name.
 */
export function Environment(name: string): BaseURL {
    return `https://${name}-zac-2w8i.encr.app`
}

/**
 * PreviewEnv returns a BaseURL for calling the preview environment with the given PR number.
 */
export function PreviewEnv(pr: number | string): BaseURL {
    return Environment(`pr${pr}`)
}

const BROWSER = typeof globalThis === "object" && ("window" in globalThis);

/**
 * Client is an API client for the zac-2w8i Encore application.
 */
export default class Client {
    public readonly auth: auth.ServiceClient
    public readonly browser: browser.ServiceClient
    public readonly chat: chat.ServiceClient
    public readonly config: config.ServiceClient
    public readonly connection: connection.ServiceClient
    public readonly database: database.ServiceClient
    public readonly events: events.ServiceClient
    public readonly executor: executor.ServiceClient
    public readonly graph_changes: graph_changes.ServiceClient
    public readonly graph_config: graph_config.ServiceClient
    public readonly graph_docs: graph_docs.ServiceClient
    public readonly mcp_zoom: mcp_zoom.ServiceClient
    public readonly orchestrator: orchestrator.ServiceClient
    public readonly parser: parser.ServiceClient
    public readonly planner: planner.ServiceClient
    public readonly planning: planning.ServiceClient
    public readonly pmf: pmf.ServiceClient
    public readonly repl: repl.ServiceClient
    public readonly report: report.ServiceClient
    public readonly validation: validation.ServiceClient
    public readonly verification: verification.ServiceClient
    public readonly zoom: zoom.ServiceClient
    private readonly options: ClientOptions
    private readonly target: string


    /**
     * Creates a Client for calling the public and authenticated APIs of your Encore application.
     *
     * @param target  The target which the client should be configured to use. See Local and Environment for options.
     * @param options Options for the client
     */
    constructor(target: BaseURL, options?: ClientOptions) {
        this.target = target
        this.options = options ?? {}
        const base = new BaseClient(this.target, this.options)
        this.auth = new auth.ServiceClient(base)
        this.browser = new browser.ServiceClient(base)
        this.chat = new chat.ServiceClient(base)
        this.config = new config.ServiceClient(base)
        this.connection = new connection.ServiceClient(base)
        this.database = new database.ServiceClient(base)
        this.events = new events.ServiceClient(base)
        this.executor = new executor.ServiceClient(base)
        this.graph_changes = new graph_changes.ServiceClient(base)
        this.graph_config = new graph_config.ServiceClient(base)
        this.graph_docs = new graph_docs.ServiceClient(base)
        this.mcp_zoom = new mcp_zoom.ServiceClient(base)
        this.orchestrator = new orchestrator.ServiceClient(base)
        this.parser = new parser.ServiceClient(base)
        this.planner = new planner.ServiceClient(base)
        this.planning = new planning.ServiceClient(base)
        this.pmf = new pmf.ServiceClient(base)
        this.repl = new repl.ServiceClient(base)
        this.report = new report.ServiceClient(base)
        this.validation = new validation.ServiceClient(base)
        this.verification = new verification.ServiceClient(base)
        this.zoom = new zoom.ServiceClient(base)
    }

    /**
     * Creates a new Encore client with the given client options set.
     *
     * @param options Client options to set. They are merged with existing options.
     **/
    public with(options: ClientOptions): Client {
        return new Client(this.target, {
            ...this.options,
            ...options,
        })
    }
}

/**
 * ClientOptions allows you to override any default behaviour within the generated Encore client.
 */
export interface ClientOptions {
    /**
     * By default the client will use the inbuilt fetch function for making the API requests.
     * however you can override it with your own implementation here if you want to run custom
     * code on each API request made or response received.
     */
    fetcher?: Fetcher

    /** Default RequestInit to be used for the client */
    requestInit?: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }

    /**
     * Allows you to set the authentication data to be used for each
     * request either by passing in a static object or by passing in
     * a function which returns a new object for each request.
     */
    auth?: auth.AuthParams | AuthDataGenerator
}

export namespace auth {
    export interface AuthParams {
        authorization: string
        tenantId: string
    }

    export interface AuthUser {
        id: string
        email: string
        name: string | null
        avatarUrl: string | null
    }

    export interface GetMeResponse {
        user: AuthUser
        tenantId: string
        hasZoomConnection: boolean
    }

    export interface LogoutResponse {
        success: boolean
    }

    export interface OtpRequestParams {
        email: string
    }

    export interface OtpRequestResponse {
        success: boolean
        message: string
    }

    export interface OtpVerifyParams {
        email: string
        code: string
    }

    export interface OtpVerifyResponse {
        token: string
        user: AuthUser
        expiresAt: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getGoogleAuthUrl = this.getGoogleAuthUrl.bind(this)
            this.getMe = this.getMe.bind(this)
            this.getZoomAuthUrl = this.getZoomAuthUrl.bind(this)
            this.googleCallback = this.googleCallback.bind(this)
            this.logout = this.logout.bind(this)
            this.requestOtp = this.requestOtp.bind(this)
            this.verifyOtpEndpoint = this.verifyOtpEndpoint.bind(this)
            this.zoomCallback = this.zoomCallback.bind(this)
        }

        public async getGoogleAuthUrl(): Promise<{
    url: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/auth/google/url`)
            return await resp.json() as {
    url: string
}
        }

        /**
         * GET /auth/me - Returns the authenticated user's profile.
         * Requires a valid session (auth: true).
         */
        public async getMe(): Promise<GetMeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/auth/me`)
            return await resp.json() as GetMeResponse
        }

        public async getZoomAuthUrl(): Promise<{
    url: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/auth/zoom/url`)
            return await resp.json() as {
    url: string
}
        }

        public async googleCallback(method: "GET", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/auth/google/callback`, body, options)
        }

        /**
         * POST /auth/logout - Revokes the current session only.
         * Requires a valid session (auth: true).
         */
        public async logout(params: {
    authorization: string
}): Promise<LogoutResponse> {
            // Convert our params into the objects we need for the request
            const headers = makeRecord<string, string>({
                authorization: params.authorization,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/auth/logout`, undefined, {headers})
            return await resp.json() as LogoutResponse
        }

        public async requestOtp(params: OtpRequestParams): Promise<OtpRequestResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/auth/otp/request`, JSON.stringify(params))
            return await resp.json() as OtpRequestResponse
        }

        public async verifyOtpEndpoint(params: OtpVerifyParams): Promise<OtpVerifyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/auth/otp/verify`, JSON.stringify(params))
            return await resp.json() as OtpVerifyResponse
        }

        public async zoomCallback(method: "GET", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/auth/zoom/callback`, body, options)
        }
    }
}

export namespace browser {
    export interface ActionRequest {
        id: string
        tabId: number
        action: BrowserAction
        status: ActionStatus
        createdAt: number
        approvedAt: number | null
        completedAt: number | null
        result: any
        error: string | null
    }

    export type ActionStatus = "pending" | "approved" | "rejected" | "executing" | "completed" | "failed"

    export type ActionType = "click" | "type" | "select" | "focus" | "navigate" | "upload"

    export interface AgentAction {
        type: "click" | "type" | "fill" | "select" | "scroll" | "hover" | "wait" | "back" | "done" | "error"
        target?: string
        value?: string
        reason: string
    }

    export interface ApproveStepResponse {
        approved: boolean
    }

    export interface AreaProbeProgressResponse {
        session: AreaProbeSession
    }

    export interface AreaProbeSession {
        id: string
        tabId: number
        status: AreaProbeStatus
        pagesProbed: number
        totalPages: number
        currentUrl: string | null
        currentAction: string | null
        startedAt: number
        completedAt: number | null
        error: string | null
    }

    export type AreaProbeStatus = "running" | "completed" | "failed"

    export interface BackendMessage {
        type: string
        /**
         * REQUEST_SNAPSHOT / REQUEST_ACTION / EXECUTE_ACTION / START_DISCOVERY / START_AGENT
         */
        tabId?: number

        requestId?: string
        actionId?: string
        action?: BrowserAction | AgentAction
        autoExecute?: boolean
        /**
         * START_DISCOVERY
         */
        sessionId?: string

        startUrl?: string
        maxDepth?: number
        /**
         * NAVIGATION_ANALYZED
         */
        sections?: NavSection[]

        error?: string
        /**
         * START_AGENT
         */
        goal?: string

        /**
         * OPEN_TAB
         */
        url?: string

        /**
         * EXECUTE_UI_STEP
         */
        executionId?: string

        stepIndex?: number
        step?: any
        /**
         * START_AREA_PROBE
         */
        targetUrls?: string[]

        /**
         * CHAT_STREAM / CHAT_MESSAGE / CHAT_ACTION (side panel responses)
         */
        token?: string

        messageId?: string
        text?: string
        actions?: {
            actionType: string
            target: string
            label: string
        }[]
    }

    export interface BrowserAction {
        type: ActionType
        ref?: string
        value?: string
        url?: string
        preview: string
        elementInfo?: {
            tag: string
            text: string
            ariaLabel: string | null
            name: string | null
        }
        fileData?: {
            name: string
            type: string
            base64: string
        }
    }

    export interface BrowserScript {
        id: string
        name: string
        steps: ScriptStep[]
        createdAt: number
        updatedAt: number
    }

    export interface CancelUIExecutionResponse {
        cancelled: boolean
    }

    export interface Control {
        ref: string
        tag: string
        role: string | null
        type: ControlType
        label: string
        text: string
        href: string | null
        inputType: string | null
        name: string | null
        value: any
        checked: boolean | null
        section: string
        rect: ElementRect
    }

    export type ControlType = "toggle" | "select" | "input" | "textarea" | "button" | "link" | "tab" | "menuitem" | "unknown"

    export interface CrawlDiff {
        runIdA: string
        runIdB: string
        pagesAdded: PageDiff[]
        pagesRemoved: PageDiff[]
        pagesChanged: PageDiff[]
        summary: {
            totalPagesA: number
            totalPagesB: number
            added: number
            removed: number
            changed: number
            unchanged: number
        }
    }

    export interface CrawlRun {
        id: string
        runType: CrawlRunType
        status: CrawlRunStatus
        pagesFound: number
        pagesVisited: number
        screenshotsCaptured: number
        startedAt: string
        completedAt: string | null
        durationMs: number | null
        error: string | null
        metadata: { [key: string]: any }
    }

    export type CrawlRunStatus = "running" | "completed" | "failed"

    export type CrawlRunType = "admin_ui" | "marketplace"

    export interface CrawlSnapshot {
        id: string
        runId: string
        pageUrl: string
        urlPattern: string | null
        pageTitle: string | null
        heading: string | null
        pageType: string | null
        activeTab: string | null
        elementCount: number
        controlCount: number
        formCount: number
        crawledAt: string
    }

    export interface CreateScriptRequest {
        name: string
        steps: ScriptStep[]
    }

    export interface CreateScriptResponse {
        script: BrowserScript
    }

    export interface DataElement {
        dataType: "heading" | "status" | "column-header" | "cell" | "label" | "badge" | "text"
        text: string
        hierarchy?: string
        tag: string
        role?: string | null
        id?: string | null
        ariaLabel?: string | null
        rect: ElementRect
        region?: RegionType
    }

    export interface DeepProbeProgressResponse {
        session: DeepProbeSession
    }

    export interface DeepProbeSession {
        id: string
        tabId: number
        url: string
        status: DeepProbeStatus
        expandablesFound: number
        expandablesProbed: number
        startedAt: number
        completedAt: number | null
        error: string | null
    }

    export type DeepProbeStatus = "idle" | "running" | "completed" | "failed"

    export interface DeleteScriptResponse {
        deleted: boolean
    }

    export interface DisambiguationCandidate {
        /**
         * Element reference in the DOM snapshot (e.g., '@e5')
         */
        ref: string

        /**
         * Visible text content
         */
        text: string

        /**
         * ARIA label
         */
        ariaLabel: string | null

        /**
         * HTML tag name
         */
        tag: string

        /**
         * Human-readable description of the element
         */
        description: string

        /**
         * DOM hierarchy breadcrumb
         */
        hierarchy: string

        /**
         * Match score
         */
        score: number
    }

    export interface DiscoverSectionRequest {
        tabId: number
        section: string
    }

    export interface DiscoverSectionResponse {
        sessionId: string
        status: string
        targetUrls: string[]
    }

    export interface DiscoveryProgressResponse {
        session: DiscoverySession
    }

    export interface DiscoverySession {
        id: string
        tabId: number
        domain: string
        startUrl: string
        maxDepth: number
        status: DiscoveryStatus
        pagesVisited: number
        pagesQueued: number
        linksFound: number
        currentUrl: string | null
        startedAt: number
        completedAt: number | null
        error: string | null
    }

    export type DiscoveryStatus = "idle" | "running" | "completed" | "failed" | "stopped"

    export interface ElementRect {
        x: number
        y: number
        width: number
        height: number
    }

    export interface EventsResponse {
        events: {
            type: string
            timestamp: number
            data: { [key: string]: any }
        }[]
    }

    export type ExpandableType = "sidebar-section" | "tab" | "menu-trigger" | "accordion" | "dropdown" | "disclosure"

    export interface ExtensionMessage {
        type: string
        /**
         * TAB_ATTACHED / TAB_DETACHED / SNAPSHOT
         */
        tabId?: number

        url?: string
        requestId?: string
        snapshot?: Snapshot
        screenshot?: string
        annotatedScreenshot?: string
        reason?: string
        /**
         * ACTION_* / SNAPSHOT_ERROR
         */
        actionId?: string

        success?: boolean
        result?: any
        error?: string
        /**
         * DISCOVERY_*
         */
        pagesVisited?: number

        pagesQueued?: number
        linksFound?: number
        currentUrl?: string
        siteMap?: {
            domain: string
            startUrl: string
            pages: { [key: string]: SiteMapPage }
            navigation: NavigationEdge[]
            discoveredAt: number
            pageCount: number
            linkCount: number
        }
        sessionId?: string
        /**
         * AGENT_DECIDE / ANALYZE_NAVIGATION
         */
        goal?: string

        history?: {
            action: string
            result: string
        }[]
        /**
         * AGENT_COMPLETE
         */
        steps?: number

        /**
         * RECORDED_ACTION
         */
        action?: BrowserAction

        /**
         * UI_STEP_RESULT
         */
        executionId?: string

        stepIndex?: number
        discoveries?: any[]
        /**
         * DEEP_PROBE_PROGRESS / DEEP_PROBE_COMPLETE / DEEP_PROBE_ERROR
         */
        expandablesFound?: number

        expandablesProbed?: number
        currentLabel?: string
        deepProbeResult?: any
        /**
         * FULL_DISCOVERY_PROGRESS / FULL_DISCOVERY_PAGE / FULL_DISCOVERY_COMPLETE
         */
        pageUrl?: string

        pageTitle?: string
        activeTab?: string
        pagesFound?: number
        /**
         * AREA_PROBE_*
         */
        forms?: any[]

        button?: {
            text: string
            ariaLabel: string
        }
        outcome?: string
        destinationUrl?: string | null
        pagesProbed?: number
        totalPages?: number
        currentAction?: string
        rowActions?: string[]
        /**
         * CHAT_SEND (side panel)
         */
        text?: string

        pageContext?: any
        /**
         * SET_EXEC_MODE
         */
        mode?: string
    }

    export interface ExtensionStatus {
        connected: boolean
        connectedAt: number | null
        tabs: {
            tabId: number
            url: string
            attachedAt: number
        }[]
    }

    export interface FullAdminDiscoverySession {
        id: string
        tabId: number
        status: FullDiscoveryStatus
        pagesFound: number
        pagesVisited: number
        currentUrl: string | null
        startedAt: number
        completedAt: number | null
        error: string | null
    }

    export interface FullDiscoveryProgressResponse {
        session: FullAdminDiscoverySession
    }

    export type FullDiscoveryStatus = "running" | "completed" | "failed"

    export interface GetActionStatusResponse {
        action: ActionRequest | null
    }

    export interface GetScriptResponse {
        script: BrowserScript | null
    }

    export interface GetSiteMapResponse {
        siteMap: SiteMap | null
    }

    export interface GetSnapshotResponse {
        snapshot: Snapshot | null
        pending: boolean
    }

    export interface HealthResponse {
        status: "ok"
        extensionConnected: boolean
        connectedTabs: number
        pendingActions: number
        pendingSnapshots: number
    }

    export interface LatestSnapshotResponse {
        snapshot: Snapshot | null
        screenshot: string | null
        annotatedScreenshot: string | null
        reason: string | null
        timestamp: number | null
    }

    export interface ListScriptsResponse {
        scripts: BrowserScript[]
    }

    export interface ListSiteMapsResponse {
        maps: {
            id: string
            domain: string
            pageCount: number
            linkCount: number
            discoveredAt: number
        }[]
    }

    export interface ListTabsResponse {
        tabs: {
            tabId: number
            url: string
            attachedAt: number
        }[]
    }

    export interface NavElement {
        ref: string
        href: string
        label: string
    }

    export interface NavSection {
        name: string
        items: string[]
    }

    export interface NavStep {
        page: string
        click: string
        label: string
    }

    export interface NavigationEdge {
        from: string
        to: string
        element: string
        label: string
    }

    export interface PageContext {
        url: string
        path: string
        documentTitle: string
        heading?: string
        breadcrumbs?: string[]
        activeNavItem?: string
        activeNavSection?: string
        activeTab?: string
        metaDescription?: string
        pageType?: "settings" | "list" | "form" | "dashboard" | "content"
        subject?: string
        navigationIntent?: {
            label: string
            elementInfo?: {
                tag: string
                text: string
                ariaLabel: string | null
                name: string | null
            } | null
            timestamp: number
        }
    }

    export interface PageDiff {
        pageUrl: string
        changeType: "added" | "removed" | "changed"
        before?: SnapshotSummary
        after?: SnapshotSummary
        changes: string[]
    }

    export interface PauseUIExecutionResponse {
        paused: boolean
    }

    export interface PlanUIExecutionRequest {
        goal: string
        tabId: number
        currentUrl: string
    }

    export interface PlanUIExecutionResponse {
        plan: UIExecutionPlan
    }

    export interface RecordingResponse {
        id: string
        name: string
        description: string | null
        pageUrl: string | null
        stepCount: number
        createdAt: string
        updatedAt: string
    }

    export interface Region {
        type: RegionType
        label: string
        rect: ElementRect
        summary: string
        metadata: RegionMetadata
        elementCount: number
        dataElementCount: number
    }

    export interface RegionMetadata {
        activeItem?: string
        activeSection?: string
        sectionCount?: number
        activeTab?: string
        tabCount?: number
        tabs?: string[]
        heading?: string
        subtitle?: string
        hasTable?: boolean
        tableRowCount?: number
        hasForm?: boolean
        contentType?: string
        brandName?: string
        title?: string
    }

    export type RegionType = "globalHeader" | "utilityBar" | "sidebar" | "pageHeader" | "tabStrip" | "mainContent" | "chatWidget" | "footer" | "modal"

    export interface RegisterTabRequest {
        tabId: number
        url: string
    }

    export interface RegisterTabResponse {
        registered: boolean
    }

    export interface RejectStepResponse {
        rejected: boolean
    }

    export interface RequestActionRequest {
        tabId: number
        action: BrowserAction
    }

    export interface RequestActionResponse {
        actionId: string
        status: ActionStatus
    }

    export interface RequestSnapshotResponse {
        requestId: string
    }

    export interface ResumeUIExecutionRequest {
        /**
         * Element ref selected by user to resolve disambiguation
         */
        selectedRef?: string
    }

    export interface ResumeUIExecutionResponse {
        resumed: boolean
    }

    export interface RevertStepResponse {
        reverted: boolean
    }

    export interface ScriptStep {
        id: string
        action: BrowserAction
        delay: number
    }

    export interface SearchControlsResponse {
        results: {
            domain: string
            pageUrl: string
            pageTitle: string
            control: Control
            path: NavStep[]
        }[]
    }

    export interface SiteMap {
        id: string
        domain: string
        startUrl: string
        pages: { [key: string]: SiteMapPage }
        navigation: NavigationEdge[]
        discoveredAt: number
        pageCount: number
        linkCount: number
    }

    export interface SiteMapPage {
        url: string
        urlPattern: string
        title: string
        path: NavStep[]
        controls: Control[]
        navElements: NavElement[]
        discoveredAt: number
    }

    export interface SkipStepResponse {
        skipped: boolean
    }

    export interface Snapshot {
        url: string
        title: string
        timestamp: number
        viewport: {
            width: number
            height: number
        }
        scrollPosition?: {
            x: number
            y: number
        }
        elements: SnapshotElement[]
        /**
         * Non-interactive data elements: headings, table cells, labels, status indicators
         */
        dataElements?: DataElement[]

        /**
         * Inferred page context: what this page is about
         */
        pageContext?: PageContext

        /**
         * Detected visual regions of the page
         */
        regions?: Region[]
    }

    export interface SnapshotElement {
        ref: string
        tag: string
        role: string | null
        type: string | null
        name: string | null
        text: string
        ariaLabel: string | null
        placeholder: string | null
        value?: any
        checked?: boolean | null
        disabled?: boolean | null
        description?: string
        /**
         * Breadcrumb path: "Settings → Security → Waiting Room → Toggle"
         */
        hierarchy?: string

        id?: string | null
        title?: string | null
        href?: string | null
        ariaExpanded?: string | null
        ariaHasPopup?: string | null
        selectors?: {
            css: string
            aria: string | null
            text: {
                type: string
                tag: string
                text: string
            } | null
            testId: string | null
        }
        rect: ElementRect
        region?: RegionType
    }

    export interface SnapshotSummary {
        pageTitle: string | null
        heading: string | null
        pageType: string | null
        elementCount: number
        controlCount: number
        formCount: number
    }

    export interface StartAreaProbeRequest {
        tabId: number
        targetUrls: string[]
    }

    export interface StartAreaProbeResponse {
        sessionId: string
        status: string
    }

    export interface StartDeepProbeRequest {
        tabId: number
    }

    export interface StartDeepProbeResponse {
        sessionId: string
        status: DeepProbeStatus
    }

    export interface StartDiscoveryRequest {
        tabId: number
        startUrl: string
        maxDepth?: number
    }

    export interface StartDiscoveryResponse {
        sessionId: string
        status: DiscoveryStatus
    }

    export interface StartFullDiscoveryRequest {
        tabId: number
    }

    export interface StartFullDiscoveryResponse {
        sessionId: string
        status: FullDiscoveryStatus
    }

    export interface StartUIExecutionRequest {
        planId: string
        tabId: number
        mode?: UIExecutionMode
    }

    export interface StartUIExecutionResponse {
        executionId: string
        status: UIExecutionStatus
    }

    export interface StepSnapshot {
        beforeUrl: string
        beforeSnapshot: any
        afterUrl?: string
        afterSnapshot?: any
        createdResourceIds?: string[]
    }

    export interface StopDiscoveryResponse {
        stopped: boolean
    }

    export interface SubmitActionResultRequest {
        actionId: string
        success: boolean
        result?: any
        error?: string
    }

    export interface SubmitActionResultResponse {
        received: boolean
    }

    export interface SubmitDiscoveryResultRequest {
        siteMap: {
            domain: string
            startUrl: string
            pages: { [key: string]: SiteMapPage }
            navigation: NavigationEdge[]
            discoveredAt: number
            pageCount: number
            linkCount: number
        }
    }

    export interface SubmitDiscoveryResultResponse {
        siteMapId: string
        pageCount: number
        linkCount: number
    }

    export interface SubmitSnapshotRequest {
        requestId: string
        snapshot: Snapshot
    }

    export interface SubmitSnapshotResponse {
        received: boolean
    }

    export interface UIActionStep {
        type: "action"
        action: BrowserAction
        graphControlId?: string
        expectedOutcome?: string
        captureAs?: string
        description: string
    }

    export interface UIDiscovery {
        type: "form" | "field" | "validation" | "navigation" | "action"
        data: { [key: string]: any }
    }

    export type UIExecutionContext = { [key: string]: string }

    export type UIExecutionMode = "auto" | "step_approval"

    export interface UIExecutionPlan {
        id: string
        goal: string
        steps: UIExecutionStep[]
        graphPaths: string[]
        confidence: "high" | "medium" | "low"
        createdAt: number
    }

    export interface UIExecutionProgressResponse {
        session: UIExecutionSession
    }

    export interface UIExecutionSession {
        id: string
        planId: string
        tabId: number
        status: UIExecutionStatus
        mode: UIExecutionMode
        currentStep: number
        stepResults: UIStepResult[]
        stepSnapshots: { [key: number]: StepSnapshot }
        context: UIExecutionContext
        startedAt: number
        completedAt: number | null
        error: string | null
        /**
         * Disambiguation candidates when status is 'paused_for_disambiguation'
         */
        disambiguationCandidates?: DisambiguationCandidate[]

        /**
         * Step index that triggered disambiguation
         */
        disambiguationStepIndex?: number
    }

    export type UIExecutionStatus = "pending" | "running" | "completed" | "failed" | "paused" | "paused_for_disambiguation" | "cancelled" | "awaiting_approval"

    export type UIExecutionStep = UINavigationStep | UIActionStep | UIVerifyStep | UIFindStep | UIScrollStep

    export interface UIFindStep {
        type: "find"
        target: "table_row" | "list_item" | "option"
        matchColumn?: string
        matchValue: string
        thenAction: "click" | "select"
        description: string
    }

    export interface UIGraphPageDetailRequest {
        url: string
    }

    export interface UIGraphPageDetailResponse {
        page: {
            url: string
            urlPattern: string
            title: string
            expandables: {
                id: string
                expandableType: ExpandableType
                label: string
                childCount: number
                children: {
                    id: string
                    nodeType: string
                    label: string
                }[]
            }[]
            forms: {
                id: string
                heading: string
                fields: {
                    id: string
                    name: string
                    inputType: string
                    label: string
                    required: boolean
                    options?: string[]
                }[]
            }[]
            tables: {
                id: string
                columns: string[]
                rowCount: number
                rowActions: string[]
            }[]
            mappedComponent: string | null
        } | null
    }

    export interface UIGraphPageResponse {
        pages: {
            url: string
            urlPattern: string
            title: string
            pageType: string | null
            heading: string | null
            lastProbedAt: number
            expandableCount: number
            controlCount: number
        }[]
    }

    export interface UINavigationStep {
        type: "navigate"
        url?: string
        clickRef?: string
        clickSelectors?: {
            css: string
            aria: string | null
            text: {
                type: string
                tag: string
                text: string
            } | null
        }
        expandableId?: string
        expectedUrl?: string
        description: string
    }

    export interface UIScrollStep {
        type: "scroll"
        direction: "up" | "down" | "top" | "bottom"
        description: string
    }

    export interface UIStepResult {
        stepIndex: number
        status: "completed" | "failed" | "skipped" | "fallback" | "reverted"
        method: "graph" | "vision"
        result?: any
        capturedValues?: { [key: string]: string }
        error?: string
        discoveries?: UIDiscovery[]
        duration: number
    }

    export interface UIVerifyStep {
        type: "verify"
        check: "element_exists" | "element_value" | "url_matches" | "text_contains"
        selector?: string
        expectedValue?: string
        expectedUrl?: string
        expectedText?: string
        description: string
    }

    export interface UnregisterTabResponse {
        unregistered: boolean
    }

    export interface UpdateScriptRequest {
        name?: string
        steps?: ScriptStep[]
    }

    export interface UpdateScriptResponse {
        script: BrowserScript
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.approveStepCommand = this.approveStepCommand.bind(this)
            this.cancelExecutionCommand = this.cancelExecutionCommand.bind(this)
            this.createScript = this.createScript.bind(this)
            this.deleteScript = this.deleteScript.bind(this)
            this.diffCrawlRunsEndpoint = this.diffCrawlRunsEndpoint.bind(this)
            this.discoverSection = this.discoverSection.bind(this)
            this.downloadExtension = this.downloadExtension.bind(this)
            this.executeBindingAction = this.executeBindingAction.bind(this)
            this.extensionSocket = this.extensionSocket.bind(this)
            this.generateBindingFromRecording = this.generateBindingFromRecording.bind(this)
            this.getActionStatus = this.getActionStatus.bind(this)
            this.getAreaProbeProgress = this.getAreaProbeProgress.bind(this)
            this.getCrawlRun = this.getCrawlRun.bind(this)
            this.getCrawlScreenshot = this.getCrawlScreenshot.bind(this)
            this.getCrawlSnapshots = this.getCrawlSnapshots.bind(this)
            this.getDeepProbeProgress = this.getDeepProbeProgress.bind(this)
            this.getDiscoveryProgress = this.getDiscoveryProgress.bind(this)
            this.getEvents = this.getEvents.bind(this)
            this.getExecutionProgress = this.getExecutionProgress.bind(this)
            this.getExtensionStatus = this.getExtensionStatus.bind(this)
            this.getFullDiscoveryProgress = this.getFullDiscoveryProgress.bind(this)
            this.getPageBinding = this.getPageBinding.bind(this)
            this.getPageCrawlHistory = this.getPageCrawlHistory.bind(this)
            this.getRecording = this.getRecording.bind(this)
            this.getScript = this.getScript.bind(this)
            this.getSiteMap = this.getSiteMap.bind(this)
            this.getSnapshot = this.getSnapshot.bind(this)
            this.getTabSnapshot = this.getTabSnapshot.bind(this)
            this.getUIGraphPageDetail = this.getUIGraphPageDetail.bind(this)
            this.getUIGraphPages = this.getUIGraphPages.bind(this)
            this.health = this.health.bind(this)
            this.listCrawlRuns = this.listCrawlRuns.bind(this)
            this.listPageBindings = this.listPageBindings.bind(this)
            this.listPendingActions = this.listPendingActions.bind(this)
            this.listRecordings = this.listRecordings.bind(this)
            this.listScripts = this.listScripts.bind(this)
            this.listSiteMaps = this.listSiteMaps.bind(this)
            this.listTabs = this.listTabs.bind(this)
            this.matchAdminUrlsEndpoint = this.matchAdminUrlsEndpoint.bind(this)
            this.openTabCommand = this.openTabCommand.bind(this)
            this.pair = this.pair.bind(this)
            this.pairAuthenticated = this.pairAuthenticated.bind(this)
            this.pauseExecutionCommand = this.pauseExecutionCommand.bind(this)
            this.planExecution = this.planExecution.bind(this)
            this.rediscoverUIGraph = this.rediscoverUIGraph.bind(this)
            this.registerTab = this.registerTab.bind(this)
            this.rejectStepCommand = this.rejectStepCommand.bind(this)
            this.relinkUIGraph = this.relinkUIGraph.bind(this)
            this.requestAction = this.requestAction.bind(this)
            this.requestActionCommand = this.requestActionCommand.bind(this)
            this.requestSnapshot = this.requestSnapshot.bind(this)
            this.requestSnapshotCommand = this.requestSnapshotCommand.bind(this)
            this.resumeExecutionCommand = this.resumeExecutionCommand.bind(this)
            this.revertStepCommand = this.revertStepCommand.bind(this)
            this.saveRecording = this.saveRecording.bind(this)
            this.searchControls = this.searchControls.bind(this)
            this.skipStepCommand = this.skipStepCommand.bind(this)
            this.startAdminCrawlEndpoint = this.startAdminCrawlEndpoint.bind(this)
            this.startAgentCommand = this.startAgentCommand.bind(this)
            this.startAreaProbe = this.startAreaProbe.bind(this)
            this.startDeepProbe = this.startDeepProbe.bind(this)
            this.startDiscovery = this.startDiscovery.bind(this)
            this.startExecutionCommand = this.startExecutionCommand.bind(this)
            this.startFullAdminDiscovery = this.startFullAdminDiscovery.bind(this)
            this.startRecordingCommand = this.startRecordingCommand.bind(this)
            this.stopDiscovery = this.stopDiscovery.bind(this)
            this.stopRecordingCommand = this.stopRecordingCommand.bind(this)
            this.submitActionResult = this.submitActionResult.bind(this)
            this.submitDiscoveryResult = this.submitDiscoveryResult.bind(this)
            this.submitSnapshot = this.submitSnapshot.bind(this)
            this.submitSnapshotError = this.submitSnapshotError.bind(this)
            this.unregisterTab = this.unregisterTab.bind(this)
            this.updateActionStatus = this.updateActionStatus.bind(this)
            this.updateDiscoveryProgress = this.updateDiscoveryProgress.bind(this)
            this.updateScript = this.updateScript.bind(this)
        }

        /**
         * Approve pending step (step_approval mode)
         */
        public async approveStepCommand(executionId: string): Promise<ApproveStepResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/execution/${encodeURIComponent(executionId)}/approve`)
            return await resp.json() as ApproveStepResponse
        }

        /**
         * Cancel execution
         */
        public async cancelExecutionCommand(executionId: string): Promise<CancelUIExecutionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/execution/${encodeURIComponent(executionId)}/cancel`)
            return await resp.json() as CancelUIExecutionResponse
        }

        /**
         * Create a new script
         */
        public async createScript(params: CreateScriptRequest): Promise<CreateScriptResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/scripts`, JSON.stringify(params))
            return await resp.json() as CreateScriptResponse
        }

        /**
         * Delete a script
         */
        public async deleteScript(id: string): Promise<DeleteScriptResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/browser/scripts/${encodeURIComponent(id)}`)
            return await resp.json() as DeleteScriptResponse
        }

        /**
         * Diff two crawl runs
         */
        public async diffCrawlRunsEndpoint(params: {
    /**
     * Diff two crawl runs
     */
    runIdA: string

    /**
     * Diff two crawl runs
     */
    runIdB: string
}): Promise<CrawlDiff> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/crawl/diff`, JSON.stringify(params))
            return await resp.json() as CrawlDiff
        }

        /**
         * Discover a section by name — looks up URLs from the graph and starts an area probe
         */
        public async discoverSection(params: DiscoverSectionRequest): Promise<DiscoverSectionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/discover-section`, JSON.stringify(params))
            return await resp.json() as DiscoverSectionResponse
        }

        /**
         * Download a pre-configured extension ZIP with auto-pairing
         */
        public async downloadExtension(method: "GET", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/browser/extension/download`, body, options)
        }

        /**
         * Execute a binding action — generates steps, creates a plan, and starts execution
         */
        public async executeBindingAction(id: string, params: {
    actionName: string
    params: { [key: string]: string }
    tabId: number
}): Promise<{
    executionId: string
    planId: string
    status: string
    stepCount: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/bindings/${encodeURIComponent(id)}/execute`, JSON.stringify(params))
            return await resp.json() as {
    executionId: string
    planId: string
    status: string
    stepCount: number
}
        }

        /**
         * WebSocket endpoint for Chrome extension
         */
        public async extensionSocket(): Promise<StreamInOut<ExtensionMessage, BackendMessage>> {
            return await this.baseClient.createStreamInOut(`/browser/extension/ws`)
        }

        /**
         * Generate a PageBinding from a recording
         */
        public async generateBindingFromRecording(id: string): Promise<{
    bindingId: string
    section: string
    title: string
    code: string
    actionCount: number
    stepCount: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/recordings/${encodeURIComponent(id)}/generate-binding`)
            return await resp.json() as {
    bindingId: string
    section: string
    title: string
    code: string
    actionCount: number
    stepCount: number
}
        }

        /**
         * Get action status/result
         */
        public async getActionStatus(actionId: string): Promise<GetActionStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/action/${encodeURIComponent(actionId)}`)
            return await resp.json() as GetActionStatusResponse
        }

        /**
         * Get area probe session progress
         */
        public async getAreaProbeProgress(sessionId: string): Promise<AreaProbeProgressResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/area-probe/${encodeURIComponent(sessionId)}`)
            return await resp.json() as AreaProbeProgressResponse
        }

        /**
         * Get a specific crawl run
         */
        public async getCrawlRun(id: string): Promise<{
    /**
     * Get a specific crawl run
     */
    run: CrawlRun | null
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/crawl/runs/${encodeURIComponent(id)}`)
            return await resp.json() as {
    /**
     * Get a specific crawl run
     */
    run: CrawlRun | null
}
        }

        /**
         * Get screenshot bytes for a specific snapshot
         */
        public async getCrawlScreenshot(method: "GET", id: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/browser/crawl/snapshots/${encodeURIComponent(id)}/screenshot`, body, options)
        }

        /**
         * Get all snapshots for a crawl run
         */
        public async getCrawlSnapshots(id: string): Promise<{
    /**
     * Get all snapshots for a crawl run
     */
    snapshots: CrawlSnapshot[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/crawl/runs/${encodeURIComponent(id)}/snapshots`)
            return await resp.json() as {
    /**
     * Get all snapshots for a crawl run
     */
    snapshots: CrawlSnapshot[]
}
        }

        /**
         * Get deep probe session progress
         */
        public async getDeepProbeProgress(sessionId: string): Promise<DeepProbeProgressResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/deep-probe/${encodeURIComponent(sessionId)}`)
            return await resp.json() as DeepProbeProgressResponse
        }

        /**
         * Get discovery session progress
         */
        public async getDiscoveryProgress(sessionId: string): Promise<DiscoveryProgressResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/discovery/${encodeURIComponent(sessionId)}`)
            return await resp.json() as DiscoveryProgressResponse
        }

        /**
         * Get events since a timestamp (for frontend polling)
         */
        public async getEvents(params: {
    /**
     * Get events since a timestamp (for frontend polling)
     */
    since: number
}): Promise<EventsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                since: String(params.since),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/events`, undefined, {query})
            return await resp.json() as EventsResponse
        }

        /**
         * Get execution progress
         */
        public async getExecutionProgress(executionId: string): Promise<UIExecutionProgressResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/execution/${encodeURIComponent(executionId)}`)
            return await resp.json() as UIExecutionProgressResponse
        }

        /**
         * Get extension connection status (for frontend polling)
         */
        public async getExtensionStatus(): Promise<ExtensionStatus> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/extension/status`)
            return await resp.json() as ExtensionStatus
        }

        /**
         * Get full admin discovery progress
         */
        public async getFullDiscoveryProgress(sessionId: string): Promise<FullDiscoveryProgressResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/discovery/full/${encodeURIComponent(sessionId)}`)
            return await resp.json() as FullDiscoveryProgressResponse
        }

        /**
         * Get a specific binding by ID
         */
        public async getPageBinding(id: string): Promise<{
    id: string
    title: string
    section: string
    urls: string[]
    actions: {
        label: string
        outcome: string
        destinationUrl?: string
    }[]
    filters: {
        label: string
        type: string
        options?: string[]
    }[]
    tables: {
        columns: string[]
        rowActions: string[]
    }[]
    forms: { [key: string]: {
        heading: string
        fields: {
            name: string
            label: string
            type: string
            required: boolean
            options?: string[]
        }[]
    } }
    dependencies: {
        field: string
        entity: string
        required: boolean
        description: string
    }[]
    actionNames: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/bindings/${encodeURIComponent(id)}`)
            return await resp.json() as {
    id: string
    title: string
    section: string
    urls: string[]
    actions: {
        label: string
        outcome: string
        destinationUrl?: string
    }[]
    filters: {
        label: string
        type: string
        options?: string[]
    }[]
    tables: {
        columns: string[]
        rowActions: string[]
    }[]
    forms: { [key: string]: {
        heading: string
        fields: {
            name: string
            label: string
            type: string
            required: boolean
            options?: string[]
        }[]
    } }
    dependencies: {
        field: string
        entity: string
        required: boolean
        description: string
    }[]
    actionNames: string[]
}
        }

        /**
         * Get page history across crawl runs
         */
        public async getPageCrawlHistory(params: {
    /**
     * Get page history across crawl runs
     */
    url: string
}): Promise<{
    /**
     * Get page history across crawl runs
     */
    history: {
        id: string
        runId: string
        pageUrl: string
        urlPattern: string | null
        pageTitle: string | null
        heading: string | null
        pageType: string | null
        activeTab: string | null
        elementCount: number
        controlCount: number
        formCount: number
        crawledAt: string
        /**
         * Get page history across crawl runs
         */
        runStartedAt: string

        /**
         * Get page history across crawl runs
         */
        runStatus: string
    }[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                url: params.url,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/crawl/pages/history`, undefined, {query})
            return await resp.json() as {
    /**
     * Get page history across crawl runs
     */
    history: {
        id: string
        runId: string
        pageUrl: string
        urlPattern: string | null
        pageTitle: string | null
        heading: string | null
        pageType: string | null
        activeTab: string | null
        elementCount: number
        controlCount: number
        formCount: number
        crawledAt: string
        /**
         * Get page history across crawl runs
         */
        runStartedAt: string

        /**
         * Get page history across crawl runs
         */
        runStatus: string
    }[]
}
        }

        /**
         * Get a recording with full steps
         */
        public async getRecording(id: string): Promise<{
    recording: {
        id: string
        name: string
        description: string | null
        pageUrl: string | null
        stepCount: number
        createdAt: string
        updatedAt: string
        steps: any[]
    } | null
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/recordings/${encodeURIComponent(id)}`)
            return await resp.json() as {
    recording: {
        id: string
        name: string
        description: string | null
        pageUrl: string | null
        stepCount: number
        createdAt: string
        updatedAt: string
        steps: any[]
    } | null
}
        }

        /**
         * Get a script by ID
         */
        public async getScript(id: string): Promise<GetScriptResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/scripts/${encodeURIComponent(id)}`)
            return await resp.json() as GetScriptResponse
        }

        /**
         * Get site map for a domain
         */
        public async getSiteMap(domain: string): Promise<GetSiteMapResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/maps/${encodeURIComponent(domain)}`)
            return await resp.json() as GetSiteMapResponse
        }

        /**
         * Get snapshot result
         */
        public async getSnapshot(requestId: string): Promise<GetSnapshotResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/snapshot/${encodeURIComponent(requestId)}`)
            return await resp.json() as GetSnapshotResponse
        }

        /**
         * Get latest snapshot for a tab
         */
        public async getTabSnapshot(tabId: number): Promise<LatestSnapshotResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/tabs/${encodeURIComponent(tabId)}/snapshot`)
            return await resp.json() as LatestSnapshotResponse
        }

        /**
         * Get full capability tree for a specific page URL
         */
        public async getUIGraphPageDetail(params: UIGraphPageDetailRequest): Promise<UIGraphPageDetailResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                url: params.url,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/ui-graph/page`, undefined, {query})
            return await resp.json() as UIGraphPageDetailResponse
        }

        /**
         * Get all UIPage nodes from the capability graph
         */
        public async getUIGraphPages(): Promise<UIGraphPageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/ui-graph`)
            return await resp.json() as UIGraphPageResponse
        }

        /**
         * Health check for browser service
         */
        public async health(): Promise<HealthResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/health`)
            return await resp.json() as HealthResponse
        }

        /**
         * List crawl runs
         */
        public async listCrawlRuns(params: {
    /**
     * List crawl runs
     */
    runType?: string
}): Promise<{
    /**
     * List crawl runs
     */
    runs: CrawlRun[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                runType: params.runType,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/crawl/runs`, undefined, {query})
            return await resp.json() as {
    /**
     * List crawl runs
     */
    runs: CrawlRun[]
}
        }

        /**
         * List all registered page bindings
         */
        public async listPageBindings(): Promise<void> {
            await this.baseClient.callTypedAPI("GET", `/browser/bindings`)
        }

        /**
         * List pending actions for relay to poll
         */
        public async listPendingActions(): Promise<{
    /**
     * List pending actions for relay to poll
     */
    actions: ActionRequest[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/actions/pending`)
            return await resp.json() as {
    /**
     * List pending actions for relay to poll
     */
    actions: ActionRequest[]
}
        }

        /**
         * List all recordings
         */
        public async listRecordings(): Promise<{
    /**
     * List all recordings
     */
    recordings: RecordingResponse[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/recordings`)
            return await resp.json() as {
    /**
     * List all recordings
     */
    recordings: RecordingResponse[]
}
        }

        /**
         * List all scripts
         */
        public async listScripts(): Promise<ListScriptsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/scripts`)
            return await resp.json() as ListScriptsResponse
        }

        /**
         * List all discovered site maps
         */
        public async listSiteMaps(): Promise<ListSiteMapsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/maps`)
            return await resp.json() as ListSiteMapsResponse
        }

        /**
         * List attached tabs
         */
        public async listTabs(): Promise<ListTabsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/tabs`)
            return await resp.json() as ListTabsResponse
        }

        /**
         * Trigger admin URL matching between ui_graph and config_schema
         */
        public async matchAdminUrlsEndpoint(): Promise<void> {
            await this.baseClient.callTypedAPI("POST", `/browser/admin-url/match`)
        }

        /**
         * Open a new tab in the browser
         */
        public async openTabCommand(params: {
    /**
     * Open a new tab in the browser
     */
    url: string
}): Promise<{
    /**
     * Open a new tab in the browser
     */
    sent: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/command/open-tab`, JSON.stringify(params))
            return await resp.json() as {
    /**
     * Open a new tab in the browser
     */
    sent: boolean
}
        }

        /**
         * Get a pairing code for the browser extension (dev identity)
         */
        public async pair(): Promise<{
    code: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/pair`)
            return await resp.json() as {
    code: string
}
        }

        /**
         * Get a pairing code tied to the authenticated user
         */
        public async pairAuthenticated(): Promise<{
    code: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/pair`)
            return await resp.json() as {
    code: string
}
        }

        /**
         * Pause execution
         */
        public async pauseExecutionCommand(executionId: string): Promise<PauseUIExecutionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/execution/${encodeURIComponent(executionId)}/pause`)
            return await resp.json() as PauseUIExecutionResponse
        }

        /**
         * Generate a UI execution plan for a goal
         */
        public async planExecution(params: PlanUIExecutionRequest): Promise<PlanUIExecutionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/execution/plan`, JSON.stringify(params))
            return await resp.json() as PlanUIExecutionResponse
        }

        /**
         * Trigger re-discovery of all known pages
         */
        public async rediscoverUIGraph(): Promise<{
    /**
     * Trigger re-discovery of all known pages
     */
    triggered: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/ui-graph/rediscover`)
            return await resp.json() as {
    /**
     * Trigger re-discovery of all known pages
     */
    triggered: number
}
        }

        /**
         * Register an attached tab (legacy - tabs now register via WebSocket)
         */
        public async registerTab(params: RegisterTabRequest): Promise<RegisterTabResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/tabs/register`, JSON.stringify(params))
            return await resp.json() as RegisterTabResponse
        }

        /**
         * Reject pending step (step_approval mode — skips the step)
         */
        public async rejectStepCommand(executionId: string): Promise<RejectStepResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/execution/${encodeURIComponent(executionId)}/reject`)
            return await resp.json() as RejectStepResponse
        }

        /**
         * Re-run knowledge graph linking for all UIPage nodes
         */
        public async relinkUIGraph(): Promise<{
    /**
     * Re-run knowledge graph linking for all UIPage nodes
     */
    componentLinks: number

    /**
     * Re-run knowledge graph linking for all UIPage nodes
     */
    endpointLinks: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/ui-graph/relink`)
            return await resp.json() as {
    /**
     * Re-run knowledge graph linking for all UIPage nodes
     */
    componentLinks: number

    /**
     * Re-run knowledge graph linking for all UIPage nodes
     */
    endpointLinks: number
}
        }

        /**
         * Request an action to be executed (requires user approval)
         */
        public async requestAction(params: RequestActionRequest): Promise<RequestActionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/action/request`, JSON.stringify(params))
            return await resp.json() as RequestActionResponse
        }

        /**
         * Request an action to be executed
         */
        public async requestActionCommand(params: {
    /**
     * Request an action to be executed
     */
    tabId: number

    /**
     * Request an action to be executed
     */
    action: BrowserAction

    /**
     * Request an action to be executed
     */
    autoExecute?: boolean
}): Promise<{
    /**
     * Request an action to be executed
     */
    actionId: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/command/action`, JSON.stringify(params))
            return await resp.json() as {
    /**
     * Request an action to be executed
     */
    actionId: string
}
        }

        /**
         * Request a snapshot from an attached tab
         */
        public async requestSnapshot(params: {
    /**
     * Request a snapshot from an attached tab
     */
    tabId: number
}): Promise<RequestSnapshotResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/snapshot/request`, JSON.stringify(params))
            return await resp.json() as RequestSnapshotResponse
        }

        /**
         * Request a snapshot from the extension
         */
        public async requestSnapshotCommand(params: {
    /**
     * Request a snapshot from the extension
     */
    tabId: number
}): Promise<{
    /**
     * Request a snapshot from the extension
     */
    requestId: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/command/snapshot`, JSON.stringify(params))
            return await resp.json() as {
    /**
     * Request a snapshot from the extension
     */
    requestId: string
}
        }

        /**
         * Resume execution (optionally with selectedRef for disambiguation)
         */
        public async resumeExecutionCommand(executionId: string, params: ResumeUIExecutionRequest): Promise<ResumeUIExecutionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/execution/${encodeURIComponent(executionId)}/resume`, JSON.stringify(params))
            return await resp.json() as ResumeUIExecutionResponse
        }

        /**
         * Revert a completed step
         */
        public async revertStepCommand(executionId: string, stepIndex: number): Promise<RevertStepResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/execution/${encodeURIComponent(executionId)}/revert/${encodeURIComponent(stepIndex)}`)
            return await resp.json() as RevertStepResponse
        }

        /**
         * Save a browser recording
         */
        public async saveRecording(params: {
    name: string
    description?: string
    pageUrl?: string
    steps: any[]
    screenshots?: {
        stepIndex: number
        dataUrl: string
    }[]
}): Promise<RecordingResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/recordings`, JSON.stringify(params))
            return await resp.json() as RecordingResponse
        }

        /**
         * Search for controls across all site maps
         */
        public async searchControls(params: {
    /**
     * Search for controls across all site maps
     */
    q: string

    /**
     * Search for controls across all site maps
     */
    domain?: string
}): Promise<SearchControlsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                domain: params.domain,
                q:      params.q,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/browser/search`, undefined, {query})
            return await resp.json() as SearchControlsResponse
        }

        /**
         * Skip current step
         */
        public async skipStepCommand(executionId: string): Promise<SkipStepResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/execution/${encodeURIComponent(executionId)}/skip`)
            return await resp.json() as SkipStepResponse
        }

        /**
         * Start a versioned admin UI crawl
         */
        public async startAdminCrawlEndpoint(params: {
    /**
     * Start a versioned admin UI crawl
     */
    tabId: number
}): Promise<{
    /**
     * Start a versioned admin UI crawl
     */
    runId: string

    /**
     * Start a versioned admin UI crawl
     */
    sessionId: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/crawl/admin`, JSON.stringify(params))
            return await resp.json() as {
    /**
     * Start a versioned admin UI crawl
     */
    runId: string

    /**
     * Start a versioned admin UI crawl
     */
    sessionId: string
}
        }

        /**
         * Start agent with a goal
         */
        public async startAgentCommand(params: {
    /**
     * Start agent with a goal
     */
    tabId: number

    /**
     * Start agent with a goal
     */
    goal: string
}): Promise<{
    /**
     * Start agent with a goal
     */
    sent: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/command/start-agent`, JSON.stringify(params))
            return await resp.json() as {
    /**
     * Start agent with a goal
     */
    sent: boolean
}
        }

        /**
         * Start an area probe — deep discovery of forms, actions, and state for target pages
         */
        public async startAreaProbe(params: StartAreaProbeRequest): Promise<StartAreaProbeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/area-probe/start`, JSON.stringify(params))
            return await resp.json() as StartAreaProbeResponse
        }

        /**
         * Start a deep probe on a tab to discover expandable content
         */
        public async startDeepProbe(params: StartDeepProbeRequest): Promise<StartDeepProbeResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/deep-probe/start`, JSON.stringify(params))
            return await resp.json() as StartDeepProbeResponse
        }

        /**
         * Start a discovery session to crawl a site
         */
        public async startDiscovery(params: StartDiscoveryRequest): Promise<StartDiscoveryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/discovery/start`, JSON.stringify(params))
            return await resp.json() as StartDiscoveryResponse
        }

        /**
         * Start executing a plan
         */
        public async startExecutionCommand(params: StartUIExecutionRequest): Promise<StartUIExecutionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/execution/start`, JSON.stringify(params))
            return await resp.json() as StartUIExecutionResponse
        }

        /**
         * Start a full admin discovery — expands sidebar, visits all pages, captures snapshots into UI graph
         */
        public async startFullAdminDiscovery(params: StartFullDiscoveryRequest): Promise<StartFullDiscoveryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/discovery/full`, JSON.stringify(params))
            return await resp.json() as StartFullDiscoveryResponse
        }

        /**
         * Start browser-side recording
         */
        public async startRecordingCommand(): Promise<{
    /**
     * Start browser-side recording
     */
    sent: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/command/start-recording`)
            return await resp.json() as {
    /**
     * Start browser-side recording
     */
    sent: boolean
}
        }

        /**
         * Stop a discovery session
         */
        public async stopDiscovery(sessionId: string): Promise<StopDiscoveryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/discovery/${encodeURIComponent(sessionId)}/stop`)
            return await resp.json() as StopDiscoveryResponse
        }

        /**
         * Stop browser-side recording
         */
        public async stopRecordingCommand(): Promise<{
    /**
     * Stop browser-side recording
     */
    sent: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/command/stop-recording`)
            return await resp.json() as {
    /**
     * Stop browser-side recording
     */
    sent: boolean
}
        }

        /**
         * Submit action result from relay
         */
        public async submitActionResult(params: SubmitActionResultRequest): Promise<SubmitActionResultResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/action/result`, JSON.stringify(params))
            return await resp.json() as SubmitActionResultResponse
        }

        /**
         * Submit discovery results (called by relay when complete)
         */
        public async submitDiscoveryResult(sessionId: string, params: SubmitDiscoveryResultRequest): Promise<SubmitDiscoveryResultResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/discovery/${encodeURIComponent(sessionId)}/result`, JSON.stringify(params))
            return await resp.json() as SubmitDiscoveryResultResponse
        }

        /**
         * Submit snapshot from relay
         */
        public async submitSnapshot(params: SubmitSnapshotRequest): Promise<SubmitSnapshotResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/snapshot/submit`, JSON.stringify(params))
            return await resp.json() as SubmitSnapshotResponse
        }

        /**
         * Report snapshot error from relay
         */
        public async submitSnapshotError(params: {
    requestId: string
    error: string
}): Promise<{
    received: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/snapshot/error`, JSON.stringify(params))
            return await resp.json() as {
    received: boolean
}
        }

        /**
         * Unregister a detached tab (legacy - tabs now unregister via WebSocket)
         */
        public async unregisterTab(tabId: number): Promise<UnregisterTabResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/tabs/${encodeURIComponent(tabId)}/unregister`)
            return await resp.json() as UnregisterTabResponse
        }

        /**
         * Update action status (approved/rejected by user via relay)
         */
        public async updateActionStatus(actionId: string, params: {
    status: ActionStatus
}): Promise<{
    updated: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/action/${encodeURIComponent(actionId)}/status`, JSON.stringify(params))
            return await resp.json() as {
    updated: boolean
}
        }

        /**
         * Update discovery progress (called by relay)
         */
        public async updateDiscoveryProgress(sessionId: string, params: {
    pagesVisited: number
    pagesQueued: number
    linksFound: number
    currentUrl: string
}): Promise<{
    updated: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/browser/discovery/${encodeURIComponent(sessionId)}/progress`, JSON.stringify(params))
            return await resp.json() as {
    updated: boolean
}
        }

        /**
         * Update a script
         */
        public async updateScript(id: string, params: UpdateScriptRequest): Promise<UpdateScriptResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/browser/scripts/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as UpdateScriptResponse
        }
    }
}

export namespace chat {
    export interface ChatInput {
        type: "message" | "cancel" | "feedback"
        message?: string
        rating?: "up" | "down"
    }

    export interface ChatStreamRequest {
        conversationId: string
        message: string
        /**
         * JSON-encoded page context: { url?: string, heading?: string }
         */
        pageContext?: string
    }

    export interface Citation {
        url: string
        title: string
        snippet?: string
        confidence: number
        sourceType: "kb_article" | "api_docs" | "release_note" | "product_page" | "pricing_page"
        extractedAt?: string
    }

    export interface Clarification {
        question: string
        options: ClarificationOption[]
        reason: "close_scores" | "low_confidence" | "multiple_products"
    }

    export interface ClarificationOption {
        label: string
        product: string
        description: string
    }

    export interface ComplexityBreakdownEntry {
        tier: string
        count: number
        avgPrecisionAtK: number
        avgNdcgAtK: number
        avgConfidenceScore: number
        retrievalGapRate: number
        passRate: number
    }

    export type ComplexityTier = "single_source" | "multi_source" | "account_grounded" | "temporal" | "comparison"

    export interface Conversation {
        id: string
        tenantId: string
        userId: string
        title?: string
        createdAt: string
        updatedAt: string
        messageCount?: number
        lastMessage?: string
    }

    export interface CreateConversationRequest {
        title?: string
    }

    export interface CreateConversationResponse {
        id: string
        conversation: Conversation
    }

    export interface DeleteConversationResponse {
        success: boolean
    }

    export interface FitnessComparison {
        runA: FitnessHistoryEntry
        runB: FitnessHistoryEntry
        deltaScore: number
        deltaPassed: number
        improvements: string[]
        regressions: string[]
    }

    export interface FitnessHistoryEntry {
        runId: string
        runAt: string
        totalTests: number
        passed: number
        failed: number
        avgScore: number
    }

    export interface FitnessRunResult {
        runId: string
        startedAt: string
        completedAt: string
        durationMs: number
        totalTests: number
        passed: number
        failed: number
        errored: number
        avgScore: number
        results: FitnessTestResult[]
    }

    export interface FitnessTestCase {
        id: string
        query: string
        persona: JudgePersona
        category: string
        description: string
        tags: string[]
    }

    export interface FitnessTestResult {
        testCaseId: string
        evaluationId: string
        query: string
        score: number
        passed: boolean
        breakdown: {
            grounding: number
            conflicts: number
            helpfulness: number
            actionability: number
        }
        error?: string
        searchJudge?: {
            precisionAtK: number
            recallAtK: number
            ndcgAtK: number
            mrr: number
            missedDocCount: number
            groundTruthSize: number
        }
        ablation?: {
            withKB: JudgeBreakdown
            withoutKB: JudgeBreakdown
            kbContribution: number
        }
    }

    export interface GetConversationResponse {
        conversation: Conversation
        messages: Message[]
    }

    export interface InteractiveMode {
        /**
         * Type of interaction
         */
        type: "choice" | "confirm" | "input"

        /**
         * Prompt text shown above options
         */
        prompt?: string

        /**
         * Available options (for choice type)
         */
        options?: InteractiveOption[]

        /**
         * Whether multiple selections are allowed
         */
        multiSelect?: boolean

        /**
         * Grounding confidence for plan approval
         */
        confidence?: {
            score: number
            level: "high" | "medium" | "low"
            rationale: string
            unsupportedActions?: string[]
        }

        /**
         * Planned API actions for user review before approval
         */
        plannedActions?: {
            order: number
            method: string
            path: string
            params: { [key: string]: any }
            description?: string
        }[]
    }

    export interface InteractiveOption {
        id: string
        label: string
        description?: string
        /**
         * Value to send back when selected
         */
        value: string

        /**
         * Optional icon hint for frontend
         */
        icon?: "plan" | "quick" | "manual" | "product" | "confirm" | "cancel" | "element"
    }

    export interface JudgeBreakdown {
        grounding: number
        conflicts: number
        helpfulness: number
        actionability: number
        specificity: number
    }

    export type JudgePersona = "contact_center_admin" | "it_administrator" | "personal_user" | "developer" | "general"

    export interface ListConversationsRequest {
        limit?: number
        offset?: number
    }

    export interface ListConversationsResponse {
        items: Conversation[]
        total: number
        hasMore: boolean
    }

    export interface Message {
        id: string
        conversationId: string
        role: MessageRole
        content: string
        artifacts?: shared.Artifact[]
        citations?: Citation[]
        createdAt: string
    }

    export type MessageRole = "user" | "assistant" | "system"

    export interface ProfileProgress {
        phase: "profiling"
        steps: ProfileStep[]
    }

    export interface ProfileStep {
        label: string
        status: "pending" | "in_progress" | "complete" | "error"
        detail?: string
    }

    export interface QuestionEvaluation {
        id: string
        conversationId?: string
        messageId?: string
        question: string
        timestamp: string
        citations: Citation[]
        retrievedEntities: string[]
        response: string
        persona: JudgePersona
        confidenceScore: number
        confidenceRationale?: string
        conflictsDetected: boolean
        unsupportedClaims: string[]
        judgeFeedback?: string
        judgeBreakdown?: JudgeBreakdown
        userFeedback?: "helpful" | "not_helpful"
        userFlags?: string[]
        adminRating?: "agree" | "disagree"
        adminNotes?: string
        isGolden: boolean
        createdAt: string
        /**
         * Retrieval metrics
         */
        retrievalMetrics?: RetrievalMetrics

        retrievalResults?: RetrievalResult[]
        complexityTier?: ComplexityTier
        specificityScore?: number
        statementEvaluations?: StatementEvaluation[]
        requestId?: string
        retrievalMode?: string
        precisionAtK?: number
        recallAtK?: number
        ndcgAtK?: number
        mrr?: number
        hitRate?: number
        contextPrecision?: number
        retrievalGap?: boolean
        agentType?: string
    }

    export interface RetrievalMetrics {
        /**
         * --- Search diagnostics (captured at search time) ---
         */
        query: string

        k: number
        candidateCount: number
        preRerankScores: number[]
        postRerankScores: number[]
        rerankDelta: number
        sourceTypes: { [key: string]: number }
        uniqueProducts: string[]
        topScore: number
        meanScore: number
        searchLatencyMs: number
        rerankLatencyMs: number
        rawResults: RetrievalResult[]
        /**
         * --- IR quality metrics (computed by judge) ---
         */
        precisionAtK: number

        recallAtK: number
        ndcgAtK: number
        mrr: number
        hitRate: number
        contextPrecision: number
        retrievalGap: boolean
    }

    export interface RetrievalResult {
        url: string
        title: string
        snippet: string
        vectorSimilarity: number
        rerankScore: number
        judgeRelevance: number
        usedInAnswer: boolean
        sourceType: string
        product?: string
        rank: number
    }

    export interface RetrievalStatsResponse {
        avgPrecisionAtK: number
        avgRecallAtK: number
        avgNdcgAtK: number
        avgMrr: number
        hitRatePercent: number
        avgContextPrecision: number
        retrievalGapPercent: number
        totalEvaluated: number
    }

    export interface SendMessageRequest {
        content: string
    }

    export interface SendMessageResponse {
        id: string
        message: Message
        /**
         * Present when the query is ambiguous and needs clarification
         */
        clarification?: Clarification

        /**
         * Present when the response offers interactive choices
         */
        interactive?: InteractiveMode
    }

    export interface StatementEvaluation {
        statement: string
        supported: boolean
        sourceUrl?: string
        confidence: number
    }

    export interface StreamMessage {
        type: StreamMessageType
        /**
         * Interactive options (for 'interactive' type)
         */
        interactive?: InteractiveMode

        /**
         * Profile progress (for 'progress' type)
         */
        progress?: ProfileProgress

        content?: string
        artifact?: shared.Artifact
        error?: string
        citations?: Citation[]
        /**
         * Evaluation data (sent with 'done' message)
         */
        evaluationId?: string

        confidenceScore?: number
        confidenceRationale?: string
    }

    export type StreamMessageType = "token" | "artifact" | "done" | "error" | "thinking" | "interactive" | "progress"

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.bidirectionalChat = this.bidirectionalChat.bind(this)
            this.cleanupLegacyFeatures = this.cleanupLegacyFeatures.bind(this)
            this.createConv = this.createConv.bind(this)
            this.deleteConv = this.deleteConv.bind(this)
            this.fitnessCompare = this.fitnessCompare.bind(this)
            this.fitnessHistory = this.fitnessHistory.bind(this)
            this.fitnessRun = this.fitnessRun.bind(this)
            this.fitnessRunDetail = this.fitnessRunDetail.bind(this)
            this.fitnessTests = this.fitnessTests.bind(this)
            this.getComplexityBreakdown = this.getComplexityBreakdown.bind(this)
            this.getConv = this.getConv.bind(this)
            this.getEval = this.getEval.bind(this)
            this.getEvalStats = this.getEvalStats.bind(this)
            this.getRetrievalStats = this.getRetrievalStats.bind(this)
            this.getReviewQueueEndpoint = this.getReviewQueueEndpoint.bind(this)
            this.listConvs = this.listConvs.bind(this)
            this.listEvals = this.listEvals.bind(this)
            this.planQuery = this.planQuery.bind(this)
            this.reEvaluate = this.reEvaluate.bind(this)
            this.regenerateEmbeddings = this.regenerateEmbeddings.bind(this)
            this.runClarificationExperiment = this.runClarificationExperiment.bind(this)
            this.runComplexityDetector = this.runComplexityDetector.bind(this)
            this.runExperimentBenchmark = this.runExperimentBenchmark.bind(this)
            this.runIntentExperiment = this.runIntentExperiment.bind(this)
            this.runKBReview = this.runKBReview.bind(this)
            this.runMultiStepExperiment = this.runMultiStepExperiment.bind(this)
            this.runPlanner = this.runPlanner.bind(this)
            this.runProductRouting = this.runProductRouting.bind(this)
            this.sendMessage = this.sendMessage.bind(this)
            this.streamChat = this.streamChat.bind(this)
            this.submitAdminReview = this.submitAdminReview.bind(this)
            this.submitUserFeedback = this.submitUserFeedback.bind(this)
            this.testIntent = this.testIntent.bind(this)
        }

        /**
         * Bidirectional chat stream for complex interactions
         */
        public async bidirectionalChat(): Promise<StreamInOut<ChatInput, StreamMessage>> {
            return await this.baseClient.createStreamInOut(`/chat/bidirectional`)
        }

        /**
         * Delete legacy Feature nodes (not ReleaseFeature)
         */
        public async cleanupLegacyFeatures(): Promise<{
    deleted: number
    remaining: {
        Feature: number
        ReleaseFeature: number
    }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/experiments/kb-review/cleanup-features`)
            return await resp.json() as {
    deleted: number
    remaining: {
        Feature: number
        ReleaseFeature: number
    }
}
        }

        /**
         * Create a new conversation
         */
        public async createConv(params: CreateConversationRequest): Promise<CreateConversationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/conversations`, JSON.stringify(params))
            return await resp.json() as CreateConversationResponse
        }

        /**
         * Delete a conversation
         */
        public async deleteConv(id: string): Promise<DeleteConversationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/chat/conversations/${encodeURIComponent(id)}`)
            return await resp.json() as DeleteConversationResponse
        }

        /**
         * Compare two fitness runs
         */
        public async fitnessCompare(params: {
    runIdA: string
    runIdB: string
}): Promise<FitnessComparison> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                runIdA: params.runIdA,
                runIdB: params.runIdB,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/fitness/compare`, undefined, {query})
            return await resp.json() as FitnessComparison
        }

        /**
         * Get fitness run history
         */
        public async fitnessHistory(params: {
    limit?: number
}): Promise<{
    runs: FitnessHistoryEntry[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/fitness/history`, undefined, {query})
            return await resp.json() as {
    runs: FitnessHistoryEntry[]
}
        }

        /**
         * Run a fitness benchmark
         */
        public async fitnessRun(params: {
    category?: string
    maxTests?: number
    ablation?: boolean
}): Promise<FitnessRunResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/fitness/run`, JSON.stringify(params))
            return await resp.json() as FitnessRunResult
        }

        /**
         * Get details of a specific fitness run
         */
        public async fitnessRunDetail(runId: string): Promise<FitnessRunResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/fitness/run/${encodeURIComponent(runId)}`)
            return await resp.json() as FitnessRunResult
        }

        /**
         * List available fitness test cases
         */
        public async fitnessTests(): Promise<{
    tests: FitnessTestCase[]
    total: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/fitness/tests`)
            return await resp.json() as {
    tests: FitnessTestCase[]
    total: number
}
        }

        /**
         * Per-complexity-tier breakdown of metrics
         */
        public async getComplexityBreakdown(): Promise<{
    tiers: ComplexityBreakdownEntry[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/evaluations/complexity-breakdown`)
            return await resp.json() as {
    tiers: ComplexityBreakdownEntry[]
}
        }

        /**
         * Get a conversation with messages
         */
        public async getConv(id: string): Promise<GetConversationResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/conversations/${encodeURIComponent(id)}`)
            return await resp.json() as GetConversationResponse
        }

        /**
         * Get single evaluation
         */
        public async getEval(id: string): Promise<{
    /**
     * Get single evaluation
     */
    evaluation: QuestionEvaluation | null
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/evaluations/${encodeURIComponent(id)}`)
            return await resp.json() as {
    /**
     * Get single evaluation
     */
    evaluation: QuestionEvaluation | null
}
        }

        /**
         * Get evaluation statistics
         */
        public async getEvalStats(): Promise<{
    byPersona: { [key: string]: {
        count: number
        avgConfidence: number
        liveCount: number
    } }
    total: number
    avgConfidence: number
    reviewQueueSize: number
    goldenCount: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/evaluations/stats`)
            return await resp.json() as {
    byPersona: { [key: string]: {
        count: number
        avgConfidence: number
        liveCount: number
    } }
    total: number
    avgConfidence: number
    reviewQueueSize: number
    goldenCount: number
}
        }

        /**
         * Aggregate retrieval metrics across all evaluations
         */
        public async getRetrievalStats(): Promise<RetrievalStatsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/evaluations/retrieval-stats`)
            return await resp.json() as RetrievalStatsResponse
        }

        /**
         * Get review queue (low-confidence + user-flagged)
         */
        public async getReviewQueueEndpoint(params: {
    limit?: number
}): Promise<{
    evaluations: QuestionEvaluation[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/evaluations/review-queue`, undefined, {query})
            return await resp.json() as {
    evaluations: QuestionEvaluation[]
}
        }

        /**
         * List conversations
         */
        public async listConvs(params: ListConversationsRequest): Promise<ListConversationsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/conversations`, undefined, {query})
            return await resp.json() as ListConversationsResponse
        }

        /**
         * List evaluations with filters
         */
        public async listEvals(params: {
    conversationId?: string
    persona?: JudgePersona
    minConfidence?: number
    maxConfidence?: number
    isGolden?: boolean
    hasUserFeedback?: boolean
    needsReview?: boolean
    limit?: number
    offset?: number
}): Promise<{
    evaluations: QuestionEvaluation[]
    total: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                conversationId:  params.conversationId,
                hasUserFeedback: params.hasUserFeedback === undefined ? undefined : String(params.hasUserFeedback),
                isGolden:        params.isGolden === undefined ? undefined : String(params.isGolden),
                limit:           params.limit === undefined ? undefined : String(params.limit),
                maxConfidence:   params.maxConfidence === undefined ? undefined : String(params.maxConfidence),
                minConfidence:   params.minConfidence === undefined ? undefined : String(params.minConfidence),
                needsReview:     params.needsReview === undefined ? undefined : String(params.needsReview),
                offset:          params.offset === undefined ? undefined : String(params.offset),
                persona:         params.persona === undefined ? undefined : String(params.persona),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/evaluations`, undefined, {query})
            return await resp.json() as {
    evaluations: QuestionEvaluation[]
    total: number
}
        }

        public async planQuery(params: {
    query: string
}): Promise<{
    query: string
    plan: experiments.MultiStepPlan
    latencyMs: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/experiments/plan`, JSON.stringify(params))
            return await resp.json() as {
    query: string
    plan: experiments.MultiStepPlan
    latencyMs: number
}
        }

        /**
         * Re-evaluate with different persona
         */
        public async reEvaluate(id: string, params: {
    persona?: JudgePersona
}): Promise<{
    evaluation: QuestionEvaluation | null
    newScore: number
    previousScore: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/evaluations/${encodeURIComponent(id)}/evaluate`, JSON.stringify(params))
            return await resp.json() as {
    evaluation: QuestionEvaluation | null
    newScore: number
    previousScore: number
}
        }

        /**
         * Regenerate embeddings for all documents and release features
         */
        public async regenerateEmbeddings(params: {
    batchSize?: number
    nodeType?: "Document" | "ReleaseFeature" | "all"
}): Promise<{
    documentsProcessed: number
    featuresProcessed: number
    errors: number
    duration: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/experiments/kb-review/regenerate-embeddings`, JSON.stringify(params))
            return await resp.json() as {
    documentsProcessed: number
    featuresProcessed: number
    errors: number
    duration: number
}
        }

        public async runClarificationExperiment(): Promise<experiments.ClarificationExperimentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/experiments/clarification`)
            return await resp.json() as experiments.ClarificationExperimentResponse
        }

        public async runComplexityDetector(): Promise<experiments.DetectorResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/experiments/complexity-detector`)
            return await resp.json() as experiments.DetectorResponse
        }

        public async runExperimentBenchmark(): Promise<experiments.BenchmarkResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/experiments/benchmark`)
            return await resp.json() as experiments.BenchmarkResponse
        }

        public async runIntentExperiment(params: experiments.ExperimentRequest): Promise<experiments.IntentExperimentResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                id:       params.id,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/experiments/intent-vs-native`, undefined, {query})
            return await resp.json() as experiments.IntentExperimentResponse
        }

        public async runKBReview(): Promise<experiments.KBReviewReport> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/experiments/kb-review`)
            return await resp.json() as experiments.KBReviewReport
        }

        public async runMultiStepExperiment(): Promise<experiments.MultiStepExperimentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/experiments/multi-step`)
            return await resp.json() as experiments.MultiStepExperimentResponse
        }

        public async runPlanner(): Promise<experiments.PlannerResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/experiments/planner`)
            return await resp.json() as experiments.PlannerResponse
        }

        public async runProductRouting(params: {
    category?: string
}): Promise<experiments.ProductRoutingExperimentResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/chat/experiments/product-routing`, undefined, {query})
            return await resp.json() as experiments.ProductRoutingExperimentResponse
        }

        /**
         * Send a message and get a response (non-streaming)
         */
        public async sendMessage(conversationId: string, params: SendMessageRequest): Promise<SendMessageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/conversations/${encodeURIComponent(conversationId)}/messages`, JSON.stringify(params))
            return await resp.json() as SendMessageResponse
        }

        /**
         * Stream chat responses via WebSocket
         */
        public async streamChat(params: ChatStreamRequest): Promise<StreamIn<StreamMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                conversationId: params.conversationId,
                message:        params.message,
                pageContext:    params.pageContext,
            })

            return await this.baseClient.createStreamIn(`/chat/stream`, {query})
        }

        /**
         * Record admin review
         */
        public async submitAdminReview(id: string, params: {
    rating: "agree" | "disagree"
    notes?: string
    isGolden?: boolean
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/evaluations/${encodeURIComponent(id)}/review`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Record user feedback (thumbs up/down)
         */
        public async submitUserFeedback(id: string, params: {
    feedback: "helpful" | "not_helpful"
    flags?: string[]
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/evaluations/${encodeURIComponent(id)}/feedback`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        public async testIntent(params: {
    intent: string
}): Promise<{
    intent: string
    embeddings: experiments.ApproachResult
    "llm_routing": experiments.ApproachResult
    structured: experiments.ApproachResult
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/chat/experiments/test`, JSON.stringify(params))
            return await resp.json() as {
    intent: string
    embeddings: experiments.ApproachResult
    "llm_routing": experiments.ApproachResult
    structured: experiments.ApproachResult
}
        }
    }
}

export namespace config {
    export interface AuditLogEntry {
        accountId: string
        userId?: string
        action: string
        resourceType: string
        resourceId?: string
        resourceName?: string
        details?: { [key: string]: any }
    }

    export interface AuditLogEntry {
        accountId: string
        userId?: string
        action: string
        resourceType: string
        resourceId?: string
        resourceName?: string
        details?: { [key: string]: any }
    }

    export interface CreatePlanRequest {
        accountId: string
        intents: shared.ConfigurationIntent[]
        tasks: shared.ConfigurationTask[]
        executionOrder: string[]
        estimatedApiCalls: number
        warnings?: string[]
        blockers?: string[]
    }

    export interface DependencyPath {
        nodes: ResourceNode[]
        relationships: string[]
    }

    export interface GetPlanResponse {
        plan: {
            id: string
            intents: shared.ConfigurationIntent[]
            tasks: shared.ConfigurationTask[]
            executionOrder: string[]
            estimatedApiCalls: number
            warnings: string[]
            blockers: string[]
            status: string
            createdAt: string
        }
    }

    export interface ListPlansRequest {
        accountId: string
        status?: string
        limit?: number
        offset?: number
    }

    export interface ListPlansResponse {
        plans: {
            id: string
            status: string
            taskCount: number
            createdAt: string
        }[]
        total: number
    }

    export interface PlanResponse {
        id: string
        status: string
        createdAt: string
    }

    export interface ResourceNode {
        type: string
        resourceId: string
        name: string
        properties: { [key: string]: any }
    }

    export interface SaveExecutionResultRequest {
        planId: string
        result: {
            executionId: string
            status: shared.ExecutionStatus
            startedAt: string
            completedAt: string
            completedTasks: shared.CompletedTask[]
            failedTask?: shared.FailedTask
            createdResources: shared.CreatedResource[]
            dryRun: boolean
        }
    }

    export interface SaveVerificationResultRequest {
        planId: string
        executionId: string
        result: {
            timestamp: string
            mode: shared.VerificationMode
            layers: {
                readBack: shared.ReadBackVerification[]
                stateDiff?: shared.StateDiff
                webhooks: shared.WebhookConfirmation[]
                synthetic: shared.SyntheticTest[]
            }
            overallStatus: shared.VerificationOverallStatus
            summary: {
                totalChecks: number
                passed: number
                failed: number
                warnings: number
                skipped: number
            }
            issues: shared.VerificationIssue[]
        }
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.createAuditLog = this.createAuditLog.bind(this)
            this.createPlan = this.createPlan.bind(this)
            this.getPlan = this.getPlan.bind(this)
            this.listAuditLog = this.listAuditLog.bind(this)
            this.listPlans = this.listPlans.bind(this)
            this.saveExecutionResult = this.saveExecutionResult.bind(this)
            this.saveVerificationResult = this.saveVerificationResult.bind(this)
            this.updatePlanStatus = this.updatePlanStatus.bind(this)
        }

        /**
         * Create audit log entry
         */
        public async createAuditLog(params: AuditLogEntry): Promise<{
    id: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/audit`, JSON.stringify(params))
            return await resp.json() as {
    id: string
}
        }

        /**
         * Create a new execution plan
         */
        public async createPlan(params: CreatePlanRequest): Promise<PlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plans`, JSON.stringify(params))
            return await resp.json() as PlanResponse
        }

        /**
         * Get an execution plan by ID
         */
        public async getPlan(id: string): Promise<GetPlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans/${encodeURIComponent(id)}`)
            return await resp.json() as GetPlanResponse
        }

        /**
         * List audit log entries
         */
        public async listAuditLog(params: {
    accountId: string
    limit?: number
    offset?: number
}): Promise<{
    entries: AuditLogEntry[]
    total: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
                limit:     params.limit === undefined ? undefined : String(params.limit),
                offset:    params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/audit`, undefined, {query})
            return await resp.json() as {
    entries: AuditLogEntry[]
    total: number
}
        }

        /**
         * List execution plans for an account
         */
        public async listPlans(params: ListPlansRequest): Promise<ListPlansResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
                limit:     params.limit === undefined ? undefined : String(params.limit),
                offset:    params.offset === undefined ? undefined : String(params.offset),
                status:    params.status,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/plans`, undefined, {query})
            return await resp.json() as ListPlansResponse
        }

        /**
         * Save execution result
         */
        public async saveExecutionResult(params: SaveExecutionResultRequest): Promise<{
    id: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/executions`, JSON.stringify(params))
            return await resp.json() as {
    id: string
}
        }

        /**
         * Save verification result
         */
        public async saveVerificationResult(params: SaveVerificationResultRequest): Promise<{
    id: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/verifications`, JSON.stringify(params))
            return await resp.json() as {
    id: string
}
        }

        /**
         * Update plan status
         */
        public async updatePlanStatus(id: string, params: {
    status: string
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/plans/${encodeURIComponent(id)}/status`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }
    }
}

export namespace connection {
    export interface AllOAuthSettingsResponse {
        settings: OAuthAppSettings[]
    }

    export type AuthType = "s2s" | "oauth"

    export interface ConnectRequest {
        accountId: string
        clientId: string
        clientSecret: string
        name?: string
    }

    export interface ConnectResponse {
        success: boolean
        connection?: StoredConnection
        error?: string
    }

    export interface ConnectionCapabilities {
        canRead: boolean
        canWrite: boolean
        readCredentialId?: string
        writeCredentialId?: string
    }

    export interface ConnectionStatusResponse {
        connected: boolean
        connection?: StoredConnection
    }

    export type CredentialPurpose = "general" | "reader" | "writer"

    export interface DisconnectResponse {
        success: boolean
    }

    export interface EnrichedAccount {
        /**
         * From stored connection
         */
        id: string

        accountId: string
        accountName: string
        authType: AuthType
        scopes: string[]
        connectedAt: string
        lastUsedAt?: string
        /**
         * From Zoom /users/me
         */
        email?: string

        displayName?: string
        picUrl?: string
        userType?: number
        userTypeName?: string
        roleName?: string
        planUnitedType?: string
        timezone?: string
        company?: string
        /**
         * Status
         */
        enrichmentStatus: "ok" | "token_expired" | "error"

        enrichmentError?: string
    }

    export interface GetZoomConnectUrlRequest {
        /**
         * Where to redirect after OAuth completes (e.g. "/settings"). Defaults to "/chat".
         */
        returnTo?: string

        /**
         * Which OAuth app to use: 'reader' (default) or 'writer'.
         */
        purpose?: string
    }

    export interface ListConnectionsResponse {
        connections: StoredConnection[]
    }

    export interface ListEnrichedAccountsResponse {
        accounts: EnrichedAccount[]
    }

    export interface OAuthAppSettings {
        id: string
        tenantId: string
        clientId: string
        redirectUri: string
        appPurpose: CredentialPurpose
        createdAt: string
        updatedAt: string
    }

    export interface OAuthSettingsRequest {
        clientId: string
        clientSecret: string
        redirectUri: string
        purpose?: CredentialPurpose
    }

    export interface OAuthSettingsResponse {
        settings: OAuthAppSettings | null
    }

    export interface SaveOAuthSettingsResponse {
        success: boolean
        settings?: OAuthAppSettings
        error?: string
    }

    export interface SaveWebhookSettingsResponse {
        success: boolean
        settings?: WebhookSettings
        error?: string
    }

    export interface StoredConnection {
        id: string
        tenantId: string
        accountId: string
        accountName: string
        scopes: string[]
        authType: AuthType
        credentialPurpose: CredentialPurpose
        connectedAt: string
        lastUsedAt?: string
    }

    export interface TestConnectionRequest {
        accountId: string
        clientId: string
        clientSecret: string
    }

    export interface TestConnectionResponse {
        success: boolean
        accountName?: string
        scopes?: string[]
        error?: string
    }

    export interface WebhookEvent {
        id: string
        tenantId: string
        eventType: string
        eventTs: string
        accountId?: string
        payload: { [key: string]: any }
        processed: boolean
        processedAt?: string
        error?: string
        createdAt: string
    }

    export interface WebhookEventsResponse {
        events: WebhookEvent[]
    }

    export interface WebhookSettings {
        id: string
        tenantId: string
        webhookUrl: string
        verificationToken: string
        hasSecretToken: boolean
        enabled: boolean
        createdAt: string
        updatedAt: string
    }

    export interface WebhookSettingsRequest {
        webhookUrl: string
        verificationToken: string
        secretToken?: string
    }

    export interface WebhookSettingsResponse {
        settings: WebhookSettings | null
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.connect = this.connect.bind(this)
            this.connectWithDefaults = this.connectWithDefaults.bind(this)
            this.deleteOAuthSettings = this.deleteOAuthSettings.bind(this)
            this.deleteWebhookSettingsEndpoint = this.deleteWebhookSettingsEndpoint.bind(this)
            this.disconnect = this.disconnect.bind(this)
            this.disconnectAccount = this.disconnectAccount.bind(this)
            this.getAllOAuthSettings = this.getAllOAuthSettings.bind(this)
            this.getCapabilities = this.getCapabilities.bind(this)
            this.getOAuthSettings = this.getOAuthSettings.bind(this)
            this.getOAuthUrl = this.getOAuthUrl.bind(this)
            this.getStatus = this.getStatus.bind(this)
            this.getWebhookEvents = this.getWebhookEvents.bind(this)
            this.getWebhookSettingsEndpoint = this.getWebhookSettingsEndpoint.bind(this)
            this.getZoomConnectUrl = this.getZoomConnectUrl.bind(this)
            this.listAccounts = this.listAccounts.bind(this)
            this.listEnrichedAccounts = this.listEnrichedAccounts.bind(this)
            this.oauthCallback = this.oauthCallback.bind(this)
            this.saveOAuthSettings = this.saveOAuthSettings.bind(this)
            this.saveWebhookSettingsEndpoint = this.saveWebhookSettingsEndpoint.bind(this)
            this.testConnection = this.testConnection.bind(this)
            this.webhookReceiver = this.webhookReceiver.bind(this)
            this.zoomConnectCallback = this.zoomConnectCallback.bind(this)
        }

        /**
         * Connect a Zoom account with S2S credentials
         */
        public async connect(params: ConnectRequest): Promise<ConnectResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/connect`, JSON.stringify(params))
            return await resp.json() as ConnectResponse
        }

        /**
         * Connect using default credentials from Encore secrets (for dev/testing)
         */
        public async connectWithDefaults(): Promise<ConnectResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/connect-default`)
            return await resp.json() as ConnectResponse
        }

        /**
         * Delete OAuth app settings for tenant
         */
        public async deleteOAuthSettings(params: {
    /**
     * Delete OAuth app settings for tenant
     */
    purpose?: CredentialPurpose
}): Promise<{
    /**
     * Delete OAuth app settings for tenant
     */
    success: boolean
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                purpose: params.purpose === undefined ? undefined : String(params.purpose),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/connection/oauth-settings`, undefined, {query})
            return await resp.json() as {
    /**
     * Delete OAuth app settings for tenant
     */
    success: boolean
}
        }

        /**
         * Delete webhook settings for tenant
         */
        public async deleteWebhookSettingsEndpoint(): Promise<{
    /**
     * Delete webhook settings for tenant
     */
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/connection/webhook-settings`)
            return await resp.json() as {
    /**
     * Delete webhook settings for tenant
     */
    success: boolean
}
        }

        /**
         * Disconnect Zoom account
         */
        public async disconnect(): Promise<DisconnectResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/disconnect`)
            return await resp.json() as DisconnectResponse
        }

        /**
         * Disconnect a specific account
         */
        public async disconnectAccount(accountId: string): Promise<DisconnectResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/disconnect/${encodeURIComponent(accountId)}`)
            return await resp.json() as DisconnectResponse
        }

        /**
         * Get all OAuth app settings for tenant (all purposes)
         */
        public async getAllOAuthSettings(): Promise<AllOAuthSettingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/oauth-settings/all`)
            return await resp.json() as AllOAuthSettingsResponse
        }

        /**
         * Get connection capabilities for tenant
         */
        public async getCapabilities(): Promise<ConnectionCapabilities> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/capabilities`)
            return await resp.json() as ConnectionCapabilities
        }

        /**
         * Get OAuth app settings for tenant (by purpose)
         */
        public async getOAuthSettings(params: {
    /**
     * Get OAuth app settings for tenant (by purpose)
     */
    purpose?: CredentialPurpose
}): Promise<OAuthSettingsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                purpose: params.purpose === undefined ? undefined : String(params.purpose),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/oauth-settings`, undefined, {query})
            return await resp.json() as OAuthSettingsResponse
        }

        /**
         * Get OAuth authorization URL for tenant
         */
        public async getOAuthUrl(params: {
    /**
     * Get OAuth authorization URL for tenant
     */
    purpose?: CredentialPurpose
}): Promise<{
    /**
     * Get OAuth authorization URL for tenant
     */
    url: string | null

    /**
     * Get OAuth authorization URL for tenant
     */
    error?: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                purpose: params.purpose === undefined ? undefined : String(params.purpose),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/oauth-url`, undefined, {query})
            return await resp.json() as {
    /**
     * Get OAuth authorization URL for tenant
     */
    url: string | null

    /**
     * Get OAuth authorization URL for tenant
     */
    error?: string
}
        }

        /**
         * Get connection status
         */
        public async getStatus(): Promise<ConnectionStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/status`)
            return await resp.json() as ConnectionStatusResponse
        }

        /**
         * Get recent webhook events for tenant
         */
        public async getWebhookEvents(params: {
    /**
     * Get recent webhook events for tenant
     */
    limit?: number
}): Promise<WebhookEventsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/webhook-events`, undefined, {query})
            return await resp.json() as WebhookEventsResponse
        }

        /**
         * Get webhook settings for tenant
         */
        public async getWebhookSettingsEndpoint(): Promise<WebhookSettingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/webhook-settings`)
            return await resp.json() as WebhookSettingsResponse
        }

        public async getZoomConnectUrl(params: GetZoomConnectUrlRequest): Promise<{
    url: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                purpose:  params.purpose,
                returnTo: params.returnTo,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/zoom/url`, undefined, {query})
            return await resp.json() as {
    url: string
}
        }

        /**
         * List all connected accounts for tenant
         */
        public async listAccounts(): Promise<ListConnectionsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/accounts`)
            return await resp.json() as ListConnectionsResponse
        }

        /**
         * List all connected accounts enriched with live Zoom profile data
         */
        public async listEnrichedAccounts(): Promise<ListEnrichedAccountsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/connection/accounts/enriched`)
            return await resp.json() as ListEnrichedAccountsResponse
        }

        /**
         * OAuth callback handler - Zoom redirects here after authorization
         */
        public async oauthCallback(method: "GET", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/connection/oauth/callback`, body, options)
        }

        /**
         * Save OAuth app settings for tenant
         */
        public async saveOAuthSettings(params: OAuthSettingsRequest): Promise<SaveOAuthSettingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/oauth-settings`, JSON.stringify(params))
            return await resp.json() as SaveOAuthSettingsResponse
        }

        /**
         * Save webhook settings for tenant
         */
        public async saveWebhookSettingsEndpoint(params: WebhookSettingsRequest): Promise<SaveWebhookSettingsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/webhook-settings`, JSON.stringify(params))
            return await resp.json() as SaveWebhookSettingsResponse
        }

        /**
         * Test S2S credentials without saving
         */
        public async testConnection(params: TestConnectionRequest): Promise<TestConnectionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/connection/test`, JSON.stringify(params))
            return await resp.json() as TestConnectionResponse
        }

        /**
         * Webhook receiver endpoint for Zoom events
         * Tenant identified by ID in URL path
         */
        public async webhookReceiver(method: "POST", tenantId: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/connection/webhook/${encodeURIComponent(tenantId)}`, body, options)
        }

        public async zoomConnectCallback(method: "GET", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/connection/zoom/callback`, body, options)
        }
    }
}

export namespace database {
    export type AuditCategory = "api_read" | "api_write" | "browser" | "error"

    export interface AuditLogEntry {
        id: string
        type: string
        category: AuditCategory
        method?: string
        endpoint?: string
        status?: number
        latencyMs?: number
        description: string
        userId?: string
        userEmail?: string
        conversationId?: string
        conversationTitle?: string
        createdAt: string
    }

    export interface AuditLogResponse {
        entries: AuditLogEntry[]
        total: number
        hasMore: boolean
    }

    export interface EventLogEntry {
        id: string
        tenantId: string
        userId?: string
        eventType: string
        resourceType?: string
        resourceId?: string
        resourceName?: string
        details: { [key: string]: any }
        confirmationId?: string
        createdAt: string
    }

    export type EventType = "zoom.change" | "zoom.error" | "planning.started" | "planning.plan_generated" | "planning.plan_reviewed" | "planning.plan_revised" | "planning.approved" | "planning.confirmed" | "planning.executed" | "planning.verified" | "planning.cancelled" | "planning.scheduled" | "planning.schedule_triggered" | "state.captured" | "state.restored" | "changeset.created" | "changeset.applied" | "changeset.copied" | "notification.sent" | "notification.failed" | "notification.webhook_delivered" | "notification.webhook_failed" | "synthetic.test_started" | "synthetic.test_completed" | "synthetic.test_failed" | "synthetic.test_error" | "synthetic.suite_completed"

    export interface ListEventsResponse {
        events: EventLogEntry[]
        total: number
        hasMore: boolean
    }

    export interface LogEventInput {
        tenantId: string
        userId?: string
        eventType: EventType
        resourceType?: string
        resourceId?: string
        resourceName?: string
        details?: { [key: string]: any }
        confirmationId?: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.createEvent = this.createEvent.bind(this)
            this.getAuditLog = this.getAuditLog.bind(this)
            this.getEventSummary = this.getEventSummary.bind(this)
            this.listEvents = this.listEvents.bind(this)
        }

        /**
         * Log a new event
         */
        public async createEvent(params: LogEventInput): Promise<EventLogEntry> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/events`, JSON.stringify(params))
            return await resp.json() as EventLogEntry
        }

        /**
         * Get audit log of Zoom API and browser activity for the authenticated tenant
         */
        public async getAuditLog(params: {
    limit?: number
    offset?: number
    category?: string
}): Promise<AuditLogResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/audit/log`, undefined, {query})
            return await resp.json() as AuditLogResponse
        }

        /**
         * Get event type summary counts
         */
        public async getEventSummary(params: {
    tenantId?: string
}): Promise<{
    byType: {
        eventType: string
        count: number
    }[]
    total: number
    recentCount: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                tenantId: params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/summary`, undefined, {query})
            return await resp.json() as {
    byType: {
        eventType: string
        count: number
    }[]
    total: number
    recentCount: number
}
        }

        /**
         * List events with optional filters
         */
        public async listEvents(params: {
    tenantId?: string
    eventType?: string
    resourceType?: string
    limit?: number
    offset?: number
}): Promise<ListEventsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                eventType:    params.eventType,
                limit:        params.limit === undefined ? undefined : String(params.limit),
                offset:       params.offset === undefined ? undefined : String(params.offset),
                resourceType: params.resourceType,
                tenantId:     params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events`, undefined, {query})
            return await resp.json() as ListEventsResponse
        }
    }
}

export namespace events {
    export interface ActivityMetric {
        category: string
        metric: string
        count: number
        errorCount: number
        avgLatencyMs: number
    }

    export interface ActivityRequest {
        tenantId?: string
        userId?: string
        category?: string
        days?: number
    }

    export interface ActivityResponse {
        metrics: ActivityMetric[]
        period: {
            days: number
            from: string
            to: string
        }
    }

    export interface AlertStatsResponse {
        counts: { [key: string]: number }
        cooldownEntries: number
        recentAlerts: {
            key: string
            timestamp: number
        }[]
    }

    export interface BackfillRequest {
        days?: number
    }

    export interface BackfillResponse {
        llmRows: number
        activityRows: number
        eventsProcessed: number
        duration: string
    }

    export interface Consumer {
        id: string
        requestCount: number
        totalTokens: number
        costUsd: number
        avgCostPerRequest: number
        topModel: string
    }

    export interface EventEntry {
        id: string
        type: string
        tenantId: string
        userId?: string
        conversationId?: string
        requestId?: string
        data: { [key: string]: any }
        cost?: {
            amount: number
            unit: string
            quantity: number
        }
        createdAt: string
    }

    export interface ListEventsRequest {
        type?: string
        tenantId?: string
        conversationId?: string
        limit?: number
        offset?: number
    }

    export interface ListEventsResponse {
        events: EventEntry[]
        total: number
        hasMore: boolean
    }

    export interface SessionSummary {
        conversationId: string
        tenantId: string
        userId?: string
        startedAt: string
        lastEventAt: string
        messageCount: number
        totalCost: number
    }

    export interface StreamEventMessage {
        type: "connected" | "event"
        event?: EventEntry
    }

    export interface StreamEventsRequest {
        conversationId?: string
        tenantId?: string
        filter?: string
    }

    export interface TopConsumersRequest {
        days?: number
        limit?: number
        dimension?: string
    }

    export interface TopConsumersResponse {
        consumers: Consumer[]
        totalCost: number
    }

    export interface UsageEntry {
        date?: string
        model?: string
        provider?: string
        tenantId?: string
        userId?: string
        requestCount: number
        inputTokens: number
        outputTokens: number
        totalTokens: number
        costUsd: number
        totalLatencyMs: number
        errorCount: number
    }

    export interface UsageRequest {
        tenantId?: string
        userId?: string
        model?: string
        days?: number
        groupBy?: string
    }

    export interface UsageResponse {
        entries: UsageEntry[]
        totals: {
            requestCount: number
            totalTokens: number
            costUsd: number
            avgCostPerRequest: number
            errorRate: number
        }
        period: {
            days: number
            from: string
            to: string
        }
    }

    export interface WorkflowStatsResponse {
        recentTriggers: {
            key: string
            timestamp: number
        }[]
        workflows: {
            name: string
            eventType: string
        }[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.backfillUsage = this.backfillUsage.bind(this)
            this.emitTestEvent = this.emitTestEvent.bind(this)
            this.getActivity = this.getActivity.bind(this)
            this.getAlerts = this.getAlerts.bind(this)
            this.getCostSummary = this.getCostSummary.bind(this)
            this.getEventsSummary = this.getEventsSummary.bind(this)
            this.getSessionEvents = this.getSessionEvents.bind(this)
            this.getTopConsumers = this.getTopConsumers.bind(this)
            this.getUsage = this.getUsage.bind(this)
            this.getWorkflows = this.getWorkflows.bind(this)
            this.listEvents = this.listEvents.bind(this)
            this.listSessions = this.listSessions.bind(this)
            this.streamEvents = this.streamEvents.bind(this)
        }

        public async backfillUsage(params: BackfillRequest): Promise<BackfillResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/events/usage/backfill`, JSON.stringify(params))
            return await resp.json() as BackfillResponse
        }

        /**
         * Emit a test event to verify the event bus is working
         */
        public async emitTestEvent(params: {
    tenantId?: string
    message?: string
}): Promise<{
    eventId: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/events/bus/test`, JSON.stringify(params))
            return await resp.json() as {
    eventId: string
}
        }

        public async getActivity(params: ActivityRequest): Promise<ActivityResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                days:     params.days === undefined ? undefined : String(params.days),
                tenantId: params.tenantId,
                userId:   params.userId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/usage/activity`, undefined, {query})
            return await resp.json() as ActivityResponse
        }

        /**
         * Get alert statistics
         */
        public async getAlerts(): Promise<AlertStatsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus/alerts`)
            return await resp.json() as AlertStatsResponse
        }

        /**
         * Get cost summary
         */
        public async getCostSummary(params: {
    tenantId?: string
    days?: number
}): Promise<{
    total: number
    byCategory: {
        category: string
        amount: number
    }[]
    byDay: {
        date: string
        amount: number
    }[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                days:     params.days === undefined ? undefined : String(params.days),
                tenantId: params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus/costs`, undefined, {query})
            return await resp.json() as {
    total: number
    byCategory: {
        category: string
        amount: number
    }[]
    byDay: {
        date: string
        amount: number
    }[]
}
        }

        /**
         * Get summary of events by type
         */
        public async getEventsSummary(params: {
    tenantId?: string
}): Promise<{
    byType: {
        type: string
        count: number
    }[]
    total: number
    last24h: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                tenantId: params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus/summary`, undefined, {query})
            return await resp.json() as {
    byType: {
        type: string
        count: number
    }[]
    total: number
    last24h: number
}
        }

        /**
         * Get all events for a session (for replay)
         */
        public async getSessionEvents(conversationId: string): Promise<{
    events: EventEntry[]
    summary: {
        messageCount: number
        toolCallCount: number
        totalCost: number
        durationMs: number
    }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus/sessions/${encodeURIComponent(conversationId)}`)
            return await resp.json() as {
    events: EventEntry[]
    summary: {
        messageCount: number
        toolCallCount: number
        totalCost: number
        durationMs: number
    }
}
        }

        public async getTopConsumers(params: TopConsumersRequest): Promise<TopConsumersResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                days:      params.days === undefined ? undefined : String(params.days),
                dimension: params.dimension,
                limit:     params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/usage/top-consumers`, undefined, {query})
            return await resp.json() as TopConsumersResponse
        }

        public async getUsage(params: UsageRequest): Promise<UsageResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                days:     params.days === undefined ? undefined : String(params.days),
                groupBy:  params.groupBy,
                model:    params.model,
                tenantId: params.tenantId,
                userId:   params.userId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/usage`, undefined, {query})
            return await resp.json() as UsageResponse
        }

        /**
         * Get workflow trigger statistics
         */
        public async getWorkflows(): Promise<WorkflowStatsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus/workflows`)
            return await resp.json() as WorkflowStatsResponse
        }

        /**
         * List events with optional filters
         */
        public async listEvents(params: ListEventsRequest): Promise<ListEventsResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                conversationId: params.conversationId,
                limit:          params.limit === undefined ? undefined : String(params.limit),
                offset:         params.offset === undefined ? undefined : String(params.offset),
                tenantId:       params.tenantId,
                type:           params.type,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus`, undefined, {query})
            return await resp.json() as ListEventsResponse
        }

        /**
         * List active/recent chat sessions
         */
        public async listSessions(params: {
    tenantId?: string
    hours?: number
    limit?: number
}): Promise<{
    sessions: SessionSummary[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                hours:    params.hours === undefined ? undefined : String(params.hours),
                limit:    params.limit === undefined ? undefined : String(params.limit),
                tenantId: params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/events/bus/sessions`, undefined, {query})
            return await resp.json() as {
    sessions: SessionSummary[]
}
        }

        /**
         * Stream events via WebSocket with polling
         */
        public async streamEvents(params: StreamEventsRequest): Promise<StreamIn<StreamEventMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                conversationId: params.conversationId,
                filter:         params.filter,
                tenantId:       params.tenantId,
            })

            return await this.baseClient.createStreamIn(`/events/bus/stream`, {query})
        }
    }
}

export namespace executor {
    export interface ExecuteRequest {
        plan: shared.ExecutionPlan
        dryRun?: boolean
        stopOnError?: boolean
        rollbackOnError?: boolean
    }

    export interface ExecuteResponse {
        result: shared.ExecutionResult
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.execute = this.execute.bind(this)
            this.executeTask = this.executeTask.bind(this)
            this.rollback = this.rollback.bind(this)
            this.rollbackAll = this.rollbackAll.bind(this)
        }

        /**
         * Execute an execution plan
         */
        public async execute(params: ExecuteRequest): Promise<ExecuteResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/executor/execute`, JSON.stringify(params))
            return await resp.json() as ExecuteResponse
        }

        /**
         * Execute a single task (for testing/debugging)
         */
        public async executeTask(params: {
    task: shared.ConfigurationTask
    dryRun?: boolean
}): Promise<{
    completed: shared.CompletedTask
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/executor/task`, JSON.stringify(params))
            return await resp.json() as {
    completed: shared.CompletedTask
}
        }

        /**
         * Rollback a specific resource
         */
        public async rollback(params: {
    resourceType: string
    resourceId: string
}): Promise<{
    success: boolean
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/executor/rollback`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
    error?: string
}
        }

        /**
         * Rollback all resources from an execution result
         */
        public async rollbackAll(params: {
    createdResources: shared.CreatedResource[]
}): Promise<{
    results: {
        resource: shared.CreatedResource
        success: boolean
        error?: string
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/executor/rollback-all`, JSON.stringify(params))
            return await resp.json() as {
    results: {
        resource: shared.CreatedResource
        success: boolean
        error?: string
    }[]
}
        }
    }
}

export namespace graph_changes {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.approve = this.approve.bind(this)
            this.cancel = this.cancel.bind(this)
            this.create = this.create.bind(this)
            this.execute = this.execute.bind(this)
            this.get = this.get.bind(this)
            this.list = this.list.bind(this)
            this.rollback = this.rollback.bind(this)
            this.status = this.status.bind(this)
        }

        /**
         * Approve a plan for execution
         */
        public async approve(id: string): Promise<{
    plan: changes.Plan
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/changes/plans/${encodeURIComponent(id)}/approve`)
            return await resp.json() as {
    plan: changes.Plan
}
        }

        /**
         * Cancel a plan
         */
        public async cancel(id: string): Promise<{
    plan: changes.Plan
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/changes/plans/${encodeURIComponent(id)}/cancel`)
            return await resp.json() as {
    plan: changes.Plan
}
        }

        /**
         * Create a new implementation plan from a goal
         */
        public async create(params: changes.CreatePlanRequest): Promise<changes.CreatePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/changes/plans`, JSON.stringify(params))
            return await resp.json() as changes.CreatePlanResponse
        }

        /**
         * Execute an approved plan
         */
        public async execute(id: string, params: {
    options?: {
        stopOnError?: boolean
        skipVerification?: boolean
    }
}): Promise<changes.ExecutePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/changes/plans/${encodeURIComponent(id)}/execute`, JSON.stringify(params))
            return await resp.json() as changes.ExecutePlanResponse
        }

        /**
         * Get a plan by ID
         */
        public async get(id: string): Promise<{
    plan: changes.Plan
    steps: changes.PlanStep[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/changes/plans/${encodeURIComponent(id)}`)
            return await resp.json() as {
    plan: changes.Plan
    steps: changes.PlanStep[]
}
        }

        /**
         * List all plans
         */
        public async list(params: {
    status?: string
    conversationId?: string
    limit?: number
    offset?: number
}): Promise<{
    plans: changes.Plan[]
    total: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                conversationId: params.conversationId,
                limit:          params.limit === undefined ? undefined : String(params.limit),
                offset:         params.offset === undefined ? undefined : String(params.offset),
                status:         params.status,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/changes/plans`, undefined, {query})
            return await resp.json() as {
    plans: changes.Plan[]
    total: number
}
        }

        /**
         * Rollback a plan execution
         */
        public async rollback(id: string, params: {
    executionId?: string
}): Promise<changes.RollbackPlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/changes/plans/${encodeURIComponent(id)}/rollback`, JSON.stringify(params))
            return await resp.json() as changes.RollbackPlanResponse
        }

        /**
         * Get execution status
         */
        public async status(id: string): Promise<changes.PlanStatusResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/changes/plans/${encodeURIComponent(id)}/status`)
            return await resp.json() as changes.PlanStatusResponse
        }
    }
}

export namespace graph_config {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.addRelationship = this.addRelationship.bind(this)
            this.deleteResource = this.deleteResource.bind(this)
            this.deleteTenant = this.deleteTenant.bind(this)
            this.detectCycles = this.detectCycles.bind(this)
            this.findPath = this.findPath.bind(this)
            this.getDependencies = this.getDependencies.bind(this)
            this.getDependents = this.getDependents.bind(this)
            this.getExecutionOrder = this.getExecutionOrder.bind(this)
            this.initializeTenant = this.initializeTenant.bind(this)
            this.listResources = this.listResources.bind(this)
            this.listTenants = this.listTenants.bind(this)
            this.upsertResource = this.upsertResource.bind(this)
        }

        /**
         * Add a relationship between resources
         */
        public async addRelationship(tenantId: string, params: {
    fromType: string
    fromId: string
    toType: string
    toId: string
    relationship: "DEPENDS_ON" | "ROUTES_TO" | "CONTAINS" | "REFERENCES"
    properties?: { [key: string]: any }
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/config/tenants/${encodeURIComponent(tenantId)}/relationships`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Delete a resource node and its relationships
         */
        public async deleteResource(tenantId: string, _type: string, resourceId: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources/${encodeURIComponent(_type)}/${encodeURIComponent(resourceId)}`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Delete a tenant's graph
         */
        public async deleteTenant(tenantId: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/graph/config/tenants/${encodeURIComponent(tenantId)}`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Detect circular dependencies
         */
        public async detectCycles(tenantId: string): Promise<{
    cycles: config.ResourceNode[][]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/cycles`)
            return await resp.json() as {
    cycles: config.ResourceNode[][]
}
        }

        /**
         * Find the dependency path between two resources
         */
        public async findPath(tenantId: string, params: {
    fromType: string
    fromId: string
    toType: string
    toId: string
}): Promise<{
    path: config.DependencyPath | null
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                fromId:   params.fromId,
                fromType: params.fromType,
                toId:     params.toId,
                toType:   params.toType,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/path`, undefined, {query})
            return await resp.json() as {
    path: config.DependencyPath | null
}
        }

        /**
         * Get all dependencies for a resource (what it depends on)
         */
        public async getDependencies(tenantId: string, _type: string, resourceId: string): Promise<{
    dependencies: config.ResourceNode[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources/${encodeURIComponent(_type)}/${encodeURIComponent(resourceId)}/dependencies`)
            return await resp.json() as {
    dependencies: config.ResourceNode[]
}
        }

        /**
         * Get all dependents of a resource (what depends on it)
         */
        public async getDependents(tenantId: string, _type: string, resourceId: string): Promise<{
    dependents: config.ResourceNode[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources/${encodeURIComponent(_type)}/${encodeURIComponent(resourceId)}/dependents`)
            return await resp.json() as {
    dependents: config.ResourceNode[]
}
        }

        /**
         * Get topological order for execution (respecting dependencies)
         */
        public async getExecutionOrder(tenantId: string, params: {
    resourceIds: {
        type: string
        resourceId: string
    }[]
}): Promise<{
    order: {
        type: string
        resourceId: string
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/config/tenants/${encodeURIComponent(tenantId)}/execution-order`, JSON.stringify(params))
            return await resp.json() as {
    order: {
        type: string
        resourceId: string
    }[]
}
        }

        /**
         * Initialize a tenant's graph database
         */
        public async initializeTenant(tenantId: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/config/tenants/${encodeURIComponent(tenantId)}/initialize`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Get all resources for a tenant
         */
        public async listResources(tenantId: string, params: {
    type?: string
}): Promise<{
    resources: config.ResourceNode[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                type: params.type,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources`, undefined, {query})
            return await resp.json() as {
    resources: config.ResourceNode[]
}
        }

        /**
         * List all tenants
         */
        public async listTenants(): Promise<{
    tenants: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/config/tenants`)
            return await resp.json() as {
    tenants: string[]
}
        }

        /**
         * Add or update a resource node for a tenant
         */
        public async upsertResource(tenantId: string, params: {
    type: string
    resourceId: string
    name: string
    properties: { [key: string]: any }
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/config/tenants/${encodeURIComponent(tenantId)}/resources`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }
    }
}

export namespace graph_docs {

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.adminClear = this.adminClear.bind(this)
            this.adminCompareExtraction = this.adminCompareExtraction.bind(this)
            this.adminCrawlApify = this.adminCrawlApify.bind(this)
            this.adminCrawlStatus = this.adminCrawlStatus.bind(this)
            this.adminDeepCrawl = this.adminDeepCrawl.bind(this)
            this.adminDevDocsCrawl = this.adminDevDocsCrawl.bind(this)
            this.adminExportCrawl = this.adminExportCrawl.bind(this)
            this.adminGetDocument = this.adminGetDocument.bind(this)
            this.adminImportCrawl = this.adminImportCrawl.bind(this)
            this.adminInitialize = this.adminInitialize.bind(this)
            this.adminJobHistory = this.adminJobHistory.bind(this)
            this.adminLibraryCrawl = this.adminLibraryCrawl.bind(this)
            this.adminListDocuments = this.adminListDocuments.bind(this)
            this.adminMarketingCrawl = this.adminMarketingCrawl.bind(this)
            this.adminMigrateTimestamps = this.adminMigrateTimestamps.bind(this)
            this.adminProducts = this.adminProducts.bind(this)
            this.adminQuery = this.adminQuery.bind(this)
            this.adminRecreateVectorIndexes = this.adminRecreateVectorIndexes.bind(this)
            this.adminReleaseNotesCrawl = this.adminReleaseNotesCrawl.bind(this)
            this.adminResetPipeline = this.adminResetPipeline.bind(this)
            this.adminSourceHealth = this.adminSourceHealth.bind(this)
            this.adminStats = this.adminStats.bind(this)
            this.adminSyncAll = this.adminSyncAll.bind(this)
            this.adminSyncApify = this.adminSyncApify.bind(this)
            this.analyticsCapabilities = this.analyticsCapabilities.bind(this)
            this.analyticsFeatures = this.analyticsFeatures.bind(this)
            this.analyticsHasCapability = this.analyticsHasCapability.bind(this)
            this.analyticsRecentFeatures = this.analyticsRecentFeatures.bind(this)
            this.analyticsSearchFeatures = this.analyticsSearchFeatures.bind(this)
            this.analyticsVelocity = this.analyticsVelocity.bind(this)
            this.apiEndpointContext = this.apiEndpointContext.bind(this)
            this.apiEndpoints = this.apiEndpoints.bind(this)
            this.apiSchema = this.apiSchema.bind(this)
            this.apiSync = this.apiSync.bind(this)
            this.apifyRunProgress = this.apifyRunProgress.bind(this)
            this.apifyRunProgressStream = this.apifyRunProgressStream.bind(this)
            this.catalogLink = this.catalogLink.bind(this)
            this.catalogQuality = this.catalogQuality.bind(this)
            this.catalogStats = this.catalogStats.bind(this)
            this.catalogSync = this.catalogSync.bind(this)
            this.configSchemaComponents = this.configSchemaComponents.bind(this)
            this.configSchemaGetComponent = this.configSchemaGetComponent.bind(this)
            this.configSchemaRebuild = this.configSchemaRebuild.bind(this)
            this.configSchemaResolve = this.configSchemaResolve.bind(this)
            this.configSchemaRuns = this.configSchemaRuns.bind(this)
            this.configSchemaSearch = this.configSchemaSearch.bind(this)
            this.configSchemaStatus = this.configSchemaStatus.bind(this)
            this.crawlOverview = this.crawlOverview.bind(this)
            this.dataSourceAbortSync = this.dataSourceAbortSync.bind(this)
            this.dataSourceAnalyze = this.dataSourceAnalyze.bind(this)
            this.dataSourceAnalyzeTopics = this.dataSourceAnalyzeTopics.bind(this)
            this.dataSourceCheckSync = this.dataSourceCheckSync.bind(this)
            this.dataSourceCheckSyncLegacy = this.dataSourceCheckSyncLegacy.bind(this)
            this.dataSourceCrawlHistory = this.dataSourceCrawlHistory.bind(this)
            this.dataSourceDelete = this.dataSourceDelete.bind(this)
            this.dataSourceDiffCrawls = this.dataSourceDiffCrawls.bind(this)
            this.dataSourceDiffItem = this.dataSourceDiffItem.bind(this)
            this.dataSourceGet = this.dataSourceGet.bind(this)
            this.dataSourceGetCrawl = this.dataSourceGetCrawl.bind(this)
            this.dataSourceGetCrawlItem = this.dataSourceGetCrawlItem.bind(this)
            this.dataSourceGraphMapping = this.dataSourceGraphMapping.bind(this)
            this.dataSourceReprocess = this.dataSourceReprocess.bind(this)
            this.dataSourceResumeOrphaned = this.dataSourceResumeOrphaned.bind(this)
            this.dataSourceSetDataset = this.dataSourceSetDataset.bind(this)
            this.dataSourceStartSync = this.dataSourceStartSync.bind(this)
            this.dataSourceSyncStream = this.dataSourceSyncStream.bind(this)
            this.dataSourceUpdateStats = this.dataSourceUpdateStats.bind(this)
            this.dataSourceUpsert = this.dataSourceUpsert.bind(this)
            this.dataSourcesList = this.dataSourcesList.bind(this)
            this.dataSourcesReseed = this.dataSourcesReseed.bind(this)
            this.dataSourcesSummary = this.dataSourcesSummary.bind(this)
            this.exportGraph = this.exportGraph.bind(this)
            this.extractGuides = this.extractGuides.bind(this)
            this.findEndpoints = this.findEndpoints.bind(this)
            this.getCatalogProduct = this.getCatalogProduct.bind(this)
            this.getGuide = this.getGuide.bind(this)
            this.getGuideLinkStatsEndpoint = this.getGuideLinkStatsEndpoint.bind(this)
            this.getPrerequisites = this.getPrerequisites.bind(this)
            this.getQueryLog = this.getQueryLog.bind(this)
            this.getQueryLogEntry = this.getQueryLogEntry.bind(this)
            this.getQueryLogStats = this.getQueryLogStats.bind(this)
            this.graphHealth = this.graphHealth.bind(this)
            this.healthCheckCategory = this.healthCheckCategory.bind(this)
            this.healthCheckFull = this.healthCheckFull.bind(this)
            this.healthCheckQueries = this.healthCheckQueries.bind(this)
            this.healthCheckQuick = this.healthCheckQuick.bind(this)
            this.healthCheckSingle = this.healthCheckSingle.bind(this)
            this.importApifyRun = this.importApifyRun.bind(this)
            this.importGraph = this.importGraph.bind(this)
            this.importOpenAPISpec = this.importOpenAPISpec.bind(this)
            this.linkGuideSteps = this.linkGuideSteps.bind(this)
            this.listCatalogProducts = this.listCatalogProducts.bind(this)
            this.listProductCategories = this.listProductCategories.bind(this)
            this.listProductFamilies = this.listProductFamilies.bind(this)
            this.pipelineConceptCoverage = this.pipelineConceptCoverage.bind(this)
            this.pipelineDocumentDetail = this.pipelineDocumentDetail.bind(this)
            this.pipelineDocuments = this.pipelineDocuments.bind(this)
            this.pipelineInventory = this.pipelineInventory.bind(this)
            this.pipelineKGState = this.pipelineKGState.bind(this)
            this.pipelineLatestReport = this.pipelineLatestReport.bind(this)
            this.pipelineOperationCoverage = this.pipelineOperationCoverage.bind(this)
            this.pipelineProductCoverage = this.pipelineProductCoverage.bind(this)
            this.pipelineRebuild = this.pipelineRebuild.bind(this)
            this.pipelineReport = this.pipelineReport.bind(this)
            this.pipelineReportsList = this.pipelineReportsList.bind(this)
            this.pipelineRetryFailed = this.pipelineRetryFailed.bind(this)
            this.pipelineStatus = this.pipelineStatus.bind(this)
            this.pipelineSyncDevDocs = this.pipelineSyncDevDocs.bind(this)
            this.pipelineSyncKB = this.pipelineSyncKB.bind(this)
            this.pipelineSyncLibrary = this.pipelineSyncLibrary.bind(this)
            this.queryConfigPath = this.queryConfigPath.bind(this)
            this.queryContent = this.queryContent.bind(this)
            this.queryFeatures = this.queryFeatures.bind(this)
            this.queryFeaturesInRange = this.queryFeaturesInRange.bind(this)
            this.queryKnowledgeGraph = this.queryKnowledgeGraph.bind(this)
            this.querySimilar = this.querySimilar.bind(this)
            this.queryWhenAdded = this.queryWhenAdded.bind(this)
            this.releaseFeaturesByDate = this.releaseFeaturesByDate.bind(this)
            this.releaseNotesSync = this.releaseNotesSync.bind(this)
            this.releaseNotesSyncProduct = this.releaseNotesSyncProduct.bind(this)
            this.releaseProducts = this.releaseProducts.bind(this)
            this.releaseTimeline = this.releaseTimeline.bind(this)
            this.releaseWhenAdded = this.releaseWhenAdded.bind(this)
            this.scopeAudit = this.scopeAudit.bind(this)
            this.searchGuidesEndpoint = this.searchGuidesEndpoint.bind(this)
            this.seedCatalog = this.seedCatalog.bind(this)
            this.tempGraphDelete = this.tempGraphDelete.bind(this)
            this.tempGraphGetItem = this.tempGraphGetItem.bind(this)
            this.tempGraphList = this.tempGraphList.bind(this)
            this.tempGraphLoad = this.tempGraphLoad.bind(this)
            this.tempGraphQuery = this.tempGraphQuery.bind(this)
            this.tempGraphStats = this.tempGraphStats.bind(this)
            this.testReleaseExtraction = this.testReleaseExtraction.bind(this)
            this.unifiedSearch = this.unifiedSearch.bind(this)
            this.updateProductMetadata = this.updateProductMetadata.bind(this)
            this.vectorizeEndpoints = this.vectorizeEndpoints.bind(this)
        }

        /**
         * Clear all graph data
         */
        public async adminClear(): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/clear`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Compare vision extraction vs direct markdown from Apify
         */
        public async adminCompareExtraction(params: {
    articleUrl: string
}): Promise<{
    comparison: kb.ComparisonResult
    recommendation: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/compare-extraction`, JSON.stringify(params))
            return await resp.json() as {
    comparison: kb.ComparisonResult
    recommendation: string
}
        }

        /**
         * Crawl KB articles using Apify (better quality than Tavily)
         */
        public async adminCrawlApify(params: {
    urls: string[]
    maxResults?: number
}): Promise<{
    success: boolean
    results: kb.ApifyCrawlResult[]
    duration: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/crawl-apify`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
    results: kb.ApifyCrawlResult[]
    duration: number
}
        }

        /**
         * Check status of a crawl run
         */
        public async adminCrawlStatus(runId: string): Promise<{
    runId: string
    status: string
    datasetId?: string
    resultsCount?: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/admin/crawl-status/${encodeURIComponent(runId)}`)
            return await resp.json() as {
    runId: string
    status: string
    datasetId?: string
    resultsCount?: number
}
        }

        /**
         * Start a deep crawl to discover KB articles (async - returns run ID)
         */
        public async adminDeepCrawl(params: {
    seedUrls: string[]
    maxCrawlDepth?: number
    maxCrawlPages?: number
    memoryMbytes?: number
    initialConcurrency?: number
    maxConcurrency?: number
}): Promise<{
    runId: string
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/deep-crawl`, JSON.stringify(params))
            return await resp.json() as {
    runId: string
    message: string
}
        }

        /**
         * Start a deep crawl for developer docs (developers.zoom.us)
         */
        public async adminDevDocsCrawl(params: {
    maxCrawlDepth?: number
    maxCrawlPages?: number
    memoryMbytes?: number
    initialConcurrency?: number
    maxConcurrency?: number
}): Promise<{
    runId: string
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/dev-docs-crawl`, JSON.stringify(params))
            return await resp.json() as {
    runId: string
    message: string
}
        }

        /**
         * Export raw crawl data from an Apify dataset
         */
        public async adminExportCrawl(datasetId: string): Promise<{
    count: number
    items: {
        url: string
        title: string
        markdown: string
        html?: string
        screenshotUrl?: string
        crawledAt: string
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/admin/export-crawl/${encodeURIComponent(datasetId)}`)
            return await resp.json() as {
    count: number
    items: {
        url: string
        title: string
        markdown: string
        html?: string
        screenshotUrl?: string
        crawledAt: string
    }[]
}
        }

        /**
         * Debug: Get a document by URL to check import results
         */
        public async adminGetDocument(params: {
    url: string
}): Promise<{
    found: boolean
    title?: string
    markdownLength?: number
    hasExtractedTables?: boolean
    hasTableSyntax?: boolean
    tablesSectionPreview?: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                url: params.url,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/admin/document`, undefined, {query})
            return await resp.json() as {
    found: boolean
    title?: string
    markdownLength?: number
    hasExtractedTables?: boolean
    hasTableSyntax?: boolean
    tablesSectionPreview?: string
}
        }

        /**
         * Import results from a completed crawl run into the graph
         */
        public async adminImportCrawl(params: {
    runId: string
}): Promise<{
    imported: number
    skipped: number
    duration: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/import-crawl`, JSON.stringify(params))
            return await resp.json() as {
    imported: number
    skipped: number
    duration: number
}
        }

        /**
         * Initialize the graph database
         */
        public async adminInitialize(): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/initialize`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Get job history
         */
        public async adminJobHistory(): Promise<{
    jobs: {
        id: string
        type: "refresh" | "rebuild" | "link" | "sync" | "discover"
        startedAt: string
        completedAt: string | null
        status: "running" | "completed" | "failed"
        result: { [key: string]: any } | null
        error: string | null
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/admin/jobs`)
            return await resp.json() as {
    jobs: {
        id: string
        type: "refresh" | "rebuild" | "link" | "sync" | "discover"
        startedAt: string
        completedAt: string | null
        status: "running" | "completed" | "failed"
        result: { [key: string]: any } | null
        error: string | null
    }[]
}
        }

        /**
         * Start a crawl for library.zoom.com learning resources
         */
        public async adminLibraryCrawl(params: {
    maxCrawlDepth?: number
    maxCrawlPages?: number
    memoryMbytes?: number
    initialConcurrency?: number
    maxConcurrency?: number
}): Promise<{
    runId: string
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/library-crawl`, JSON.stringify(params))
            return await resp.json() as {
    runId: string
    message: string
}
        }

        /**
         * List all documents (for BM25 corpus building)
         */
        public async adminListDocuments(params: {
    limit?: number
}): Promise<{
    count: number
    documents: {
        url: string
        title: string
        markdown: string
        product?: string
    }[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/admin/documents`, undefined, {query})
            return await resp.json() as {
    count: number
    documents: {
        url: string
        title: string
        markdown: string
        product?: string
    }[]
}
        }

        /**
         * Start a crawl for zoom.com marketing pages (product info, case studies, etc.)
         */
        public async adminMarketingCrawl(params: {
    maxCrawlDepth?: number
    maxCrawlPages?: number
    memoryMbytes?: number
    initialConcurrency?: number
    maxConcurrency?: number
}): Promise<{
    runId: string
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/marketing-crawl`, JSON.stringify(params))
            return await resp.json() as {
    runId: string
    message: string
}
        }

        /**
         * Migrate data to add missing timestamps (one-time fix)
         */
        public async adminMigrateTimestamps(): Promise<{
    releasesUpdated: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/migrate-timestamps`)
            return await resp.json() as {
    releasesUpdated: number
}
        }

        /**
         * Get available products from catalog
         */
        public async adminProducts(): Promise<{
    products: {
        id: string
        name: string
        aliases: string[]
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/admin/products`)
            return await resp.json() as {
    products: {
        id: string
        name: string
        aliases: string[]
    }[]
}
        }

        /**
         * Run a Cypher query on the main graph (admin only)
         */
        public async adminQuery(params: {
    query: string
}): Promise<{
    data: any[]
    columns: string[]
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/query`, JSON.stringify(params))
            return await resp.json() as {
    data: any[]
    columns: string[]
    error?: string
}
        }

        /**
         * Recreate vector indexes with correct dimensions (3072 for Gemini embeddings)
         */
        public async adminRecreateVectorIndexes(): Promise<{
    dropped: string[]
    created: string[]
    errors: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/recreate-indexes`)
            return await resp.json() as {
    dropped: string[]
    created: string[]
    errors: string[]
}
        }

        /**
         * Start a crawl for release notes (optimized for tables)
         */
        public async adminReleaseNotesCrawl(params: {
    seedUrls?: string[]
    memoryMbytes?: number
    initialConcurrency?: number
    maxConcurrency?: number
}): Promise<{
    runId: string
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/release-notes-crawl`, JSON.stringify(params))
            return await resp.json() as {
    runId: string
    message: string
}
        }

        /**
         * Reset pipeline: clear graph, reset KG state to empty, clear pipeline artifacts
         */
        public async adminResetPipeline(): Promise<{
    success: boolean
    cleared: {
        graph: boolean
        kgState: boolean
        documentStatus: boolean
    }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/pipeline/reset`)
            return await resp.json() as {
    success: boolean
    cleared: {
        graph: boolean
        kgState: boolean
        documentStatus: boolean
    }
}
        }

        /**
         * Get per-source health breakdown
         */
        public async adminSourceHealth(): Promise<{
    sources: {
        id: string
        name: string
        nodeTypes: string[]
        nodeCount: number
        lastSynced: string | null
        staleDays: number
        status: "fresh" | "stale" | "critical"
        syncEndpoint: string
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/admin/sources`)
            return await resp.json() as {
    sources: {
        id: string
        name: string
        nodeTypes: string[]
        nodeCount: number
        lastSynced: string | null
        staleDays: number
        status: "fresh" | "stale" | "critical"
        syncEndpoint: string
    }[]
}
        }

        /**
         * Get graph statistics
         */
        public async adminStats(): Promise<{
    graph: {
        products: number
        releases: number
        features: number
        capabilities: number
    }
    content: {
        total: number
        byProduct: { [key: string]: number }
    }
    links: {
        featureToEndpoint: number
        featureToDoc: number
        endpointToDoc: number
    }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/admin/stats`)
            return await resp.json() as {
    graph: {
        products: number
        releases: number
        features: number
        capabilities: number
    }
    content: {
        total: number
        byProduct: { [key: string]: number }
    }
    links: {
        featureToEndpoint: number
        featureToDoc: number
        endpointToDoc: number
    }
}
        }

        /**
         * Sync all data sources (KB, Library, DevDocs)
         */
        public async adminSyncAll(params: {
    force?: boolean
}): Promise<{
    success: boolean
    results: {
        sourceId: string
        imported: number
        skipped: number
        duration: number
    }[]
    errors: {
        sourceId: string
        error: string
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/sync-all`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
    results: {
        sourceId: string
        imported: number
        skipped: number
        duration: number
    }[]
    errors: {
        sourceId: string
        error: string
    }[]
}
        }

        /**
         * Sync a KB article using Apify and store in graph
         */
        public async adminSyncApify(params: {
    articleUrl: string
    forceRefresh?: boolean
}): Promise<{
    success: boolean
    title: string
    markdownLength: number
    hasScreenshot: boolean
    duration: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/sync-apify`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
    title: string
    markdownLength: number
    hasScreenshot: boolean
    duration: number
}
        }

        /**
         * Get product capabilities
         */
        public async analyticsCapabilities(params: {
    product: string
}): Promise<{
    capabilities: kb.CapabilityInfo[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                product: params.product,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/analytics/capabilities`, undefined, {query})
            return await resp.json() as {
    capabilities: kb.CapabilityInfo[]
}
        }

        /**
         * Get feature trends over time
         */
        public async analyticsFeatures(params: {
    product?: string
    groupBy?: string
}): Promise<{
    data: kb.FeatureTrendsResult[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                groupBy: params.groupBy,
                product: params.product,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/analytics/trends`, undefined, {query})
            return await resp.json() as {
    data: kb.FeatureTrendsResult[]
}
        }

        /**
         * Check if product has a capability
         */
        public async analyticsHasCapability(params: {
    product: string
    capability: string
}): Promise<kb.HasCapabilityResult> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                capability: params.capability,
                product:    params.product,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/analytics/has-capability`, undefined, {query})
            return await resp.json() as kb.HasCapabilityResult
        }

        /**
         * Get recent features for a product
         */
        public async analyticsRecentFeatures(params: {
    product: string
    days?: number
}): Promise<{
    features: kb.RecentFeatureResult[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                days:    params.days === undefined ? undefined : String(params.days),
                product: params.product,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/analytics/recent`, undefined, {query})
            return await resp.json() as {
    features: kb.RecentFeatureResult[]
}
        }

        /**
         * Search features by semantic query - DEPRECATED: Use /graph/kb/search instead
         */
        public async analyticsSearchFeatures(params: {
    query: string
    product?: string
    topK?: number
}): Promise<{
    features: {
        description: string
        type: string
        category?: string
        releaseDate: string
    }[]
    deprecated: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/analytics/search`, JSON.stringify(params))
            return await resp.json() as {
    features: {
        description: string
        type: string
        category?: string
        releaseDate: string
    }[]
    deprecated: string
}
        }

        /**
         * Get release velocity by product
         */
        public async analyticsVelocity(params: {
    product?: string
    months?: number
}): Promise<{
    data: kb.ReleaseVelocityResult[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                months:  params.months === undefined ? undefined : String(params.months),
                product: params.product,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/analytics/velocity`, undefined, {query})
            return await resp.json() as {
    data: kb.ReleaseVelocityResult[]
}
        }

        /**
         * Get endpoint context (features + documentation)
         */
        public async apiEndpointContext(params: {
    path: string
    method?: string
}): Promise<{
    endpoint: {
        path: string
        method: string
        summary: string
        description: string
        features: {
            id: string
            title: string
            releaseDate: string
            similarity: number
        }[]
        documentation: {
            url: string
            title: string
            similarity: number
        }[]
    } | null
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                method: params.method,
                path:   params.path,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/api/endpoint-context`, undefined, {query})
            return await resp.json() as {
    endpoint: {
        path: string
        method: string
        summary: string
        description: string
        features: {
            id: string
            title: string
            releaseDate: string
            similarity: number
        }[]
        documentation: {
            url: string
            title: string
            similarity: number
        }[]
    } | null
}
        }

        /**
         * Query API endpoints
         */
        public async apiEndpoints(params: kb.EndpointQueryRequest): Promise<{
    endpoints: kb.EndpointWithSchema[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                method:      params.method,
                pathPattern: params.pathPattern,
                resource:    params.resource,
                tag:         params.tag,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/api/endpoints`, undefined, {query})
            return await resp.json() as {
    endpoints: kb.EndpointWithSchema[]
}
        }

        /**
         * Get endpoint schema details
         */
        public async apiSchema(params: {
    method: string
    path: string
}): Promise<{
    endpoint: kb.EndpointWithSchema | null
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                method: params.method,
                path:   params.path,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/api/schema`, undefined, {query})
            return await resp.json() as {
    endpoint: kb.EndpointWithSchema | null
}
        }

        /**
         * Sync API documentation from OpenAPI specs
         */
        public async apiSync(params: {
    category: string
    force?: boolean
}): Promise<{
    success: boolean
    endpointsAdded: number
    endpointsUpdated: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/api/sync`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
    endpointsAdded: number
    endpointsUpdated: number
}
        }

        /**
         * Get detailed run progress for an Apify run
         */
        public async apifyRunProgress(runId: string): Promise<{
    progress?: kb.ApifyRunProgress
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/apify/runs/${encodeURIComponent(runId)}`)
            return await resp.json() as {
    progress?: kb.ApifyRunProgress
    error?: string
}
        }

        /**
         * Stream real-time progress for an Apify run via Server-Sent Events
         */
        public async apifyRunProgressStream(method: "GET", runId: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/graph/kb/apify/runs/${encodeURIComponent(runId)}/stream`, body, options)
        }

        /**
         * Link catalog features to endpoints and KB features
         */
        public async catalogLink(params: {
    endpointThreshold?: number
    kbThreshold?: number
    dryRun?: boolean
}): Promise<{
    toEndpoints: {
        linked: number
        avgSimilarity: number
    }
    toReleaseFeatures: {
        linked: number
        avgSimilarity: number
    }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/catalog/link`, JSON.stringify(params))
            return await resp.json() as {
    toEndpoints: {
        linked: number
        avgSimilarity: number
    }
    toReleaseFeatures: {
        linked: number
        avgSimilarity: number
    }
}
        }

        /**
         * Get catalog quality metrics
         */
        public async catalogQuality(): Promise<kb.CatalogQuality> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/catalog/quality`)
            return await resp.json() as kb.CatalogQuality
        }

        /**
         * Get catalog statistics
         */
        public async catalogStats(): Promise<kb.CatalogStats> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/catalog/stats`)
            return await resp.json() as kb.CatalogStats
        }

        /**
         * Sync product catalog - build graph from stored product/pricing content
         */
        public async catalogSync(): Promise<{
    build: kb.CatalogBuildResult
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/catalog/sync`)
            return await resp.json() as {
    build: kb.CatalogBuildResult
}
        }

        /**
         * List Component nodes from the schema graph
         */
        public async configSchemaComponents(): Promise<{
    components: {
        canonicalName: string
        name: string
        navPath: string | null
        settingsCount: number
        apiEndpointCount: number
        dependencyCount: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/config-schema/components`)
            return await resp.json() as {
    components: {
        canonicalName: string
        name: string
        navPath: string | null
        settingsCount: number
        apiEndpointCount: number
        dependencyCount: number
    }[]
}
        }

        /**
         * Get a single component with full details
         */
        public async configSchemaGetComponent(name: string): Promise<{
    component: {
        canonicalName: string
        name: string
        description: string
        productId: string
        navPath: string | null
        adminUrl: string | null
        confidence: number
        sources: any[]
        aliases: string[]
        settings: any[]
    } | null
    dependencies: {
        canonicalName: string
        name: string
        type: string
        reason: string
    }[]
    dependents: {
        canonicalName: string
        name: string
        type: string
        reason: string
    }[]
    prerequisites: {
        name: string
        type: string
    }[]
    intents: {
        id: string
        query: string
        category: string
    }[]
    methods: {
        type: string
        method?: string
        path?: string
        operationId?: string
        summary?: string
        navPath?: string
        adminUrl?: string
        bindingId?: string
        actions?: string[]
        description?: string
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/config-schema/component/${encodeURIComponent(name)}`)
            return await resp.json() as {
    component: {
        canonicalName: string
        name: string
        description: string
        productId: string
        navPath: string | null
        adminUrl: string | null
        confidence: number
        sources: any[]
        aliases: string[]
        settings: any[]
    } | null
    dependencies: {
        canonicalName: string
        name: string
        type: string
        reason: string
    }[]
    dependents: {
        canonicalName: string
        name: string
        type: string
        reason: string
    }[]
    prerequisites: {
        name: string
        type: string
    }[]
    intents: {
        id: string
        query: string
        category: string
    }[]
    methods: {
        type: string
        method?: string
        path?: string
        operationId?: string
        summary?: string
        navPath?: string
        adminUrl?: string
        bindingId?: string
        actions?: string[]
        description?: string
    }[]
}
        }

        /**
         * Rebuild config schema for all products that have documents in the KB
         */
        public async configSchemaRebuild(params: {
    limit?: number
}): Promise<{
    productsProcessed: number
    totalComponents: number
    totalDependencies: number
    totalDurationMs: number
    perProduct: {
        productId: string
        documentsProcessed: number
        resolvedComponents: number
        resolvedDependencies: number
        durationMs: number
        errors: string[]
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/config-schema/rebuild`, JSON.stringify(params))
            return await resp.json() as {
    productsProcessed: number
    totalComponents: number
    totalDependencies: number
    totalDurationMs: number
    perProduct: {
        productId: string
        documentsProcessed: number
        resolvedComponents: number
        resolvedDependencies: number
        durationMs: number
        errors: string[]
    }[]
}
        }

        /**
         * Resolve a natural language goal into a wave-ordered execution plan
         */
        public async configSchemaResolve(params: {
    goal: string
}): Promise<{
    error: string | null
    match: {
        canonicalName: string
        name: string
        similarity: number
    } | null
    plan: {
        target: string
        targetName: string
        targetNavPath?: string
        waves: {
            wave: number
            components: {
                name: string
                canonicalName: string
                navPath?: string
                reason: string
            }[]
        }[]
        totalSteps: number
    } | null
    methods: { [key: string]: {
        type: string
        method?: string
        path?: string
        operationId?: string
        summary?: string
        navPath?: string
        adminUrl?: string
        bindingId?: string
        actions?: string[]
        description?: string
    }[] }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/config-schema/resolve`, JSON.stringify(params))
            return await resp.json() as {
    error: string | null
    match: {
        canonicalName: string
        name: string
        similarity: number
    } | null
    plan: {
        target: string
        targetName: string
        targetNavPath?: string
        waves: {
            wave: number
            components: {
                name: string
                canonicalName: string
                navPath?: string
                reason: string
            }[]
        }[]
        totalSteps: number
    } | null
    methods: { [key: string]: {
        type: string
        method?: string
        path?: string
        operationId?: string
        summary?: string
        navPath?: string
        adminUrl?: string
        bindingId?: string
        actions?: string[]
        description?: string
    }[] }
}
        }

        /**
         * Get config schema pipeline run history
         */
        public async configSchemaRuns(params: {
    limit?: number
}): Promise<{
    runs: {
        id: string
        productId: string
        state: string
        startedAt: string
        completedAt: string | null
        durationMs: number | null
        docsProcessed: number | null
        objectsExtracted: number | null
        prerequisitesExtracted: number | null
        componentsResolved: number | null
        dependenciesResolved: number | null
        componentsCreated: number | null
        componentsUpdated: number | null
        dependenciesCreated: number | null
        entityRecall: number | null
        dependencyRecall: number | null
        navPathCoverage: number | null
        errors: string[]
    }[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/config-schema/runs`, undefined, {query})
            return await resp.json() as {
    runs: {
        id: string
        productId: string
        state: string
        startedAt: string
        completedAt: string | null
        durationMs: number | null
        docsProcessed: number | null
        objectsExtracted: number | null
        prerequisitesExtracted: number | null
        componentsResolved: number | null
        dependenciesResolved: number | null
        componentsCreated: number | null
        componentsUpdated: number | null
        dependenciesCreated: number | null
        entityRecall: number | null
        dependencyRecall: number | null
        navPathCoverage: number | null
        errors: string[]
    }[]
}
        }

        /**
         * Search for components by natural language query
         */
        public async configSchemaSearch(params: {
    query: string
    limit?: number
}): Promise<{
    results: {
        canonicalName: string
        name: string
        description: string
        similarity: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/config-schema/search`, JSON.stringify(params))
            return await resp.json() as {
    results: {
        canonicalName: string
        name: string
        description: string
        similarity: number
    }[]
}
        }

        /**
         * Get current config schema pipeline state and graph stats
         */
        public async configSchemaStatus(): Promise<{
    state: string
    lastRunStartedAt: string | null
    lastRunCompletedAt: string | null
    lastRunDurationMs: number | null
    lastRunComponents: number | null
    lastRunDependencies: number | null
    lastRunError: string | null
    updatedAt: string
    graph: {
        totalComponents: number
        totalDependencies: number
        withNavPath: number
        withApiEndpoints: number
        withSettings: number
    }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/config-schema/status`)
            return await resp.json() as {
    state: string
    lastRunStartedAt: string | null
    lastRunCompletedAt: string | null
    lastRunDurationMs: number | null
    lastRunComponents: number | null
    lastRunDependencies: number | null
    lastRunError: string | null
    updatedAt: string
    graph: {
        totalComponents: number
        totalDependencies: number
        withNavPath: number
        withApiEndpoints: number
        withSettings: number
    }
}
        }

        /**
         * Crawl overview — summary of latest crawl per source (replaces relay admin endpoint)
         */
        public async crawlOverview(): Promise<{
    sources: {
        sourceId: string
        latestRunId: string
        latestCrawledAt: string
        itemCount: number
        actorId: string | null
        totalRuns: number
        ageHours: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/crawl-overview`)
            return await resp.json() as {
    sources: {
        sourceId: string
        latestRunId: string
        latestCrawledAt: string
        itemCount: number
        actorId: string | null
        totalRuns: number
        ageHours: number
    }[]
}
        }

        /**
         * Abort a running sync.
         * Only works if the sync is in CRAWLING state.
         */
        public async dataSourceAbortSync(id: string, params: {
    graceful?: boolean
}): Promise<{
    status: "aborted" | "not_running" | "error"
    runId?: string
    state?: string
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/data-sources/${encodeURIComponent(id)}/sync/abort`, JSON.stringify(params))
            return await resp.json() as {
    status: "aborted" | "not_running" | "error"
    runId?: string
    state?: string
    error?: string
}
        }

        /**
         * Analyze a dataset before importing - preview coverage impact
         */
        public async dataSourceAnalyze(id: string): Promise<{
    analysis?: kb.DatasetAnalysis
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}/analyze`)
            return await resp.json() as {
    analysis?: kb.DatasetAnalysis
    error?: string
}
        }

        /**
         * Analyze source topics - works with any source type (OpenAPI, Apify, API, File)
         */
        public async dataSourceAnalyzeTopics(id: string): Promise<{
    analysis?: kb.SourceAnalysis
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}/topics`)
            return await resp.json() as {
    analysis?: kb.SourceAnalysis
    error?: string
}
        }

        /**
         * Get unified sync status with full progress info.
         * Includes both local state machine state and live Apify progress.
         */
        public async dataSourceCheckSync(id: string): Promise<{
    state: string
    runId?: string
    startedAt?: number
    progress?: {
        pagesCrawled?: number
        pagesTotal?: number
        itemsFetched?: number
        itemsImported?: number
        message?: string
    }
    apifyProgress?: kb.ApifyRunProgress
    error?: string
    stats?: {
        itemCount: number
        importedCount: number
        lastSynced: number | null
    }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}/sync/status`)
            return await resp.json() as {
    state: string
    runId?: string
    startedAt?: number
    progress?: {
        pagesCrawled?: number
        pagesTotal?: number
        itemsFetched?: number
        itemsImported?: number
        message?: string
    }
    apifyProgress?: kb.ApifyRunProgress
    error?: string
    stats?: {
        itemCount: number
        importedCount: number
        lastSynced: number | null
    }
}
        }

        /**
         * Keep old endpoint path for backwards compatibility
         */
        public async dataSourceCheckSyncLegacy(id: string): Promise<{
    progress?: kb.ApifyRunProgress
    status?: string
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}/sync-status`)
            return await resp.json() as {
    progress?: kb.ApifyRunProgress
    status?: string
    error?: string
}
        }

        /**
         * List stored crawl summaries for a data source
         */
        public async dataSourceCrawlHistory(id: string): Promise<{
    crawls: kb.StoredCrawlSummary[]
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}/crawls`)
            return await resp.json() as {
    crawls: kb.StoredCrawlSummary[]
    error?: string
}
        }

        /**
         * Delete a data source
         */
        public async dataSourceDelete(id: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/graph/kb/data-sources/${encodeURIComponent(id)}`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Compare two crawl runs for a data source
         */
        public async dataSourceDiffCrawls(id: string, params: {
    base: string
    compare: string
    status?: string
}): Promise<{
    diff?: kb.CrawlDiff
    error?: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                base:    params.base,
                compare: params.compare,
                status:  params.status,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}/crawls/diff`, undefined, {query})
            return await resp.json() as {
    diff?: kb.CrawlDiff
    error?: string
}
        }

        /**
         * Get line-by-line content diff for a specific URL between two crawl runs
         */
        public async dataSourceDiffItem(id: string, params: {
    base: string
    compare: string
    url: string
}): Promise<{
    diff?: kb.ContentDiff
    error?: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                base:    params.base,
                compare: params.compare,
                url:     params.url,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}/crawls/diff/item`, undefined, {query})
            return await resp.json() as {
    diff?: kb.ContentDiff
    error?: string
}
        }

        /**
         * Get a single data source
         */
        public async dataSourceGet(id: string): Promise<kb.DataSourceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}`)
            return await resp.json() as kb.DataSourceResponse
        }

        /**
         * Get crawl data with paginated items
         */
        public async dataSourceGetCrawl(id: string, runId: string, params: {
    offset?: number
    limit?: number
}): Promise<{
    crawl?: {
        sourceId: string
        runId: string
        datasetId: string
        crawledAt: string
        itemCount: number
        actorId: string
        memoryMb: number
    }
    items?: {
        index: number
        url: string
        title: string
        contentLength: number
        contentPreview: string
    }[]
    pagination?: {
        offset: number
        limit: number
        total: number
        hasMore: boolean
    }
    error?: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}/crawls/${encodeURIComponent(runId)}`, undefined, {query})
            return await resp.json() as {
    crawl?: {
        sourceId: string
        runId: string
        datasetId: string
        crawledAt: string
        itemCount: number
        actorId: string
        memoryMb: number
    }
    items?: {
        index: number
        url: string
        title: string
        contentLength: number
        contentPreview: string
    }[]
    pagination?: {
        offset: number
        limit: number
        total: number
        hasMore: boolean
    }
    error?: string
}
        }

        /**
         * Get a single crawl item with full content
         */
        public async dataSourceGetCrawlItem(id: string, runId: string, index: number): Promise<{
    item?: {
        index: number
        url: string
        title: string
        markdown: string
        html?: string
        screenshotUrl?: string
        crawledAt?: string
        metadata?: { [key: string]: any }
    }
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/${encodeURIComponent(id)}/crawls/${encodeURIComponent(runId)}/items/${encodeURIComponent(index)}`)
            return await resp.json() as {
    item?: {
        index: number
        url: string
        title: string
        markdown: string
        html?: string
        screenshotUrl?: string
        crawledAt?: string
        metadata?: { [key: string]: any }
    }
    error?: string
}
        }

        public async dataSourceGraphMapping(params: {
    url: string
}): Promise<{
    mapping?: kb.GraphMapping
    error?: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                url: params.url,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/graph-mapping`, undefined, {query})
            return await resp.json() as {
    mapping?: kb.GraphMapping
    error?: string
}
        }

        /**
         * Reprocess crawl data from local storage without re-crawling
         */
        public async dataSourceReprocess(id: string, params: {
    runId?: string
    limit?: number
}): Promise<{
    imported: number
    skipped: number
    releasesFound: number
    featuresStored: number
    errors: string[]
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/data-sources/${encodeURIComponent(id)}/reprocess`, JSON.stringify(params))
            return await resp.json() as {
    imported: number
    skipped: number
    releasesFound: number
    featuresStored: number
    errors: string[]
    message: string
}
        }

        /**
         * Resume orphaned syncs that were interrupted by a restart.
         * Call this after a server restart to pick up incomplete syncs.
         */
        public async dataSourceResumeOrphaned(): Promise<{
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/data-sources/resume-orphaned`)
            return await resp.json() as {
    message: string
}
        }

        /**
         * Set Apify dataset for a data source
         */
        public async dataSourceSetDataset(id: string, params: {
    datasetId: string
    runId?: string
    itemCount?: number
}): Promise<kb.DataSourceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/data-sources/${encodeURIComponent(id)}/dataset`, JSON.stringify(params))
            return await resp.json() as kb.DataSourceResponse
        }

        /**
         * Start a sync/crawl for an Apify data source.
         * 
         * Features:
         * - Duplicate protection: Won't start a new sync if one is already running
         * - Cache check: Returns cached data if fresh (< 14 days) unless force=true
         * - Async-first: Returns immediately with runId for SSE progress tracking
         * - State machine: Proper state transitions with progress tracking
         */
        public async dataSourceStartSync(id: string, params: {
    force?: boolean
}): Promise<{
    status: "started" | "already_running" | "cached"
    runId?: string
    state: string
    startedAt?: number
    cachedAt?: number
    ageDays?: number
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/data-sources/${encodeURIComponent(id)}/sync`, JSON.stringify(params))
            return await resp.json() as {
    status: "started" | "already_running" | "cached"
    runId?: string
    state: string
    startedAt?: number
    cachedAt?: number
    ageDays?: number
    error?: string
}
        }

        /**
         * Stream real-time sync progress for a data source via Server-Sent Events.
         * This is the new unified stream that shows all sync states, not just Apify progress.
         */
        public async dataSourceSyncStream(method: "GET", id: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/graph/kb/data-sources/${encodeURIComponent(id)}/sync/stream`, body, options)
        }

        /**
         * Update data source stats after import
         */
        public async dataSourceUpdateStats(id: string, params: {
    itemCount?: number
    importedCount?: number
    lastSynced?: number
    lastImported?: number
}): Promise<kb.DataSourceResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/data-sources/${encodeURIComponent(id)}/stats`, JSON.stringify(params))
            return await resp.json() as kb.DataSourceResponse
        }

        /**
         * Create or update a data source
         */
        public async dataSourceUpsert(params: kb.DataSourceInput): Promise<kb.DataSource> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/data-sources`, JSON.stringify(params))
            return await resp.json() as kb.DataSource
        }

        /**
         * Get all data sources
         */
        public async dataSourcesList(): Promise<{
    sources: kb.DataSource[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources`)
            return await resp.json() as {
    sources: kb.DataSource[]
}
        }

        /**
         * Reseed default data sources - adds any new sources from DEFAULT_DATA_SOURCES
         */
        public async dataSourcesReseed(): Promise<{
    seeded: string[]
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/data-sources/reseed`)
            return await resp.json() as {
    seeded: string[]
    message: string
}
        }

        /**
         * Get data sources summary for admin UI
         */
        public async dataSourcesSummary(): Promise<kb.DataSourcesSummaryResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/data-sources/summary`)
            return await resp.json() as kb.DataSourcesSummaryResponse
        }

        /**
         * Export the entire graph as JSON
         */
        public async exportGraph(params: {
    excludeEmbeddings?: boolean
    excludeMarkdown?: boolean
    nodeTypes?: string[]
    limit?: number
    offset?: number
}): Promise<kb.GraphExport> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/export`, JSON.stringify(params))
            return await resp.json() as kb.GraphExport
        }

        /**
         * Extract guides from KB articles
         */
        public async extractGuides(params: {
    products?: string[]
    limit?: number
}): Promise<kb.GuideExtractionResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/guides/extract`, JSON.stringify(params))
            return await resp.json() as kb.GuideExtractionResult
        }

        /**
         * Find endpoints for a capability
         */
        public async findEndpoints(params: {
    capability: string
    topK?: number
    threshold?: number
}): Promise<{
    endpoints: {
        method: string
        path: string
        summary: string
        similarity: number
        fromStep?: {
            action: string
            description: string
        }
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/guides/endpoints`, JSON.stringify(params))
            return await resp.json() as {
    endpoints: {
        method: string
        path: string
        summary: string
        similarity: number
        fromStep?: {
            action: string
            description: string
        }
    }[]
}
        }

        /**
         * Get a single product by ID
         */
        public async getCatalogProduct(id: string): Promise<{
    product: kb.CatalogProduct | null
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/catalog/products/${encodeURIComponent(id)}`)
            return await resp.json() as {
    product: kb.CatalogProduct | null
}
        }

        /**
         * Get configuration guide by ID
         */
        public async getGuide(guideId: string): Promise<{
    guide: kb.GuideWithLinks | null
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/guides/${encodeURIComponent(guideId)}`)
            return await resp.json() as {
    guide: kb.GuideWithLinks | null
}
        }

        /**
         * Get guide linking statistics
         */
        public async getGuideLinkStatsEndpoint(): Promise<{
    totalSteps: number
    linkedSteps: number
    unlinkedSteps: number
    byMatchType: { [key: string]: number }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/guides/link-stats`)
            return await resp.json() as {
    totalSteps: number
    linkedSteps: number
    unlinkedSteps: number
    byMatchType: { [key: string]: number }
}
        }

        /**
         * Get prerequisites for a capability
         */
        public async getPrerequisites(params: {
    capability: string
}): Promise<{
    prerequisites: kb.PrerequisiteNode[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/guides/prerequisites`, JSON.stringify(params))
            return await resp.json() as {
    prerequisites: kb.PrerequisiteNode[]
}
        }

        /**
         * Paginated query log for data scientist
         */
        public async getQueryLog(params: {
    limit?: number
    offset?: number
    requestId?: string
}): Promise<{
    entries: kb.QueryLogEntry[]
    total: number
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:     params.limit === undefined ? undefined : String(params.limit),
                offset:    params.offset === undefined ? undefined : String(params.offset),
                requestId: params.requestId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/query-log`, undefined, {query})
            return await resp.json() as {
    entries: kb.QueryLogEntry[]
    total: number
}
        }

        /**
         * Single query log entry with full details
         */
        public async getQueryLogEntry(id: string): Promise<{
    entry: kb.QueryLogEntry | null
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/query-log/${encodeURIComponent(id)}`)
            return await resp.json() as {
    entry: kb.QueryLogEntry | null
}
        }

        /**
         * Aggregate stats for dashboard
         */
        public async getQueryLogStats(): Promise<{
    avgTotalLatencyMs: number
    avgDocVectorLatencyMs: number
    avgFeatureVectorLatencyMs: number
    avgRerankLatencyMs: number
    avgFinalCount: number
    avgMergedCount: number
    avgFilteredOut: number
    totalQueries: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/query-log/stats`)
            return await resp.json() as {
    avgTotalLatencyMs: number
    avgDocVectorLatencyMs: number
    avgFeatureVectorLatencyMs: number
    avgRerankLatencyMs: number
    avgFinalCount: number
    avgMergedCount: number
    avgFilteredOut: number
    totalQueries: number
}
        }

        /**
         * Get graph health status
         */
        public async graphHealth(): Promise<kb.GraphHealth> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/health`)
            return await resp.json() as kb.GraphHealth
        }

        /**
         * Run health check for specific category
         */
        public async healthCheckCategory(category: string): Promise<kb.HealthCheckSummary> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/health/category/${encodeURIComponent(category)}`)
            return await resp.json() as kb.HealthCheckSummary
        }

        /**
         * Run full health check with all queries
         */
        public async healthCheckFull(): Promise<kb.HealthCheckSummary> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/health`)
            return await resp.json() as kb.HealthCheckSummary
        }

        /**
         * Get list of all health check queries
         */
        public async healthCheckQueries(): Promise<{
    categories: { [key: string]: {
        name: string
        description: string
    } }
    queries: {
        id: string
        category: string
        question: string
        description: string
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/health/queries`)
            return await resp.json() as {
    categories: { [key: string]: {
        name: string
        description: string
    } }
    queries: {
        id: string
        category: string
        question: string
        description: string
    }[]
}
        }

        /**
         * Run quick health check (validation queries only, no search)
         */
        public async healthCheckQuick(): Promise<kb.HealthCheckSummary> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/health/quick`)
            return await resp.json() as kb.HealthCheckSummary
        }

        /**
         * Run specific health check query by ID
         */
        public async healthCheckSingle(queryId: string): Promise<kb.HealthCheckSummary> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/health/query/${encodeURIComponent(queryId)}`)
            return await resp.json() as kb.HealthCheckSummary
        }

        /**
         * Import an existing Apify run by run ID (doesn't start a new crawl)
         */
        public async importApifyRun(params: {
    runId: string
    sourceId: string
}): Promise<{
    success: boolean
    runId: string
    datasetId?: string
    itemCount?: number
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/import-apify-run`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
    runId: string
    datasetId?: string
    itemCount?: number
    error?: string
}
        }

        /**
         * Import a previously exported graph
         */
        public async importGraph(params: {
    data: kb.GraphExport
    clearFirst?: boolean
}): Promise<{
    nodesImported: number
    relationshipsImported: number
    errors: string[]
    duration: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/admin/import`, JSON.stringify(params))
            return await resp.json() as {
    nodesImported: number
    relationshipsImported: number
    errors: string[]
    duration: number
}
        }

        /**
         * Import an OpenAPI spec from local file into the graph
         */
        public async importOpenAPISpec(id: string): Promise<{
    success: boolean
    sourceId: string
    endpointsImported: number
    resourcesCreated: number
    scopesCreated: number
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/openapi/${encodeURIComponent(id)}/import`)
            return await resp.json() as {
    success: boolean
    sourceId: string
    endpointsImported: number
    resourcesCreated: number
    scopesCreated: number
    error?: string
}
        }

        /**
         * Link guide steps to API endpoints
         */
        public async linkGuideSteps(params: {
    guideId?: string
}): Promise<{
    linked: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/guides/link`, JSON.stringify(params))
            return await resp.json() as {
    linked: number
}
        }

        /**
         * List all products with full catalog data
         */
        public async listCatalogProducts(): Promise<{
    products: kb.CatalogProduct[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/catalog/products`)
            return await resp.json() as {
    products: kb.CatalogProduct[]
}
        }

        /**
         * Get product categories
         */
        public async listProductCategories(): Promise<{
    categories: kb.ProductCategory[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/catalog/categories`)
            return await resp.json() as {
    categories: kb.ProductCategory[]
}
        }

        /**
         * Get product families
         */
        public async listProductFamilies(): Promise<{
    families: kb.ProductFamily[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/catalog/families`)
            return await resp.json() as {
    families: kb.ProductFamily[]
}
        }

        /**
         * Get concept coverage for a specific product
         */
        public async pipelineConceptCoverage(productId: string): Promise<kb.ProductConceptCoverage> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/concept-coverage/${encodeURIComponent(productId)}`)
            return await resp.json() as kb.ProductConceptCoverage
        }

        /**
         * Get single document detail with graph mapping
         */
        public async pipelineDocumentDetail(params: {
    url: string
}): Promise<{
    document: kb.PipelineArtifact | null
    mapping?: kb.GraphMapping
    error?: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                url: params.url,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/documents/detail`, undefined, {query})
            return await resp.json() as {
    document: kb.PipelineArtifact | null
    mapping?: kb.GraphMapping
    error?: string
}
        }

        /**
         * Search/list documents with filters and pagination
         */
        public async pipelineDocuments(params: {
    state?: string
    source?: string
    search?: string
    limit?: number
    offset?: number
}): Promise<{
    documents: kb.PipelineArtifact[]
    total: number
    sources: string[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
                search: params.search,
                source: params.source,
                state:  params.state,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/documents`, undefined, {query})
            return await resp.json() as {
    documents: kb.PipelineArtifact[]
    total: number
    sources: string[]
}
        }

        /**
         * Raw inputs inventory - shows counts of all data sources before graph building
         */
        public async pipelineInventory(): Promise<{
    documents: {
        total: number
        byType: { [key: string]: number }
    }
    endpoints: {
        total: number
        byCategory: { [key: string]: number }
    }
    features: {
        total: number
        byProduct: { [key: string]: number }
    }
    products: number
    guides: number
    lastUpdated: string | null
    apify?: {
        latestRun?: {
            runId: string
            status: string
            itemCount: number
            finishedAt: string | null
        }
        totalAvailable: number
    }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/inventory`)
            return await resp.json() as {
    documents: {
        total: number
        byType: { [key: string]: number }
    }
    endpoints: {
        total: number
        byCategory: { [key: string]: number }
    }
    features: {
        total: number
        byProduct: { [key: string]: number }
    }
    products: number
    guides: number
    lastUpdated: string | null
    apify?: {
        latestRun?: {
            runId: string
            status: string
            itemCount: number
            finishedAt: string | null
        }
        totalAvailable: number
    }
}
        }

        /**
         * Get KG state machine state + document processing summary
         */
        public async pipelineKGState(): Promise<{
    kgState: kb.KGStateInfo
    documentStatus: { [key: string]: number }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/kg-state`)
            return await resp.json() as {
    kgState: kb.KGStateInfo
    documentStatus: { [key: string]: number }
}
        }

        /**
         * Get latest rebuild report
         */
        public async pipelineLatestReport(): Promise<kb.RebuildReportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/report`)
            return await resp.json() as kb.RebuildReportResponse
        }

        /**
         * Get operation coverage matrix - shows which admin operations have docs per product
         */
        public async pipelineOperationCoverage(): Promise<{
    products: kb.ProductOperationCoverage[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/operation-coverage`)
            return await resp.json() as {
    products: kb.ProductOperationCoverage[]
}
        }

        /**
         * Get product coverage data - shows content coverage per product
         */
        public async pipelineProductCoverage(): Promise<{
    products: kb.ProductCoverageItem[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/product-coverage`)
            return await resp.json() as {
    products: kb.ProductCoverageItem[]
}
        }

        /**
         * Full rebuild — clears graph, artifacts, and KG state, then rebuilds from crawl data
         */
        public async pipelineRebuild(params: {
    limit?: number
}): Promise<{
    success: boolean
    duration: number
    docsEmitted: number
    docsSkipped: number
    docsFailed: number
    sources: { [key: string]: {
        loaded: number
        emitted: number
        skipped: number
    } }
    errors: string[]
    report?: kb.RebuildReport
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/pipeline/rebuild`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
    duration: number
    docsEmitted: number
    docsSkipped: number
    docsFailed: number
    sources: { [key: string]: {
        loaded: number
        emitted: number
        skipped: number
    } }
    errors: string[]
    report?: kb.RebuildReport
}
        }

        /**
         * Get rebuild report by run ID
         */
        public async pipelineReport(runId: string): Promise<kb.RebuildReportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/report/${encodeURIComponent(runId)}`)
            return await resp.json() as kb.RebuildReportResponse
        }

        /**
         * List all rebuild reports
         */
        public async pipelineReportsList(): Promise<{
    reports: kb.RebuildReport[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/reports`)
            return await resp.json() as {
    reports: kb.RebuildReport[]
}
        }

        /**
         * Retry failed artifacts — resets to pending and re-emits with staggered pacing
         */
        public async pipelineRetryFailed(): Promise<{
    retried: number
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/pipeline/retry-failed`)
            return await resp.json() as {
    retried: number
    message: string
}
        }

        /**
         * Get pipeline status - what's in the graph + KG state + document status
         */
        public async pipelineStatus(): Promise<void> {
            await this.baseClient.callTypedAPI("GET", `/graph/kb/pipeline/status`)
        }

        /**
         * Sync developer docs from developers.zoom.us via Apify
         */
        public async pipelineSyncDevDocs(params: {
    force?: boolean
    existingRunId?: string
    maxPages?: number
}): Promise<{
    documentsStored: number
    documentsSkipped: number
    errors: string[]
    duration: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/pipeline/sync-devdocs`, JSON.stringify(params))
            return await resp.json() as {
    documentsStored: number
    documentsSkipped: number
    errors: string[]
    duration: number
}
        }

        /**
         * Sync KB articles from support.zoom.com via Apify
         */
        public async pipelineSyncKB(params: {
    force?: boolean
    existingRunId?: string
    maxPages?: number
}): Promise<{
    articlesStored: number
    articlesSkipped: number
    errors: string[]
    duration: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/pipeline/sync-kb`, JSON.stringify(params))
            return await resp.json() as {
    articlesStored: number
    articlesSkipped: number
    errors: string[]
    duration: number
}
        }

        /**
         * Sync library content from library.zoom.com via Apify
         */
        public async pipelineSyncLibrary(params: {
    force?: boolean
    existingRunId?: string
    maxPages?: number
}): Promise<{
    documentsStored: number
    documentsSkipped: number
    errors: string[]
    duration: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/pipeline/sync-library`, JSON.stringify(params))
            return await resp.json() as {
    documentsStored: number
    documentsSkipped: number
    errors: string[]
    duration: number
}
        }

        /**
         * Get configuration path for a capability
         */
        public async queryConfigPath(params: {
    query: string
    product?: string
}): Promise<{
    capability: string
    configSteps: {
        feature: {
            title: string
            description: string
            releaseDate: string
        }
        endpoints: {
            method: string
            path: string
            summary: string
        }[]
        documentation: {
            title: string
            url: string
        }[]
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/query/config-path`, JSON.stringify(params))
            return await resp.json() as {
    capability: string
    configSteps: {
        feature: {
            title: string
            description: string
            releaseDate: string
        }
        endpoints: {
            method: string
            path: string
            summary: string
        }[]
        documentation: {
            title: string
            url: string
        }[]
    }[]
}
        }

        /**
         * Search KB content (raw articles)
         */
        public async queryContent(params: {
    query: string
    topK?: number
    threshold?: number
}): Promise<{
    results: kb.DocumentSearchResult[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/query/content`, JSON.stringify(params))
            return await resp.json() as {
    results: kb.DocumentSearchResult[]
}
        }

        /**
         * Search features by semantic similarity
         */
        public async queryFeatures(params: {
    query: string
    product?: string
    topK?: number
}): Promise<{
    results: {
        id: string
        title: string
        description: string
        type: string
        productId: string
        releaseDate: string
        capabilities: string[]
        similarity: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/query/features`, JSON.stringify(params))
            return await resp.json() as {
    results: {
        id: string
        title: string
        description: string
        type: string
        productId: string
        releaseDate: string
        capabilities: string[]
        similarity: number
    }[]
}
        }

        /**
         * Get features added in a date range
         */
        public async queryFeaturesInRange(params: {
    startDate: string
    endDate: string
    product?: string
    limit?: number
}): Promise<{
    features: {
        id: string
        title: string
        description: string
        type: string
        productId: string
        releaseDate: string
    }[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                endDate:   params.endDate,
                limit:     params.limit === undefined ? undefined : String(params.limit),
                product:   params.product,
                startDate: params.startDate,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/query/features-in-range`, undefined, {query})
            return await resp.json() as {
    features: {
        id: string
        title: string
        description: string
        type: string
        productId: string
        releaseDate: string
    }[]
}
        }

        /**
         * Query the knowledge graph - features, endpoints, and documentation
         */
        public async queryKnowledgeGraph(params: {
    query: string
    topK?: number
    threshold?: number
    product?: string
}): Promise<{
    features: {
        id: string
        title: string
        description: string
        type: string
        productId: string
        releaseDate: string
        similarity: number
        endpoints: {
            path: string
            method: string
            summary: string
            similarity: number
        }[]
        documentation: {
            url: string
            title: string
            similarity: number
        }[]
    }[]
    endpoints: {
        path: string
        method: string
        summary: string
        description: string
        productId?: string
        features: {
            id: string
            title: string
            releaseDate: string
            similarity: number
        }[]
        documentation: {
            url: string
            title: string
            similarity: number
        }[]
    }[]
    documentation: {
        url: string
        title: string
        snippet: string
        similarity: number
        features: {
            id: string
            title: string
            releaseDate: string
        }[]
        endpoints: {
            path: string
            method: string
            summary: string
        }[]
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/query`, JSON.stringify(params))
            return await resp.json() as {
    features: {
        id: string
        title: string
        description: string
        type: string
        productId: string
        releaseDate: string
        similarity: number
        endpoints: {
            path: string
            method: string
            summary: string
            similarity: number
        }[]
        documentation: {
            url: string
            title: string
            similarity: number
        }[]
    }[]
    endpoints: {
        path: string
        method: string
        summary: string
        description: string
        productId?: string
        features: {
            id: string
            title: string
            releaseDate: string
            similarity: number
        }[]
        documentation: {
            url: string
            title: string
            similarity: number
        }[]
    }[]
    documentation: {
        url: string
        title: string
        snippet: string
        similarity: number
        features: {
            id: string
            title: string
            releaseDate: string
        }[]
        endpoints: {
            path: string
            method: string
            summary: string
        }[]
    }[]
}
        }

        /**
         * Find similar features - DEPRECATED: Use /graph/kb/search instead
         */
        public async querySimilar(params: {
    query: string
    product?: string
    topK?: number
}): Promise<{
    results: {
        url: string
        title: string
        snippet: string
        product?: string
        publishedAt?: string
        similarity: number
    }[]
    deprecated: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/query/similar`, JSON.stringify(params))
            return await resp.json() as {
    results: {
        url: string
        title: string
        snippet: string
        product?: string
        publishedAt?: string
        similarity: number
    }[]
    deprecated: string
}
        }

        /**
         * Find when a capability was added
         */
        public async queryWhenAdded(params: {
    query: string
    product?: string
}): Promise<{
    found: boolean
    feature?: {
        title: string
        description: string
        releaseDate: string
        productId: string
        url?: string
    }
    relatedFeatures: {
        title: string
        releaseDate: string
        similarity: number
    }[]
    fromArticle?: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/query/when-added`, JSON.stringify(params))
            return await resp.json() as {
    found: boolean
    feature?: {
        title: string
        description: string
        releaseDate: string
        productId: string
        url?: string
    }
    relatedFeatures: {
        title: string
        releaseDate: string
        similarity: number
    }[]
    fromArticle?: boolean
}
        }

        /**
         * Get features added in a date range
         */
        public async releaseFeaturesByDate(params: {
    product: string
    startDate: string
    endDate: string
}): Promise<{
    features: {
        description: string
        type: string
        date: string
        category?: string
    }[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                endDate:   params.endDate,
                product:   params.product,
                startDate: params.startDate,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/releases/features`, undefined, {query})
            return await resp.json() as {
    features: {
        description: string
        type: string
        date: string
        category?: string
    }[]
}
        }

        /**
         * Sync release notes for all products
         */
        public async releaseNotesSync(params: {
    products?: string[]
}): Promise<kb.SyncAllResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/releases/sync`, JSON.stringify(params))
            return await resp.json() as kb.SyncAllResult
        }

        /**
         * Sync release notes for a single product
         */
        public async releaseNotesSyncProduct(product: string): Promise<kb.ReleaseNotesSyncResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/releases/sync/${encodeURIComponent(product)}`)
            return await resp.json() as kb.ReleaseNotesSyncResult
        }

        /**
         * List available products for release notes
         */
        public async releaseProducts(): Promise<{
    products: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/releases/products`)
            return await resp.json() as {
    products: string[]
}
        }

        /**
         * Get release timeline for a product
         */
        public async releaseTimeline(product: string): Promise<{
    releases: {
        date: string
        featureCount: number
        fixCount: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/releases/timeline/${encodeURIComponent(product)}`)
            return await resp.json() as {
    releases: {
        date: string
        featureCount: number
        fixCount: number
    }[]
}
        }

        /**
         * Query when a capability was added to a product
         */
        public async releaseWhenAdded(params: {
    product: string
    query: string
}): Promise<{
    found: boolean
    date?: string
    description?: string
    releaseUrl?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/releases/when-added`, JSON.stringify(params))
            return await resp.json() as {
    found: boolean
    date?: string
    description?: string
    releaseUrl?: string
}
        }

        /**
         * Audit all OAuth scopes required by endpoints in the graph
         */
        public async scopeAudit(params: {
    tenantId?: string
    usedOnly?: boolean
}): Promise<kb.ScopeAuditResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                tenantId: params.tenantId,
                usedOnly: params.usedOnly === undefined ? undefined : String(params.usedOnly),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/scope-audit`, undefined, {query})
            return await resp.json() as kb.ScopeAuditResponse
        }

        /**
         * Search for guides by capability or query
         */
        public async searchGuidesEndpoint(params: {
    query: string
    product?: string
    topK?: number
}): Promise<{
    guides: kb.GuideSearchResult[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/guides/search`, JSON.stringify(params))
            return await resp.json() as {
    guides: kb.GuideSearchResult[]
}
        }

        /**
         * Seed catalog with initial product metadata (one-time operation)
         */
        public async seedCatalog(): Promise<{
    families: number
    categories: number
    products: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/catalog/seed`)
            return await resp.json() as {
    families: number
    categories: number
    products: number
}
        }

        /**
         * Delete a temporary graph
         */
        public async tempGraphDelete(graphName: string): Promise<{
    deleted: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/graph/kb/temp-graph/${encodeURIComponent(graphName)}`)
            return await resp.json() as {
    deleted: boolean
}
        }

        /**
         * Get full content of a crawl item (for viewing in temp graph browser)
         */
        public async tempGraphGetItem(params: {
    sourceId: string
    runId: string
    url: string
}): Promise<{
    item: kb.ApifyCrawlResult | null
    error?: string
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                runId:    params.runId,
                sourceId: params.sourceId,
                url:      params.url,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/temp-graph/item`, undefined, {query})
            return await resp.json() as {
    item: kb.ApifyCrawlResult | null
    error?: string
}
        }

        /**
         * List all active temporary graphs
         */
        public async tempGraphList(): Promise<{
    graphs: {
        graphName: string
        createdAt: number
        itemCount: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/temp-graphs`)
            return await resp.json() as {
    graphs: {
        graphName: string
        createdAt: number
        itemCount: number
    }[]
}
        }

        /**
         * Load a crawl run into a temporary FalkorDB graph for exploration
         */
        public async tempGraphLoad(params: {
    sourceId: string
    runId: string
    skipReleaseNotes?: boolean
}): Promise<{
    graphName: string
    itemCount: number
    nodeTypes: { [key: string]: number }
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/temp-graph/load`, JSON.stringify(params))
            return await resp.json() as {
    graphName: string
    itemCount: number
    nodeTypes: { [key: string]: number }
    error?: string
}
        }

        /**
         * Query a temporary graph with Cypher
         */
        public async tempGraphQuery(params: {
    graphName: string
    query: string
    params?: { [key: string]: any }
}): Promise<{
    data: any[]
    columns: string[]
    executionTime: number
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/temp-graph/query`, JSON.stringify(params))
            return await resp.json() as {
    data: any[]
    columns: string[]
    executionTime: number
    error?: string
}
        }

        /**
         * Get stats for a temporary graph
         */
        public async tempGraphStats(graphName: string): Promise<{
    exists: boolean
    nodeCount: number
    nodeTypes: { [key: string]: number }
    createdAt?: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/graph/kb/temp-graph/${encodeURIComponent(graphName)}/stats`)
            return await resp.json() as {
    exists: boolean
    nodeCount: number
    nodeTypes: { [key: string]: number }
    createdAt?: number
}
        }

        /**
         * Test release note extraction on a single URL
         */
        public async testReleaseExtraction(params: {
    url: string
    markdown: string
}): Promise<{
    title: string
    product: string | null
    releasesFound: number
    featuresStored: number
    releases: {
        date: string
        featureCount: number
    }[]
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/test-release-extraction`, JSON.stringify(params))
            return await resp.json() as {
    title: string
    product: string | null
    releasesFound: number
    featuresStored: number
    releases: {
        date: string
        featureCount: number
    }[]
    error?: string
}
        }

        /**
         * Unified search across all knowledge graph content
         */
        public async unifiedSearch(params: {
    query: string
    topK?: number
    threshold?: number
    product?: string
    sourceTypes?: kb.SourceType[]
}): Promise<{
    results: kb.SearchResult[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/search`, JSON.stringify(params))
            return await resp.json() as {
    results: kb.SearchResult[]
}
        }

        /**
         * Update product metadata
         */
        public async updateProductMetadata(id: string, params: {
    aliases?: string[]
    apiPrefix?: string
    licenseCheckEndpoint?: string
    releaseNotesQuery?: string
    productPageUrl?: string
    pricingPageUrl?: string
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/graph/kb/catalog/products/${encodeURIComponent(id)}/metadata`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Vectorize endpoints that don't have embeddings yet
         */
        public async vectorizeEndpoints(params: {
    batchSize?: number
}): Promise<{
    success: boolean
    processed: number
    remaining: number
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/graph/kb/endpoints/vectorize`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
    processed: number
    remaining: number
    error?: string
}
        }
    }
}

export namespace mcp_zoom {
    export interface LiveStreamHandshake {
        accountId?: string
        token?: string
        /**
         * Polling interval in seconds (default 30, min 10)
         */
        interval?: number
    }

    export interface LiveStreamMessage {
        type: string
        totalLive?: number
        meetings?: string
        timestamp?: string
        message?: string
    }

    export interface OverviewRequest {
        accountId?: string
    }

    export interface OverviewStreamHandshake {
        accountId?: string
        token?: string
    }

    export interface OverviewStreamMessage {
        type: string
        /**
         * Step fields
         */
        name?: string

        label?: string
        stepStatus?: string
        completed?: number
        total?: number
        /**
         * Section fields
         */
        data?: string

        /**
         * Done fields
         */
        fetchedAt?: string

        scope?: string
        /**
         * Error fields
         */
        message?: string
    }

    export interface QosParticipant {
        name: string
        email?: string
        device?: string
        audio: lib.QosMetrics
        video: lib.QosMetrics
        screenShare?: lib.QosMetrics
    }

    export interface QosRequest {
        accountId?: string
    }

    export interface QosResponse {
        meetingUuid: string
        participants: QosParticipant[]
        error?: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getMeetingQos = this.getMeetingQos.bind(this)
            this.getOverview = this.getOverview.bind(this)
            this.mcpSSEEndpoint = this.mcpSSEEndpoint.bind(this)
            this.streamLiveMeetings = this.streamLiveMeetings.bind(this)
            this.streamOverview = this.streamOverview.bind(this)
        }

        public async getMeetingQos(meetingId: string, params: QosRequest): Promise<QosResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/meetings/${encodeURIComponent(meetingId)}/qos`, undefined, {query})
            return await resp.json() as QosResponse
        }

        public async getOverview(params: OverviewRequest): Promise<lib.ZoomOverviewData> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/overview`, undefined, {query})
            return await resp.json() as lib.ZoomOverviewData
        }

        /**
         * MCP SSE endpoint - handles GET (SSE connection) and POST (JSON-RPC messages)
         */
        public async mcpSSEEndpoint(method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE" | "HEAD" | "OPTIONS" | "TRACE", body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/mcp/zoom/sse`, body, options)
        }

        public async streamLiveMeetings(params: LiveStreamHandshake): Promise<StreamIn<LiveStreamMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
                interval:  params.interval === undefined ? undefined : String(params.interval),
                token:     params.token,
            })

            return await this.baseClient.createStreamIn(`/zoom/meetings/live/stream`, {query})
        }

        public async streamOverview(params: OverviewStreamHandshake): Promise<StreamIn<OverviewStreamMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
                token:     params.token,
            })

            return await this.baseClient.createStreamIn(`/zoom/overview/stream`, {query})
        }
    }
}

export namespace orchestrator {
    export interface ConfigureRequest {
        requirements: string
        options?: {
            dryRun?: boolean
            verificationMode?: shared.VerificationMode
            stopOnError?: boolean
            rollbackOnError?: boolean
            skipValidation?: boolean
        }
    }

    export interface ConfigureResponse {
        success: boolean
        planId: string
        executionId?: string
        status: string
        summary: {
            intentsIdentified: number
            tasksPlanned: number
            tasksCompleted: number
            resourcesCreated: number
            verificationStatus?: string
            issues: number
        }
        warnings: string[]
        errors: string[]
        plan?: shared.ExecutionPlan
        executionResult?: shared.ExecutionResult
        verificationResult?: shared.VerificationResult
    }

    export interface ExecutePlanRequest {
        plan: shared.ExecutionPlan
        options?: {
            dryRun?: boolean
            verificationMode?: shared.VerificationMode
            stopOnError?: boolean
            rollbackOnError?: boolean
        }
    }

    export interface ExecutePlanResponse {
        executionResult: shared.ExecutionResult
        verificationResult?: shared.VerificationResult
    }

    export interface ParseAndPlanRequest {
        requirements: string
    }

    export interface ParseAndPlanResponse {
        intents: shared.ConfigurationIntent[]
        plan: shared.ExecutionPlan
        clarificationsNeeded: string[]
        warnings: string[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.configure = this.configure.bind(this)
            this.executePlan = this.executePlan.bind(this)
            this.health = this.health.bind(this)
            this.plan = this.plan.bind(this)
            this.preview = this.preview.bind(this)
        }

        /**
         * Main entry point: Configure Zoom CX from natural language requirements
         */
        public async configure(params: ConfigureRequest): Promise<ConfigureResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/configure`, JSON.stringify(params))
            return await resp.json() as ConfigureResponse
        }

        /**
         * Execute an existing plan
         */
        public async executePlan(params: ExecutePlanRequest): Promise<ExecutePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/execute`, JSON.stringify(params))
            return await resp.json() as ExecutePlanResponse
        }

        /**
         * Health check
         */
        public async health(): Promise<{
    status: "healthy" | "degraded" | "unhealthy"
    services: { [key: string]: boolean }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/health`)
            return await resp.json() as {
    status: "healthy" | "degraded" | "unhealthy"
    services: { [key: string]: boolean }
}
        }

        /**
         * Parse requirements and create plan without executing
         */
        public async plan(params: ParseAndPlanRequest): Promise<ParseAndPlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/plan`, JSON.stringify(params))
            return await resp.json() as ParseAndPlanResponse
        }

        /**
         * Get a summary of what would be configured
         */
        public async preview(params: {
    requirements: string
}): Promise<{
    intents: {
        entity: string
        action: string
        name?: string
        confidence: number
    }[]
    summary: {
        totalTasks: number
        byOperation: { [key: string]: number }
        byResourceType: { [key: string]: number }
        hasBlockers: boolean
        warningCount: number
    }
    warnings: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/preview`, JSON.stringify(params))
            return await resp.json() as {
    intents: {
        entity: string
        action: string
        name?: string
        confidence: number
    }[]
    summary: {
        totalTasks: number
        byOperation: { [key: string]: number }
        byResourceType: { [key: string]: number }
        hasBlockers: boolean
        warningCount: number
    }
    warnings: string[]
}
        }
    }
}

export namespace parser {
    export interface ParseRequest {
        requirements: string
        context?: {
            existingResources?: {
                type: string
                name: string
            }[]
            accountLicenses?: { [key: string]: boolean }
        }
    }

    export interface ParseResponse {
        intents: shared.ConfigurationIntent[]
        warnings: string[]
        clarificationsNeeded: string[]
    }

    export interface RawChatRequest {
        systemPrompt: string
        userPrompt: string
        temperature?: number
        maxTokens?: number
    }

    export interface RawChatResponse {
        content: string
        usage?: {
            inputTokens: number
            outputTokens: number
        }
    }

    export interface ValidateIntentsRequest {
        intents: shared.ConfigurationIntent[]
    }

    export interface ValidateIntentsResponse {
        valid: boolean
        errors: {
            intentId: string
            error: string
        }[]
        warnings: {
            intentId: string
            warning: string
        }[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.askClarification = this.askClarification.bind(this)
            this.parseRequirements = this.parseRequirements.bind(this)
            this.rawChat = this.rawChat.bind(this)
            this.refineIntents = this.refineIntents.bind(this)
            this.validateIntents = this.validateIntents.bind(this)
        }

        /**
         * Ask clarifying questions about requirements
         */
        public async askClarification(params: {
    requirements: string
    currentIntents: shared.ConfigurationIntent[]
    unclear: string[]
}): Promise<{
    questions: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/parser/clarify`, JSON.stringify(params))
            return await resp.json() as {
    questions: string[]
}
        }

        /**
         * Parse natural language requirements into configuration intents
         */
        public async parseRequirements(params: ParseRequest): Promise<ParseResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/parser/parse`, JSON.stringify(params))
            return await resp.json() as ParseResponse
        }

        /**
         * Raw LLM chat endpoint for experiments - allows custom system prompts
         */
        public async rawChat(params: RawChatRequest): Promise<RawChatResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/parser/raw-chat`, JSON.stringify(params))
            return await resp.json() as RawChatResponse
        }

        /**
         * Refine intents based on user answers
         */
        public async refineIntents(params: {
    intents: shared.ConfigurationIntent[]
    clarifications: {
        question: string
        answer: string
    }[]
}): Promise<{
    intents: shared.ConfigurationIntent[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/parser/refine`, JSON.stringify(params))
            return await resp.json() as {
    intents: shared.ConfigurationIntent[]
}
        }

        /**
         * Validate a list of configuration intents
         */
        public async validateIntents(params: ValidateIntentsRequest): Promise<ValidateIntentsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/parser/validate`, JSON.stringify(params))
            return await resp.json() as ValidateIntentsResponse
        }
    }
}

export namespace planner {
    export interface AnalyzeDocumentRequest {
        documentId: string
        content: string
        filename: string
    }

    export interface AnalyzeDocumentResponse {
        analysis: DocumentAnalysis
    }

    export interface ApprovePlanResponse {
        plan: shared.ImplementationPlan
    }

    export interface ClarificationQuestion {
        question: string
        context: string
        options?: string[]
    }

    export interface CreatePlanAction {
        type: string
        description: string
        endpoint?: string
        method?: string
        payload?: { [key: string]: any }
    }

    export interface CreatePlanRequest {
        accountId: string
        intents: shared.ConfigurationIntent[]
        dryRun?: boolean
    }

    export interface CreatePlanRequest {
        name: string
        description?: string
        documentId?: string
        stages: CreatePlanStage[]
    }

    export interface CreatePlanResponse {
        plan: shared.ImplementationPlan
    }

    export interface CreatePlanStage {
        name: string
        description: string
        order: number
        dependencies?: string[]
        actions: CreatePlanAction[]
        validation?: shared.ValidationConfig
    }

    export interface DocumentAnalysis {
        summary: string
        detectedElements: {
            queues: QueueElement[]
            skills: SkillElement[]
            flows: FlowElement[]
            users: UserElement[]
            hours: HoursElement[]
            other: string[]
        }
        suggestedStages: SuggestedStage[]
        questions: ClarificationQuestion[]
    }

    export interface ExecuteStageResponse {
        success: boolean
        stage: shared.PlanStage
        error?: string
    }

    export interface ExportBuildPlanRequest {
        format?: "markdown" | "json" | "csv"
    }

    export interface ExportBuildPlanResponse {
        content: string
        filename: string
        contentType: string
    }

    export interface FlowElement {
        name: string
        type?: string
        description?: string
        confidence: number
    }

    export interface GetPlanResponse {
        plan: shared.ImplementationPlan
    }

    export interface GetRequirementResearchResponse {
        requirement: planning.Requirement
        researchResults: planning.RequirementResearchResults | null
    }

    export interface HoursElement {
        name: string
        days: string[]
        startTime: string
        endTime: string
        timezone?: string
    }

    export interface IntentPlanResponse {
        plan: shared.ExecutionPlan
    }

    export interface ListPlansRequest {
        status?: shared.PlanStatus
        limit?: number
        offset?: number
    }

    export interface ListPlansResponse {
        plans: shared.ImplementationPlan[]
        total: number
        hasMore: boolean
    }

    export interface QueueElement {
        name: string
        channel?: string
        description?: string
        product?: "contact_center" | "phone"
        confidence: number
    }

    export interface RollbackStageResponse {
        success: boolean
        stage: shared.PlanStage
        error?: string
    }

    export interface SkillElement {
        name: string
        description?: string
        confidence: number
    }

    export interface StreamMessage {
        event: planning.PlanningStreamEvent
    }

    export interface SuggestedStage {
        name: string
        description: string
        actionCount: number
        dependencies: string[]
    }

    export interface UpdatePlanRequest {
        name?: string
        description?: string
        stages?: CreatePlanStage[]
    }

    export interface UpdatePlanResponse {
        plan: shared.ImplementationPlan
    }

    export interface UserElement {
        name?: string
        email?: string
        role?: string
        skills?: string[]
        queues?: string[]
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.analyze = this.analyze.bind(this)
            this.approveBuildPlan = this.approveBuildPlan.bind(this)
            this.approveImplementationPlan = this.approveImplementationPlan.bind(this)
            this.createImplementationPlan = this.createImplementationPlan.bind(this)
            this.createPlan = this.createPlan.bind(this)
            this.deleteImplementationPlan = this.deleteImplementationPlan.bind(this)
            this.executePlanStage = this.executePlanStage.bind(this)
            this.exportBuildPlan = this.exportBuildPlan.bind(this)
            this.generateFromAnalysis = this.generateFromAnalysis.bind(this)
            this.getBuildPlan = this.getBuildPlan.bind(this)
            this.getDocument = this.getDocument.bind(this)
            this.getExecutionSteps = this.getExecutionSteps.bind(this)
            this.getImplementationPlan = this.getImplementationPlan.bind(this)
            this.getIssues = this.getIssues.bind(this)
            this.getPlanSummary = this.getPlanSummary.bind(this)
            this.getRequirementResearch = this.getRequirementResearch.bind(this)
            this.getRequirements = this.getRequirements.bind(this)
            this.listDocuments = this.listDocuments.bind(this)
            this.listImplementationPlans = this.listImplementationPlans.bind(this)
            this.optimizePlan = this.optimizePlan.bind(this)
            this.reanalyzeDependencies = this.reanalyzeDependencies.bind(this)
            this.regenerateExecutionPlan = this.regenerateExecutionPlan.bind(this)
            this.resolveIssue = this.resolveIssue.bind(this)
            this.resumeBuildPlan = this.resumeBuildPlan.bind(this)
            this.resumeDocument = this.resumeDocument.bind(this)
            this.rollbackPlanStage = this.rollbackPlanStage.bind(this)
            this.streamDocumentEvents = this.streamDocumentEvents.bind(this)
            this.updateImplementationPlan = this.updateImplementationPlan.bind(this)
            this.uploadDocument = this.uploadDocument.bind(this)
            this.validatePlan = this.validatePlan.bind(this)
        }

        /**
         * Analyze a document and extract configuration requirements
         */
        public async analyze(params: AnalyzeDocumentRequest): Promise<AnalyzeDocumentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/analyze`, JSON.stringify(params))
            return await resp.json() as AnalyzeDocumentResponse
        }

        /**
         * Approve a build plan and start execution
         */
        public async approveBuildPlan(buildPlanId: string, params: planning.ApproveBuildPlanRequest): Promise<planning.ApproveBuildPlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/build-plans/${encodeURIComponent(buildPlanId)}/approve`, JSON.stringify(params))
            return await resp.json() as planning.ApproveBuildPlanResponse
        }

        /**
         * Approve an implementation plan for execution
         */
        public async approveImplementationPlan(id: string): Promise<ApprovePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/plans/${encodeURIComponent(id)}/approve`)
            return await resp.json() as ApprovePlanResponse
        }

        /**
         * Create a new implementation plan
         */
        public async createImplementationPlan(params: CreatePlanRequest): Promise<CreatePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/plans`, JSON.stringify(params))
            return await resp.json() as CreatePlanResponse
        }

        /**
         * Create an execution plan from configuration intents
         */
        public async createPlan(params: CreatePlanRequest): Promise<IntentPlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/plan`, JSON.stringify(params))
            return await resp.json() as IntentPlanResponse
        }

        /**
         * Delete an implementation plan
         */
        public async deleteImplementationPlan(id: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/planner/plans/${encodeURIComponent(id)}`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Execute a specific stage of a plan
         */
        public async executePlanStage(planId: string, stageId: string): Promise<ExecuteStageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/plans/${encodeURIComponent(planId)}/stages/${encodeURIComponent(stageId)}/execute`)
            return await resp.json() as ExecuteStageResponse
        }

        /**
         * Export the build plan as markdown or JSON for review before execution.
         */
        public async exportBuildPlan(documentId: string, params: ExportBuildPlanRequest): Promise<ExportBuildPlanResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                format: params.format === undefined ? undefined : String(params.format),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/documents/${encodeURIComponent(documentId)}/export`, undefined, {query})
            return await resp.json() as ExportBuildPlanResponse
        }

        /**
         * Generate a plan from document analysis
         */
        public async generateFromAnalysis(params: {
    analysis: DocumentAnalysis
    name?: string
}): Promise<CreatePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/generate`, JSON.stringify(params))
            return await resp.json() as CreatePlanResponse
        }

        /**
         * Get build plan for a document
         */
        public async getBuildPlan(documentId: string): Promise<planning.GetBuildPlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/documents/${encodeURIComponent(documentId)}/build-plan`)
            return await resp.json() as planning.GetBuildPlanResponse
        }

        /**
         * Get a requirements document with its requirements
         */
        public async getDocument(documentId: string): Promise<planning.GetDocumentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/documents/${encodeURIComponent(documentId)}`)
            return await resp.json() as planning.GetDocumentResponse
        }

        /**
         * Get execution steps for a build plan (config step level DAG)
         */
        public async getExecutionSteps(buildPlanId: string): Promise<{
    executionPlan: planning.ExecutionPlan | null
    steps: planning.ExecutionStep[]
    waves: planning.ExecutionWave[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/build-plans/${encodeURIComponent(buildPlanId)}/execution-steps`)
            return await resp.json() as {
    executionPlan: planning.ExecutionPlan | null
    steps: planning.ExecutionStep[]
    waves: planning.ExecutionWave[]
}
        }

        /**
         * Get an implementation plan by ID
         */
        public async getImplementationPlan(id: string): Promise<GetPlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/plans/${encodeURIComponent(id)}`)
            return await resp.json() as GetPlanResponse
        }

        /**
         * Get open issues for a build plan
         */
        public async getIssues(buildPlanId: string, params: planning.GetIssuesRequest): Promise<planning.GetIssuesResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                status: params.status === undefined ? undefined : String(params.status),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/build-plans/${encodeURIComponent(buildPlanId)}/issues`, undefined, {query})
            return await resp.json() as planning.GetIssuesResponse
        }

        /**
         * Get plan summary
         */
        public async getPlanSummary(params: {
    plan: shared.ExecutionPlan
}): Promise<{
    totalTasks: number
    byOperation: { [key: string]: number }
    byResourceType: { [key: string]: number }
    hasBlockers: boolean
    warningCount: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/summary`, JSON.stringify(params))
            return await resp.json() as {
    totalTasks: number
    byOperation: { [key: string]: number }
    byResourceType: { [key: string]: number }
    hasBlockers: boolean
    warningCount: number
}
        }

        /**
         * Get a single requirement's research results
         */
        public async getRequirementResearch(requirementId: string): Promise<GetRequirementResearchResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/requirements/${encodeURIComponent(requirementId)}/research`)
            return await resp.json() as GetRequirementResearchResponse
        }

        /**
         * Get requirements with filtering
         */
        public async getRequirements(documentId: string, params: {
    researchStatus?: string
    executionStatus?: string
    verificationStatus?: string
    area?: string
}): Promise<{
    requirements: planning.Requirement[]
    summary: {
        total: number
        pending: number
        completed: number
        failed: number
        skipped: number
    }
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                area:               params.area,
                executionStatus:    params.executionStatus,
                researchStatus:     params.researchStatus,
                verificationStatus: params.verificationStatus,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/documents/${encodeURIComponent(documentId)}/requirements`, undefined, {query})
            return await resp.json() as {
    requirements: planning.Requirement[]
    summary: {
        total: number
        pending: number
        completed: number
        failed: number
        skipped: number
    }
}
        }

        /**
         * List all documents for a tenant
         */
        public async listDocuments(params: {
    tenantId?: string
    status?: string
    limit?: number
    offset?: number
}): Promise<{
    documents: planning.RequirementsDocument[]
    total: number
    hasMore: boolean
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
                status:   params.status,
                tenantId: params.tenantId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/documents`, undefined, {query})
            return await resp.json() as {
    documents: planning.RequirementsDocument[]
    total: number
    hasMore: boolean
}
        }

        /**
         * List implementation plans
         */
        public async listImplementationPlans(params: ListPlansRequest): Promise<ListPlansResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
                status: params.status === undefined ? undefined : String(params.status),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planner/plans`, undefined, {query})
            return await resp.json() as ListPlansResponse
        }

        /**
         * Optimize a plan (remove redundant tasks, reorder for efficiency)
         */
        public async optimizePlan(params: {
    plan: shared.ExecutionPlan
}): Promise<{
    plan: shared.ExecutionPlan
    optimizations: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/optimize`, JSON.stringify(params))
            return await resp.json() as {
    plan: shared.ExecutionPlan
    optimizations: string[]
}
        }

        /**
         * Re-analyze dependencies for a document
         */
        public async reanalyzeDependencies(documentId: string): Promise<{
    dependencies: planning.RequirementDependency[]
    phases: planning.BuildPhase[]
    debug: {
        requirementCount: number
        requirementSamples: string[]
    }
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/documents/${encodeURIComponent(documentId)}/reanalyze-dependencies`)
            return await resp.json() as {
    dependencies: planning.RequirementDependency[]
    phases: planning.BuildPhase[]
    debug: {
        requirementCount: number
        requirementSamples: string[]
    }
}
        }

        /**
         * Regenerate execution plan (delete existing and create new)
         */
        public async regenerateExecutionPlan(buildPlanId: string): Promise<{
    executionPlan: planning.ExecutionPlan | null
    steps: planning.ExecutionStep[]
    waves: planning.ExecutionWave[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/build-plans/${encodeURIComponent(buildPlanId)}/execution-steps/regenerate`)
            return await resp.json() as {
    executionPlan: planning.ExecutionPlan | null
    steps: planning.ExecutionStep[]
    waves: planning.ExecutionWave[]
}
        }

        /**
         * Resolve an execution issue
         */
        public async resolveIssue(issueId: string, params: planning.ResolveIssueRequest): Promise<planning.ResolveIssueResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/issues/${encodeURIComponent(issueId)}/resolve`, JSON.stringify(params))
            return await resp.json() as planning.ResolveIssueResponse
        }

        /**
         * Resume execution of a paused build plan
         */
        public async resumeBuildPlan(buildPlanId: string): Promise<planning.ResumeBuildPlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/build-plans/${encodeURIComponent(buildPlanId)}/resume`)
            return await resp.json() as planning.ResumeBuildPlanResponse
        }

        /**
         * Resume a document's workflow from where it left off
         */
        public async resumeDocument(documentId: string): Promise<{
    resumed: boolean
    currentStatus: planning.DocumentStatus
    message: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/documents/${encodeURIComponent(documentId)}/resume`)
            return await resp.json() as {
    resumed: boolean
    currentStatus: planning.DocumentStatus
    message: string
}
        }

        /**
         * Rollback a specific stage of a plan
         */
        public async rollbackPlanStage(planId: string, stageId: string): Promise<RollbackStageResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/plans/${encodeURIComponent(planId)}/stages/${encodeURIComponent(stageId)}/rollback`)
            return await resp.json() as RollbackStageResponse
        }

        /**
         * Stream events for a document's planning workflow
         */
        public async streamDocumentEvents(documentId: string): Promise<StreamIn<StreamMessage>> {
            return await this.baseClient.createStreamIn(`/planner/documents/${encodeURIComponent(documentId)}/stream`)
        }

        /**
         * Update an implementation plan
         */
        public async updateImplementationPlan(id: string, params: UpdatePlanRequest): Promise<UpdatePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/planner/plans/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as UpdatePlanResponse
        }

        /**
         * Upload a requirements document and start decomposition
         */
        public async uploadDocument(params: planning.UploadDocumentRequest): Promise<planning.UploadDocumentResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/documents`, JSON.stringify(params))
            return await resp.json() as planning.UploadDocumentResponse
        }

        /**
         * Validate a plan without executing
         */
        public async validatePlan(params: {
    plan: shared.ExecutionPlan
}): Promise<{
    valid: boolean
    errors: string[]
    warnings: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planner/validate`, JSON.stringify(params))
            return await resp.json() as {
    valid: boolean
    errors: string[]
    warnings: string[]
}
        }
    }
}

export namespace planning {
    export interface ApiVerificationCheck {
        /**
         * GET endpoint to query (with placeholders like {resourceId})
         */
        endpoint: string

        /**
         * HTTP method (defaults to GET)
         */
        method?: "GET" | "POST"

        /**
         * JSON path to the field to check (e.g., "settings.priority_routing" or "queues[0].skill_ids")
         */
        fieldPath: string

        /**
         * Expected value or pattern
         */
        expectedValue: any

        /**
         * Comparison type
         */
        comparison: "equals" | "contains" | "exists" | "not_empty" | "greater_than" | "matches_regex"

        /**
         * Description of what this check verifies
         */
        description: string
    }

    export interface ApproveBuildPlanRequest {
        checkpointMode?: CheckpointMode
    }

    export interface ApproveBuildPlanResponse {
        approved: boolean
        confirmationToken?: string
    }

    export interface ApprovePlanResponse {
        session: PlanningSession
        confirmation: Confirmation
    }

    export interface BuildPhase {
        number: number
        name: string
        description?: string
        requirementIds: string[]
        isCheckpoint: boolean
        estimatedApiCalls: number
        status: "pending" | "in_progress" | "completed" | "failed" | "skipped"
        /**
         * Components that must be configured in this phase
         */
        components?: string[]

        /**
         * Dependency chain - phases that must complete before this one
         */
        dependsOnPhases?: number[]

        /**
         * Human-readable dependency explanation
         */
        dependencyReason?: string
    }

    export interface BuildPlan {
        id: string
        documentId: string
        status: BuildPlanStatus
        phases: BuildPhase[]
        currentPhase: number
        checkpointMode: CheckpointMode
        configExecutionPlanId?: string
        createdAt: string
        updatedAt: string
    }

    export type BuildPlanStatus = "draft" | "approved" | "executing" | "paused" | "completed" | "failed"

    export interface CancelSessionResponse {
        success: boolean
    }

    export type CheckpointMode = "every_step" | "issues_only" | "phase_boundaries" | "full_auto"

    export interface ConfigStep {
        order: number
        action: string
        endpoint?: string
        payload?: { [key: string]: any }
    }

    export interface ConfirmExecutionRequest {
        confirmationToken: string
        dryRun?: boolean
    }

    export interface ConfirmExecutionResponse {
        session: PlanningSession
        executionStarted: boolean
        isDryRun: boolean
    }

    export interface Confirmation {
        id: string
        planningSessionId: string
        token: string
        confirmationType: ConfirmationType
        description: string
        operationDetails: { [key: string]: any }
        status: ConfirmationStatus
        confirmedBy?: string
        confirmedAt?: string
        expiresAt: string
        createdAt: string
    }

    export type ConfirmationStatus = "pending" | "confirmed" | "expired" | "cancelled"

    export type ConfirmationType = "plan_approval" | "execute_stage" | "execute_all" | "delete_resource"

    export interface CreatedResource {
        resourceType: string
        resourceId: string
        resourceName?: string
    }

    export type DependencyType = "hard" | "soft"

    export type DocumentStatus = "uploaded" | "decomposing" | "researching" | "analyzing_dependencies" | "planning" | "ready" | "executing" | "verifying" | "completed" | "failed"

    export interface DocumentationReference {
        url: string
        title: string
        type: "kb_article" | "config_guide" | "api_docs" | "release_note"
        snippet?: string
    }

    export interface EndpointInfo {
        method: string
        path: string
        description: string
        requiredFields?: string[]
        optionalFields?: string[]
    }

    export interface ExecutionIssue {
        id: string
        buildPlanId: string
        requirementId?: string
        phaseNumber?: number
        issueType: IssueType
        severity: IssueSeverity
        message: string
        context?: { [key: string]: any }
        status: IssueStatus
        resolutionNotes?: string
        createdAt: string
        resolvedAt?: string
    }

    export interface ExecutionPlan {
        id: string
        buildPlanId: string
        documentId: string
        /**
         * All steps in execution order
         */
        steps: ExecutionStep[]

        /**
         * Steps grouped by parallel execution wave
         */
        waves: ExecutionWave[]

        /**
         * Total number of steps
         */
        totalSteps: number

        /**
         * Number of completed steps
         */
        completedSteps: number

        /**
         * Current wave being executed
         */
        currentWave: number

        status: "pending" | "executing" | "paused" | "completed" | "failed"
        createdAt: string
        updatedAt: string
    }

    export type ExecutionStatus = "pending" | "in_progress" | "completed" | "failed" | "skipped" | "manual"

    export interface ExecutionStep {
        id: string
        buildPlanId: string
        /**
         * Source requirement this step came from
         */
        requirementId: string

        /**
         * Global execution order (1, 2, 3, ... across all requirements)
         */
        executionOrder: number

        /**
         * Human-readable action description
         */
        action: string

        /**
         * API endpoint path (e.g., /contact_center/queues)
         */
        endpoint?: string

        /**
         * HTTP method
         */
        method?: string

        /**
         * Request payload template
         */
        payload?: { [key: string]: any }

        /**
         * Resource types this step CREATES (e.g., ['queue', 'skill'])
         */
        resourcesCreated: string[]

        /**
         * Resource types this step REQUIRES (e.g., ['flow', 'queue'])
         */
        resourcesRequired: string[]

        /**
         * Step IDs that must complete before this step can run
         */
        dependsOn: string[]

        /**
         * Execution status
         */
        status: ExecutionStepStatus

        /**
         * When execution started
         */
        startedAt?: string

        /**
         * When execution completed
         */
        completedAt?: string

        /**
         * Error message if failed
         */
        error?: string

        /**
         * Resources created by this step (actual IDs after execution)
         */
        createdResources?: CreatedResource[]

        createdAt: string
    }

    export type ExecutionStepStatus = "pending" | "ready" | "in_progress" | "completed" | "failed" | "skipped"

    export interface ExecutionWave {
        waveNumber: number
        /**
         * Step IDs in this wave
         */
        stepIds: string[]

        /**
         * Status of this wave
         */
        status: "pending" | "in_progress" | "completed" | "failed"
    }

    export interface GetBuildPlanResponse {
        buildPlan: BuildPlan | null
        phases: BuildPhase[]
        dependencies: RequirementDependency[]
    }

    export interface GetDocumentResponse {
        document: RequirementsDocument
        requirements: Requirement[]
        summary: {
            total: number
            pending: number
            researched: number
            configured: number
            verified: number
            failed: number
        }
    }

    export interface GetIssuesRequest {
        status?: IssueStatus
    }

    export interface GetIssuesResponse {
        issues: ExecutionIssue[]
    }

    export interface GetSessionRequest {
        sessionId?: string
        conversationId?: string
    }

    export interface GetSessionResponse {
        session: PlanningSession | null
    }

    export interface ImpactAnalysis {
        failedRequirement: string
        failurePoint: "research" | "configuration" | "verification"
        blockedRequirements: {
            id: string
            description: string
            reason: string
        }[]
        atRiskRequirements: {
            id: string
            dependencyChain: string[]
        }[]
        unaffectedRequirements: string[]
        suggestedActions: {
            action: "skip_branch" | "manual" | "retry" | "alternative"
            affectedCount: number
        }[]
    }

    export type IssueSeverity = "blocker" | "warning"

    export type IssueStatus = "open" | "resolved" | "skipped"

    export type IssueType = "api_error" | "missing_dependency" | "feature_not_enabled" | "rate_limited" | "clarification_needed" | "validation_failed" | "verification_failed" | "not_supported"

    export interface Pitfall {
        description: string
        settingPath: string
        failureImpact: string
        /**
         * How to check if this pitfall applies
         */
        detection?: ApiVerificationCheck

        /**
         * How to fix if detected
         */
        remediation?: string
    }

    export interface PlannedAction {
        order: number
        method: "POST" | "PUT" | "PATCH" | "DELETE"
        path: string
        params: { [key: string]: any }
        description?: string
        resourceType?: string
    }

    export interface PlanningRequirements {
        intent?: string
        entities: {
            type: string
            name?: string
            properties: { [key: string]: any }
        }[]
        parameters: { [key: string]: any }
        clarifications: {
            question: string
            answer: string
            answeredAt: string
        }[]
        plannedActions?: PlannedAction[]
    }

    export interface PlanningSession {
        id: string
        conversationId: string
        tenantId: string
        userId: string
        state: PlanningState
        accountId?: string
        accountName?: string
        requirements: PlanningRequirements
        planId?: string
        currentStageIndex: number
        executionResultId?: string
        createdAt: string
        updatedAt: string
    }

    export type PlanningState = "gathering_requirements" | "selecting_account" | "generating_plan" | "awaiting_approval" | "awaiting_confirmation" | "executing" | "completed" | "cancelled" | "document_uploaded" | "decomposing" | "researching" | "analyzing_dependencies" | "build_plan_ready" | "phase_executing" | "phase_paused" | "verifying" | "issue_raised"

    export type PlanningStreamEvent = {
        type: "decomposition_started"
    } | {
        type: "area_identified"
        area: string
        requirementCount: number
    } | {
        type: "requirement_extracted"
        requirement: Requirement
    } | {
        type: "decomposition_completed"
        totalRequirements: number
    } | {
        type: "research_started"
        totalRequirements: number
    } | {
        type: "requirement_research_started"
        requirementId: string
        description: string
    } | {
        type: "requirement_research_progress"
        requirementId: string
        message: string
    } | {
        type: "requirement_research_completed"
        requirementId: string
        endpoints: string[]
        confidence: number
    } | {
        type: "requirement_research_failed"
        requirementId: string
        error: string
    } | {
        type: "research_progress"
        message: string
    } | {
        type: "research_completed"
        researched: number
        failed: number
    } | {
        type: "dependency_analysis_started"
    } | {
        type: "dependency_found"
        from: string
        to: string
        reason: string
    } | {
        type: "phase_determined"
        phaseNumber: number
        name: string
        requirementIds: string[]
    } | {
        type: "dependency_analysis_completed"
        phases: number
        dependencies: number
    } | {
        type: "build_plan_generated"
        buildPlanId: string
        phases: BuildPhase[]
    } | {
        type: "build_plan_ready"
    } | {
        type: "phase_started"
        phaseNumber: number
        name: string
        requirementCount: number
    } | {
        type: "phase_paused"
        phaseNumber: number
        reason: string
    } | {
        type: "phase_completed"
        phaseNumber: number
    } | {
        type: "requirement_started"
        requirementId: string
        description: string
    } | {
        type: "api_call_started"
        requirementId: string
        method: string
        endpoint: string
    } | {
        type: "api_call_succeeded"
        requirementId: string
        resourceId?: string
        resourceName?: string
    } | {
        type: "api_call_failed"
        requirementId: string
        error: string
        statusCode?: number
    } | {
        type: "requirement_completed"
        requirementId: string
        createdResources: CreatedResource[]
    } | {
        type: "requirement_failed"
        requirementId: string
        error: string
    } | {
        type: "execution_mode"
        mode: "step_level" | "phase_level"
        totalSteps?: number
        totalWaves?: number
        totalPhases?: number
    } | {
        type: "execution_plan_generated"
        planId: string
        totalSteps: number
        totalWaves: number
    } | {
        type: "wave_started"
        waveNumber: number
        stepCount: number
    } | {
        type: "wave_completed"
        waveNumber: number
        success: boolean
        failedCount: number
    } | {
        type: "step_started"
        stepId: string
        action: string
        method?: string
        endpoint?: string
    } | {
        type: "step_progress"
        stepId: string
        message: string
    } | {
        type: "step_completed"
        stepId: string
        createdResources?: CreatedResource[]
    } | {
        type: "step_failed"
        stepId: string
        error: string
        statusCode?: number
    } | {
        type: "step_skipped"
        stepId: string
        reason: string
    } | {
        type: "execution_completed"
        success: boolean
        completedSteps: number
        failedSteps?: string[]
    } | {
        type: "issue_raised"
        issueId: string
        severity: IssueSeverity
        message: string
    } | {
        type: "execution_paused"
        issueId?: string
        message: string
    } | {
        type: "waiting_for_human"
        issueId: string
    } | {
        type: "issue_resolved"
        issueId: string
        action: string
    } | {
        type: "verification_phase_started"
        requirementCount: number
    } | {
        type: "requirement_verification_started"
        requirementId: string
        testCount: number
    } | {
        type: "test_running"
        requirementId: string
        testCase: string
    } | {
        type: "test_passed"
        requirementId: string
        testCase: string
    } | {
        type: "test_failed"
        requirementId: string
        testCase: string
        reason: string
        gradingNote: string
    } | {
        type: "setting_check_passed"
        requirementId: string
        setting: string
    } | {
        type: "setting_check_failed"
        requirementId: string
        setting: string
        expected: string
        actual: string
    } | {
        type: "manual_verification_needed"
        requirementId: string
        instructions: string
    } | {
        type: "requirement_verification_completed"
        requirementId: string
        status: VerificationStatus
    } | {
        type: "verification_phase_completed"
        passed: number
        failed: number
        manual: number
    } | {
        type: "impact_analysis"
        analysis: ImpactAnalysis
    } | {
        type: "requirements_blocked"
        ids: string[]
        reason: string
    } | {
        type: "error"
        message: string
    } | {
        type: "status_changed"
        status: DocumentStatus
    }

    export interface Requirement {
        id: string
        documentId: string
        area: string
        section?: string
        description: string
        /**
         * Original text from the document that this requirement was extracted from
         */
        sourceText?: string

        priority: number
        estimatedComplexity?: number
        /**
         * Research
         */
        researchStatus: ResearchStatus

        researchResults?: RequirementResearchResults
        /**
         * Verification info
         */
        verificationSteps?: VerificationStep[]

        testCases?: TestCase[]
        commonPitfalls?: Pitfall[]
        /**
         * Config execution
         */
        executionStatus: ExecutionStatus

        executionStartedAt?: string
        executionCompletedAt?: string
        executionNotes?: string
        createdResources?: CreatedResource[]
        /**
         * Verification execution
         */
        verificationStatus: VerificationStatus

        verificationNotes?: string
        gradingCategory?: string
        createdAt: string
    }

    export interface RequirementDependency {
        dependentId: string
        dependencyId: string
        dependencyType: DependencyType
        reason?: string
    }

    export interface RequirementResearchResults {
        endpoints: EndpointInfo[]
        configSteps: ConfigStep[]
        verificationSteps?: VerificationStep[]
        testCases?: TestCase[]
        pitfalls?: Pitfall[]
        references?: DocumentationReference[]
        /**
         * Prerequisites from KB articles (e.g., licenses, roles, prior configurations)
         */
        prerequisites?: string[]

        confidence: number
        warnings: string[]
        blockers: string[]
    }

    export interface RequirementsDocument {
        id: string
        tenantId: string
        planningSessionId?: string
        name?: string
        rawContent: string
        status: DocumentStatus
        /**
         * The Zoom account ID to use when executing this build plan
         */
        zoomAccountId?: string

        createdAt: string
        updatedAt: string
    }

    export type ResearchStatus = "pending" | "researching" | "complete" | "failed" | "not_supported"

    export interface ResolveIssueRequest {
        action: "retry" | "skip" | "manual"
        notes?: string
    }

    export interface ResolveIssueResponse {
        resolved: boolean
        issueId: string
    }

    export interface ResumeBuildPlanResponse {
        resumed: boolean
        nextPhase: number
    }

    export interface SelectAccountRequest {
        accountId: string
    }

    export interface SelectAccountResponse {
        session: PlanningSession
    }

    export interface StartPlanningRequest {
        conversationId: string
        initialMessage?: string
    }

    export interface StartPlanningResponse {
        session: PlanningSession
        needsAccountSelection: boolean
        availableAccounts?: {
            id: string
            name: string
        }[]
    }

    export interface SubmitRequirementsRequest {
        requirements: PlanningRequirements
    }

    export interface SubmitRequirementsResponse {
        session: PlanningSession
        planId: string
        planSummary: {
            name: string
            description: string
            stageCount: number
            totalActions: number
            estimatedApiCalls: number
            warnings: string[]
        }
    }

    export interface TestCase {
        name: string
        input: string
        expectedResult: string
        category: string
        /**
         * Whether this test can be automated
         */
        automatable?: boolean

        /**
         * For automatable tests, the verification check
         */
        apiCheck?: ApiVerificationCheck
    }

    export interface UploadDocumentRequest {
        content: string
        name?: string
        tenantId?: string
        /**
         * The Zoom account ID to use when executing this build plan
         */
        zoomAccountId?: string
    }

    export interface UploadDocumentResponse {
        documentId: string
        sessionId?: string
        status: DocumentStatus
    }

    export type VerificationStatus = "not_tested" | "testing" | "passed" | "failed" | "blocked" | "manual_needed"

    export interface VerificationStep {
        order: number
        action: string
        expectedOutcome: string
        /**
         * @deprecated Use strategy instead
         */
        checkType?: "ui" | "api" | "manual"

        /**
         * The verification strategy to use
         */
        strategy: VerificationStrategy

        /**
         * For API-based verification
         */
        apiCheck?: ApiVerificationCheck

        /**
         * For manual verification
         */
        manualInstructions?: string[]

        /**
         * Criticality - if this fails, is it a blocker?
         */
        critical?: boolean
    }

    export type VerificationStrategy = "api_state_check" | "resource_exists" | "relationship_check" | "setting_enabled" | "flow_structure" | "manual_test"

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.approvePlan = this.approvePlan.bind(this)
            this.cancelPlanningSession = this.cancelPlanningSession.bind(this)
            this.confirmExecution = this.confirmExecution.bind(this)
            this.getPlanningSession = this.getPlanningSession.bind(this)
            this.getPlanningSessionById = this.getPlanningSessionById.bind(this)
            this.listPlanningSessions = this.listPlanningSessions.bind(this)
            this.selectAccount = this.selectAccount.bind(this)
            this.startPlanning = this.startPlanning.bind(this)
            this.submitRequirements = this.submitRequirements.bind(this)
        }

        /**
         * Approve a generated plan
         */
        public async approvePlan(sessionId: string): Promise<ApprovePlanResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planning/sessions/${encodeURIComponent(sessionId)}/approve`)
            return await resp.json() as ApprovePlanResponse
        }

        /**
         * Cancel a planning session
         */
        public async cancelPlanningSession(sessionId: string): Promise<CancelSessionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planning/sessions/${encodeURIComponent(sessionId)}/cancel`)
            return await resp.json() as CancelSessionResponse
        }

        /**
         * Confirm and execute the approved plan
         */
        public async confirmExecution(sessionId: string, params: ConfirmExecutionRequest): Promise<ConfirmExecutionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planning/sessions/${encodeURIComponent(sessionId)}/execute`, JSON.stringify(params))
            return await resp.json() as ConfirmExecutionResponse
        }

        /**
         * Get a planning session
         */
        public async getPlanningSession(params: GetSessionRequest): Promise<GetSessionResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                conversationId: params.conversationId,
                sessionId:      params.sessionId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planning/sessions`, undefined, {query})
            return await resp.json() as GetSessionResponse
        }

        /**
         * Get a planning session by ID
         */
        public async getPlanningSessionById(id: string): Promise<GetSessionResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planning/sessions/${encodeURIComponent(id)}`)
            return await resp.json() as GetSessionResponse
        }

        /**
         * List active planning sessions
         */
        public async listPlanningSessions(params: {
    limit?: number
}): Promise<{
    sessions: PlanningSession[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/planning/sessions/active`, undefined, {query})
            return await resp.json() as {
    sessions: PlanningSession[]
}
        }

        /**
         * Select account for planning session
         */
        public async selectAccount(sessionId: string, params: SelectAccountRequest): Promise<SelectAccountResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planning/sessions/${encodeURIComponent(sessionId)}/account`, JSON.stringify(params))
            return await resp.json() as SelectAccountResponse
        }

        /**
         * Start a new planning session
         */
        public async startPlanning(params: StartPlanningRequest): Promise<StartPlanningResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planning/sessions`, JSON.stringify(params))
            return await resp.json() as StartPlanningResponse
        }

        /**
         * Submit gathered requirements and generate plan
         */
        public async submitRequirements(sessionId: string, params: SubmitRequirementsRequest): Promise<SubmitRequirementsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/planning/sessions/${encodeURIComponent(sessionId)}/requirements`, JSON.stringify(params))
            return await resp.json() as SubmitRequirementsResponse
        }
    }
}

export namespace pmf {
    export interface Alternative {
        id: string
        name: string
        type: AlternativeType
        description: string | null
        strengths: string[]
        weaknesses: string[]
        typicalCost: string | null
        typicalUsers: string | null
        mentionCount: number
        createdAt: string
    }

    export interface AlternativeSignal {
        id: string
        name: string
        type: AlternativeType
        userCount: number
        avgSatisfaction: number | null
        switchRate: number
    }

    export type AlternativeType = "status_quo" | "paid_service" | "diy" | "tool" | "avoidance"

    export interface AssignJobRequest {
        personId: string
        jobId: string
        importance: number
        satisfaction?: number
        currentApproach?: string
        notes?: string
    }

    export interface Assumption {
        id: string
        statement: string
        pyramidLayer: number
        category: AssumptionCategory
        risk: RiskLevel
        impact: RiskLevel
        status: AssumptionStatus
        testPlan: string | null
        evidenceFor: string[]
        evidenceAgainst: string[]
        relatedInsightIds: string[]
        relatedBenchmarkCategory: string | null
        notes: string | null
        validatedAt: string | null
        createdAt: string
        updatedAt: string
    }

    export type AssumptionCategory = "market_size" | "customer" | "need" | "value_prop" | "feature" | "ux"

    export type AssumptionStatus = "hypothesis" | "testing" | "validated" | "invalidated" | "revised"

    export interface BenchmarkResult {
        category: string
        passRate: number
        avgScore: number
        runId: string
    }

    export interface BulkImportRequest {
        people: CreatePersonInput[]
    }

    export interface BulkImportResponse {
        created: number
        skipped: number
        errors: string[]
    }

    export interface ChangeStageRequest {
        stage: LifecycleStage
        trigger?: string
        reason?: string
        changedBy?: string
    }

    export type CompanySize = "smb" | "mid-market" | "enterprise"

    export interface CreateAssumptionInput {
        statement: string
        pyramidLayer: number
        category: AssumptionCategory
        risk?: RiskLevel
        impact?: RiskLevel
        testPlan?: string
        relatedBenchmarkCategory?: string
        notes?: string
    }

    export interface CreatePersonInput {
        email?: string
        name: string
        company?: string
        title?: string
        persona?: string
        industry?: string
        companySize?: string
        zoomSeatCount?: number
        zoomProducts?: string[]
        source?: string
        stage?: string
        linkedinUrl?: string
        phone?: string
        tags?: string[]
        notes?: string
    }

    export interface CreatePersonRequest {
        email?: string
        name: string
        company?: string
        title?: string
        persona?: string
        industry?: string
        companySize?: string
        zoomSeatCount?: number
        zoomProducts?: string[]
        source?: string
        stage?: string
        linkedinUrl?: string
        phone?: string
        tags?: string[]
        notes?: string
    }

    export interface CreateTouchpointRequest {
        category: TouchpointCategory
        type: string
        channel?: string
        subject?: string
        body?: string
        metadata?: { [key: string]: any }
        direction?: TouchpointDirection
        loggedBy?: string
        occurredAt?: string
    }

    export interface CsvImportRequest {
        csvContent: string
        source?: string
    }

    export interface DiscoveryQuestion {
        id: string
        layer: number
        question: string
        answerType: "text" | "rating" | "select" | "multiselect"
        capturesField?: string
        capturesPersona?: boolean
        capturesJobs?: boolean
        aiExtract?: boolean
        min?: number
        max?: number
        options?: string[]
    }

    export interface DiscoveryTemplate {
        id: string
        name: string
        description: string | null
        targetPersona: Persona | null
        targetLayers: number[]
        questions: DiscoveryQuestion[]
        estimatedDuration: number | null
        createdAt: string
    }

    export interface FunnelStep {
        milestone: string
        count: number
        percentage: number
    }

    export interface Interview {
        id: string
        personId: string
        templateId: string | null
        interviewedBy: string
        channel: string | null
        durationMinutes: number | null
        answers: { [key: string]: InterviewAnswer }
        summary: string | null
        assumptionsTested: string[]
        keyInsights: string[]
        followUpActions: string[]
        conductedAt: string
        createdAt: string
    }

    export interface InterviewAnswer {
        answer: string | number
        notes?: string
        rating?: number
    }

    export interface Job {
        id: string
        title: string
        description: string | null
        category: JobCategory
        frequency: JobFrequency | null
        painLevel: number | null
        sourceCount: number
        zacCapability: ZacCapability | null
        benchmarkCategory: string | null
        benchmarkPassRate: number | null
        benchmarkAvgScore: number | null
        benchmarkRunId: string | null
        exampleTasks: string[]
        createdAt: string
        updatedAt: string
    }

    export type JobCategory = "admin" | "compliance" | "optimization" | "support" | "reporting" | "security"

    export type JobFrequency = "daily" | "weekly" | "monthly" | "quarterly" | "ad-hoc"

    export interface JobSignal {
        id: string
        title: string
        painLevel: number | null
        benchmarkPassRate: number | null
        avgSatisfaction: number | null
        personCount: number
        recommendation: "build" | "fix_ux" | "maintain" | "deprioritize"
    }

    export type LifecycleStage = "awareness" | "interested" | "evaluating" | "trial" | "activated" | "retained" | "churned"

    export interface ListAssumptionsRequest {
        pyramidLayer?: number
        status?: string
        risk?: string
        category?: string
    }

    export interface ListInsightsRequest {
        pyramidLayer?: number
        type?: string
        limit?: number
    }

    export interface ListPeopleRequest {
        stage?: string
        source?: string
        industry?: string
        persona?: string
        search?: string
        limit?: number
        offset?: number
    }

    export interface ListPeopleResponse {
        items: Person[]
        total: number
    }

    export interface ListResearchRequest {
        source?: string
        analyzed?: boolean
        limit?: number
    }

    export interface ListSeoRequest {
        category?: string
        keyword?: string
    }

    export interface ListTouchpointsRequest {
        category?: string
        limit?: number
        offset?: number
    }

    export interface Milestone {
        id: string
        personId: string
        milestone: MilestoneType
        reachedAt: string
        metadata: { [key: string]: any } | null
    }

    export type MilestoneType = "signed_up" | "connected_zoom" | "first_chat" | "first_plan" | "first_execution" | "first_verification" | "return_usage" | "onboarding_complete"

    export interface Person {
        id: string
        email: string | null
        name: string
        company: string | null
        title: string | null
        persona: Persona | null
        industry: string | null
        companySize: CompanySize | null
        zoomSeatCount: number | null
        zoomProducts: string[]
        source: PersonSource | null
        stage: LifecycleStage
        currentAlternative: string | null
        alternativeSatisfaction: number | null
        switchingReason: string | null
        userId: string | null
        tenantId: string | null
        linkedinUrl: string | null
        phone: string | null
        tags: string[]
        notes: string | null
        enrichment: { [key: string]: any } | null
        enrichedAt: string | null
        createdAt: string
        updatedAt: string
    }

    export type PersonSource = "organic" | "referral" | "outbound" | "community" | "event"

    export type Persona = "it_admin" | "cc_implementor" | "zoom_partner" | "comms_it"

    export interface PersonalizationProfile {
        known: boolean
        persona: string | null
        zoomProducts: string[]
        industry: string | null
        companySize: string | null
        topJobs: {
            title: string
            importance: number
        }[]
        switchingFrom: string | null
        switchingReason: string | null
        keyTouchpoints: string[]
    }

    export interface RecordMilestoneRequest {
        email: string
        milestone: MilestoneType
        metadata?: { [key: string]: any }
    }

    export type ResearchSource = "job_posting" | "reddit" | "zoom_forum" | "hacker_news" | "stack_exchange" | "spiceworks" | "mantiks" | "other"

    export type RiskLevel = "low" | "medium" | "high"

    export interface ScrapeRequest {
        source: ResearchSource
    }

    export interface SegmentMetrics {
        segment: string
        segmentType: string
        total: number
        activated: number
        activationRate: number
    }

    export interface SeoQuery {
        id: string
        keyword: string
        category: string | null
        searchVolume: number | null
        currentRank: number | null
        previousRank: number | null
        rankDate: string | null
        source: string
        relatedInsightId: string | null
        relatedJobId: string | null
        notes: string | null
        createdAt: string
        updatedAt: string
    }

    export interface StageDistribution {
        stage: LifecycleStage
        count: number
        percentage: number
    }

    export interface SubmitInterviewRequest {
        templateId?: string
        interviewedBy: string
        channel?: string
        durationMinutes?: number
        answers: { [key: string]: InterviewAnswer }
        summary?: string
        assumptionsTested?: string[]
        keyInsights?: string[]
        followUpActions?: string[]
    }

    export interface SyncBenchmarksRequest {
        results: BenchmarkResult[]
    }

    export interface Touchpoint {
        id: string
        personId: string
        category: TouchpointCategory
        type: string
        channel: string | null
        subject: string | null
        body: string | null
        metadata: { [key: string]: any } | null
        direction: TouchpointDirection | null
        loggedBy: string | null
        occurredAt: string
        createdAt: string
    }

    export type TouchpointCategory = "sales" | "marketing" | "product" | "support" | "interview"

    export type TouchpointDirection = "inbound" | "outbound" | "system"

    export interface TrackRequest {
        email: string
        category: "sales" | "marketing" | "product" | "support" | "interview"
        type: string
        metadata?: { [key: string]: any }
    }

    export interface UpdateAssumptionRequest {
        statement?: string
        risk?: RiskLevel
        impact?: RiskLevel
        status?: AssumptionStatus
        testPlan?: string
        notes?: string
        relatedBenchmarkCategory?: string
        addEvidenceFor?: string
        addEvidenceAgainst?: string
        addRelatedInsightId?: string
    }

    export interface UpdatePersonJobRequest {
        importance?: number
        satisfaction?: number
        currentApproach?: string
        notes?: string
    }

    export interface UpdatePersonRequest {
        email?: string
        name?: string
        company?: string
        title?: string
        persona?: string
        industry?: string
        companySize?: string
        zoomSeatCount?: number
        zoomProducts?: string[]
        source?: string
        currentAlternative?: string
        alternativeSatisfaction?: number
        switchingReason?: string
        linkedinUrl?: string
        phone?: string
        tags?: string[]
        notes?: string
        userId?: string
        tenantId?: string
        enrichment?: { [key: string]: any }
        enrichedAt?: string
    }

    export interface UpsertAlternativeInput {
        id?: string
        name: string
        type: AlternativeType
        description?: string
        strengths?: string[]
        weaknesses?: string[]
        typicalCost?: string
        typicalUsers?: string
    }

    export interface UpsertJobInput {
        id: string
        title: string
        description?: string
        category: JobCategory
        frequency?: string
        painLevel?: number
        zacCapability?: ZacCapability
        benchmarkCategory?: string
        exampleTasks?: string[]
    }

    export interface UpsertSeoInput {
        id?: string
        keyword: string
        category?: string
        searchVolume?: number
        currentRank?: number
        source?: string
        relatedInsightId?: string
        relatedJobId?: string
        notes?: string
    }

    export interface UpsertTemplateInput {
        id?: string
        name: string
        description?: string
        targetPersona?: Persona
        targetLayers?: number[]
        questions: DiscoveryQuestion[]
        estimatedDuration?: number
    }

    export type ZacCapability = "full" | "partial" | "planned" | "none"

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.activityEndpoint = this.activityEndpoint.bind(this)
            this.alternativeSignalsEndpoint = this.alternativeSignalsEndpoint.bind(this)
            this.analyzeEndpoint = this.analyzeEndpoint.bind(this)
            this.assignJobEndpoint = this.assignJobEndpoint.bind(this)
            this.atRiskEndpoint = this.atRiskEndpoint.bind(this)
            this.bulkImportEndpoint = this.bulkImportEndpoint.bind(this)
            this.changeStageEndpoint = this.changeStageEndpoint.bind(this)
            this.createAssumptionEndpoint = this.createAssumptionEndpoint.bind(this)
            this.createPersonEndpoint = this.createPersonEndpoint.bind(this)
            this.createTouchpointEndpoint = this.createTouchpointEndpoint.bind(this)
            this.csvImportEndpoint = this.csvImportEndpoint.bind(this)
            this.deleteSeoEndpoint = this.deleteSeoEndpoint.bind(this)
            this.enrichPendingEndpoint = this.enrichPendingEndpoint.bind(this)
            this.enrichPersonEndpoint = this.enrichPersonEndpoint.bind(this)
            this.extractEndpoint = this.extractEndpoint.bind(this)
            this.funnelEndpoint = this.funnelEndpoint.bind(this)
            this.getAssumptionEndpoint = this.getAssumptionEndpoint.bind(this)
            this.getJobEndpoint = this.getJobEndpoint.bind(this)
            this.getPersonByEmailEndpoint = this.getPersonByEmailEndpoint.bind(this)
            this.getPersonEndpoint = this.getPersonEndpoint.bind(this)
            this.getTemplateEndpoint = this.getTemplateEndpoint.bind(this)
            this.jobsSignalsEndpoint = this.jobsSignalsEndpoint.bind(this)
            this.listAllInterviewsEndpoint = this.listAllInterviewsEndpoint.bind(this)
            this.listAlternativesEndpoint = this.listAlternativesEndpoint.bind(this)
            this.listAssumptionsEndpoint = this.listAssumptionsEndpoint.bind(this)
            this.listInsightsEndpoint = this.listInsightsEndpoint.bind(this)
            this.listJobsEndpoint = this.listJobsEndpoint.bind(this)
            this.listMilestonesEndpoint = this.listMilestonesEndpoint.bind(this)
            this.listPeopleEndpoint = this.listPeopleEndpoint.bind(this)
            this.listPersonInterviewsEndpoint = this.listPersonInterviewsEndpoint.bind(this)
            this.listPersonJobsEndpoint = this.listPersonJobsEndpoint.bind(this)
            this.listResearchEndpoint = this.listResearchEndpoint.bind(this)
            this.listSeoEndpoint = this.listSeoEndpoint.bind(this)
            this.listTemplatesEndpoint = this.listTemplatesEndpoint.bind(this)
            this.listTouchpointsEndpoint = this.listTouchpointsEndpoint.bind(this)
            this.personalizeEndpoint = this.personalizeEndpoint.bind(this)
            this.recordMilestoneEndpoint = this.recordMilestoneEndpoint.bind(this)
            this.researchSignalsEndpoint = this.researchSignalsEndpoint.bind(this)
            this.researchStatsEndpoint = this.researchStatsEndpoint.bind(this)
            this.scrapeAllEndpoint = this.scrapeAllEndpoint.bind(this)
            this.scrapeEndpoint = this.scrapeEndpoint.bind(this)
            this.seedEndpoint = this.seedEndpoint.bind(this)
            this.seedTarget100Endpoint = this.seedTarget100Endpoint.bind(this)
            this.segmentsEndpoint = this.segmentsEndpoint.bind(this)
            this.seoSuggestionsEndpoint = this.seoSuggestionsEndpoint.bind(this)
            this.stagesEndpoint = this.stagesEndpoint.bind(this)
            this.submitInterviewEndpoint = this.submitInterviewEndpoint.bind(this)
            this.syncBenchmarksEndpoint = this.syncBenchmarksEndpoint.bind(this)
            this.trackEndpoint = this.trackEndpoint.bind(this)
            this.updateAssumptionEndpoint = this.updateAssumptionEndpoint.bind(this)
            this.updatePersonEndpoint = this.updatePersonEndpoint.bind(this)
            this.updatePersonJobEndpoint = this.updatePersonJobEndpoint.bind(this)
            this.upsertAlternativeEndpoint = this.upsertAlternativeEndpoint.bind(this)
            this.upsertJobEndpoint = this.upsertJobEndpoint.bind(this)
            this.upsertSeoEndpoint = this.upsertSeoEndpoint.bind(this)
            this.upsertTemplateEndpoint = this.upsertTemplateEndpoint.bind(this)
        }

        public async activityEndpoint(): Promise<{
    items: Touchpoint[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/signals/activity`)
            return await resp.json() as {
    items: Touchpoint[]
}
        }

        public async alternativeSignalsEndpoint(): Promise<{
    alternatives: AlternativeSignal[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/signals/alternatives`)
            return await resp.json() as {
    alternatives: AlternativeSignal[]
}
        }

        public async analyzeEndpoint(): Promise<{
    analyzed: number
    errors: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/research/analyze`)
            return await resp.json() as {
    analyzed: number
    errors: number
}
        }

        public async assignJobEndpoint(id: string, params: AssignJobRequest): Promise<{
    id: string
    personId: string
    jobId: string
    importance: number
    satisfaction: number | null
    currentApproach: string | null
    notes: string | null
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/people/${encodeURIComponent(id)}/jobs`, JSON.stringify(params))
            return await resp.json() as {
    id: string
    personId: string
    jobId: string
    importance: number
    satisfaction: number | null
    currentApproach: string | null
    notes: string | null
}
        }

        public async atRiskEndpoint(): Promise<{
    items: {
        id: string
        name: string
        company: string | null
        stage: string
        daysSinceActivity: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/signals/at-risk`)
            return await resp.json() as {
    items: {
        id: string
        name: string
        company: string | null
        stage: string
        daysSinceActivity: number
    }[]
}
        }

        public async bulkImportEndpoint(params: BulkImportRequest): Promise<BulkImportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/people/bulk`, JSON.stringify(params))
            return await resp.json() as BulkImportResponse
        }

        public async changeStageEndpoint(id: string, params: ChangeStageRequest): Promise<Person> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/people/${encodeURIComponent(id)}/stage`, JSON.stringify(params))
            return await resp.json() as Person
        }

        public async createAssumptionEndpoint(params: CreateAssumptionInput): Promise<Assumption> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/assumptions`, JSON.stringify(params))
            return await resp.json() as Assumption
        }

        public async createPersonEndpoint(params: CreatePersonRequest): Promise<Person> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/people`, JSON.stringify(params))
            return await resp.json() as Person
        }

        public async createTouchpointEndpoint(id: string, params: CreateTouchpointRequest): Promise<Touchpoint> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/people/${encodeURIComponent(id)}/touchpoints`, JSON.stringify(params))
            return await resp.json() as Touchpoint
        }

        public async csvImportEndpoint(params: CsvImportRequest): Promise<{
    created: number
    skipped: number
    errors: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/people/csv-import`, JSON.stringify(params))
            return await resp.json() as {
    created: number
    skipped: number
    errors: string[]
}
        }

        public async deleteSeoEndpoint(id: string): Promise<{
    deleted: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/pmf/seo/queries/${encodeURIComponent(id)}`)
            return await resp.json() as {
    deleted: boolean
}
        }

        public async enrichPendingEndpoint(): Promise<{
    total: number
    results: {
        personId: string
        apolloFound: boolean
        errors: string[]
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/people/enrich-pending`)
            return await resp.json() as {
    total: number
    results: {
        personId: string
        apolloFound: boolean
        errors: string[]
    }[]
}
        }

        public async enrichPersonEndpoint(id: string): Promise<{
    personId: string
    apolloFound: boolean
    linkedinFound: boolean
    personaClassified: boolean
    errors: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/people/${encodeURIComponent(id)}/enrich`)
            return await resp.json() as {
    personId: string
    apolloFound: boolean
    linkedinFound: boolean
    personaClassified: boolean
    errors: string[]
}
        }

        public async extractEndpoint(): Promise<{
    insightsCreated: number
    jobsUpdated: number
    alternativesUpdated: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/research/extract`)
            return await resp.json() as {
    insightsCreated: number
    jobsUpdated: number
    alternativesUpdated: number
}
        }

        public async funnelEndpoint(): Promise<{
    steps: FunnelStep[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/signals/funnel`)
            return await resp.json() as {
    steps: FunnelStep[]
}
        }

        public async getAssumptionEndpoint(id: string): Promise<Assumption> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/assumptions/${encodeURIComponent(id)}`)
            return await resp.json() as Assumption
        }

        public async getJobEndpoint(id: string): Promise<Job> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/jobs/${encodeURIComponent(id)}`)
            return await resp.json() as Job
        }

        public async getPersonByEmailEndpoint(email: string): Promise<Person> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/people/by-email/${encodeURIComponent(email)}`)
            return await resp.json() as Person
        }

        public async getPersonEndpoint(id: string): Promise<Person> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/people/${encodeURIComponent(id)}`)
            return await resp.json() as Person
        }

        public async getTemplateEndpoint(id: string): Promise<DiscoveryTemplate> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/discovery/templates/${encodeURIComponent(id)}`)
            return await resp.json() as DiscoveryTemplate
        }

        public async jobsSignalsEndpoint(): Promise<{
    jobs: JobSignal[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/signals/jobs`)
            return await resp.json() as {
    jobs: JobSignal[]
}
        }

        public async listAllInterviewsEndpoint(): Promise<{
    items: Interview[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/interviews`)
            return await resp.json() as {
    items: Interview[]
}
        }

        public async listAlternativesEndpoint(): Promise<{
    items: Alternative[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/alternatives`)
            return await resp.json() as {
    items: Alternative[]
}
        }

        public async listAssumptionsEndpoint(params: ListAssumptionsRequest): Promise<{
    items: Assumption[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category:     params.category,
                pyramidLayer: params.pyramidLayer === undefined ? undefined : String(params.pyramidLayer),
                risk:         params.risk,
                status:       params.status,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/assumptions`, undefined, {query})
            return await resp.json() as {
    items: Assumption[]
}
        }

        public async listInsightsEndpoint(params: ListInsightsRequest): Promise<{
    items: {
        id: string
        researchId: string
        pyramidLayer: number
        type: string
        content: string
        confidence: number | null
        createdAt: string
    }[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:        params.limit === undefined ? undefined : String(params.limit),
                pyramidLayer: params.pyramidLayer === undefined ? undefined : String(params.pyramidLayer),
                type:         params.type,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/research/insights`, undefined, {query})
            return await resp.json() as {
    items: {
        id: string
        researchId: string
        pyramidLayer: number
        type: string
        content: string
        confidence: number | null
        createdAt: string
    }[]
}
        }

        public async listJobsEndpoint(): Promise<{
    items: Job[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/jobs`)
            return await resp.json() as {
    items: Job[]
}
        }

        public async listMilestonesEndpoint(id: string): Promise<{
    items: Milestone[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/people/${encodeURIComponent(id)}/milestones`)
            return await resp.json() as {
    items: Milestone[]
}
        }

        public async listPeopleEndpoint(params: ListPeopleRequest): Promise<ListPeopleResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                industry: params.industry,
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
                persona:  params.persona,
                search:   params.search,
                source:   params.source,
                stage:    params.stage,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/people`, undefined, {query})
            return await resp.json() as ListPeopleResponse
        }

        public async listPersonInterviewsEndpoint(id: string): Promise<{
    items: Interview[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/people/${encodeURIComponent(id)}/interviews`)
            return await resp.json() as {
    items: Interview[]
}
        }

        public async listPersonJobsEndpoint(id: string): Promise<{
    items: {
        id: string
        personId: string
        jobId: string
        importance: number
        satisfaction: number | null
        currentApproach: string | null
        notes: string | null
        job: Job
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/people/${encodeURIComponent(id)}/jobs`)
            return await resp.json() as {
    items: {
        id: string
        personId: string
        jobId: string
        importance: number
        satisfaction: number | null
        currentApproach: string | null
        notes: string | null
        job: Job
    }[]
}
        }

        public async listResearchEndpoint(params: ListResearchRequest): Promise<{
    items: {
        id: string
        source: string
        title: string | null
        analyzed: boolean
        scrapedAt: string
    }[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                analyzed: params.analyzed === undefined ? undefined : String(params.analyzed),
                limit:    params.limit === undefined ? undefined : String(params.limit),
                source:   params.source,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/research/items`, undefined, {query})
            return await resp.json() as {
    items: {
        id: string
        source: string
        title: string | null
        analyzed: boolean
        scrapedAt: string
    }[]
}
        }

        public async listSeoEndpoint(params: ListSeoRequest): Promise<{
    items: SeoQuery[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                keyword:  params.keyword,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/seo/queries`, undefined, {query})
            return await resp.json() as {
    items: SeoQuery[]
}
        }

        public async listTemplatesEndpoint(): Promise<{
    items: DiscoveryTemplate[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/discovery/templates`)
            return await resp.json() as {
    items: DiscoveryTemplate[]
}
        }

        public async listTouchpointsEndpoint(id: string, params: ListTouchpointsRequest): Promise<{
    items: Touchpoint[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                category: params.category,
                limit:    params.limit === undefined ? undefined : String(params.limit),
                offset:   params.offset === undefined ? undefined : String(params.offset),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/people/${encodeURIComponent(id)}/touchpoints`, undefined, {query})
            return await resp.json() as {
    items: Touchpoint[]
}
        }

        public async personalizeEndpoint(email: string): Promise<PersonalizationProfile> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/personalize/${encodeURIComponent(email)}`)
            return await resp.json() as PersonalizationProfile
        }

        public async recordMilestoneEndpoint(params: RecordMilestoneRequest): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/milestone`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        public async researchSignalsEndpoint(): Promise<{
    bySource: {
        source: string
        items: number
        analyzed: number
        insights: number
    }[]
    trends: {
        type: string
        count: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/signals/research`)
            return await resp.json() as {
    bySource: {
        source: string
        items: number
        analyzed: number
        insights: number
    }[]
    trends: {
        type: string
        count: number
    }[]
}
        }

        public async researchStatsEndpoint(): Promise<{
    bySource: {
        source: string
        items: number
        analyzed: number
        insights: number
    }[]
    trends: {
        type: string
        count: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/research/stats`)
            return await resp.json() as {
    bySource: {
        source: string
        items: number
        analyzed: number
        insights: number
    }[]
    trends: {
        type: string
        count: number
    }[]
}
        }

        public async scrapeAllEndpoint(): Promise<{
    results: {
        source: string
        itemsScraped: number
        itemsStored: number
        errors: string[]
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/research/scrape-all`)
            return await resp.json() as {
    results: {
        source: string
        itemsScraped: number
        itemsStored: number
        errors: string[]
    }[]
}
        }

        public async scrapeEndpoint(params: ScrapeRequest): Promise<{
    source: string
    itemsScraped: number
    itemsStored: number
    duplicatesSkipped: number
    errors: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/research/scrape`, JSON.stringify(params))
            return await resp.json() as {
    source: string
    itemsScraped: number
    itemsStored: number
    duplicatesSkipped: number
    errors: string[]
}
        }

        public async seedEndpoint(): Promise<{
    alternatives: number
    templates: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/seed`)
            return await resp.json() as {
    alternatives: number
    templates: number
}
        }

        public async seedTarget100Endpoint(): Promise<{
    created: number
    skipped: number
    errors: string[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/seed/target-100`)
            return await resp.json() as {
    created: number
    skipped: number
    errors: string[]
}
        }

        public async segmentsEndpoint(): Promise<{
    segments: SegmentMetrics[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/signals/segments`)
            return await resp.json() as {
    segments: SegmentMetrics[]
}
        }

        public async seoSuggestionsEndpoint(): Promise<{
    suggestions: {
        keyword: string
        category: string
        insightCount: number
    }[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/seo/suggestions`)
            return await resp.json() as {
    suggestions: {
        keyword: string
        category: string
        insightCount: number
    }[]
}
        }

        public async stagesEndpoint(): Promise<{
    stages: StageDistribution[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/pmf/signals/stages`)
            return await resp.json() as {
    stages: StageDistribution[]
}
        }

        public async submitInterviewEndpoint(id: string, params: SubmitInterviewRequest): Promise<Interview> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/people/${encodeURIComponent(id)}/interview`, JSON.stringify(params))
            return await resp.json() as Interview
        }

        public async syncBenchmarksEndpoint(params: SyncBenchmarksRequest): Promise<{
    updated: number
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/signals/sync-benchmarks`, JSON.stringify(params))
            return await resp.json() as {
    updated: number
}
        }

        public async trackEndpoint(params: TrackRequest): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/track`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        public async updateAssumptionEndpoint(id: string, params: UpdateAssumptionRequest): Promise<Assumption> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/pmf/assumptions/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as Assumption
        }

        public async updatePersonEndpoint(id: string, params: UpdatePersonRequest): Promise<Person> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/pmf/people/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as Person
        }

        public async updatePersonJobEndpoint(id: string, jobId: string, params: UpdatePersonJobRequest): Promise<{
    id: string
    personId: string
    jobId: string
    importance: number
    satisfaction: number | null
    currentApproach: string | null
    notes: string | null
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PUT", `/pmf/people/${encodeURIComponent(id)}/jobs/${encodeURIComponent(jobId)}`, JSON.stringify(params))
            return await resp.json() as {
    id: string
    personId: string
    jobId: string
    importance: number
    satisfaction: number | null
    currentApproach: string | null
    notes: string | null
}
        }

        public async upsertAlternativeEndpoint(params: UpsertAlternativeInput): Promise<Alternative> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/alternatives`, JSON.stringify(params))
            return await resp.json() as Alternative
        }

        public async upsertJobEndpoint(params: UpsertJobInput): Promise<Job> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/jobs`, JSON.stringify(params))
            return await resp.json() as Job
        }

        public async upsertSeoEndpoint(params: UpsertSeoInput): Promise<SeoQuery> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/seo/queries`, JSON.stringify(params))
            return await resp.json() as SeoQuery
        }

        public async upsertTemplateEndpoint(params: UpsertTemplateInput): Promise<DiscoveryTemplate> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/pmf/discovery/templates`, JSON.stringify(params))
            return await resp.json() as DiscoveryTemplate
        }
    }
}

export namespace repl {
    export interface ApiCallRecord {
        method: string
        path: string
        status: number
        durationMs: number
    }

    export interface ExecuteRequest {
        code: string
        mode: SandboxMode
        tenantId: string
        userId: string
        conversationId?: string
        requestId?: string
    }

    export interface ExecuteResponse {
        success: boolean
        result: any
        logs: string[]
        plannedWrites: PlannedWrite[]
        apiCalls: ApiCallRecord[]
        error?: string
        durationMs: number
    }

    export interface PlannedWrite {
        type: "api" | "browser"
        /**
         * API write fields
         */
        method?: "POST" | "PUT" | "PATCH" | "DELETE"

        path?: string
        body?: any
        /**
         * Browser write fields
         */
        bindingId?: string

        actionName?: string
        params?: { [key: string]: string }
        goal?: string
    }

    export type SandboxMode = "knowledge" | "research" | "configure"

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.execute = this.execute.bind(this)
        }

        /**
         * Execute JavaScript in a sandboxed REPL environment
         */
        public async execute(params: ExecuteRequest): Promise<ExecuteResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/repl/execute`, JSON.stringify(params))
            return await resp.json() as ExecuteResponse
        }
    }
}

export namespace report {
    export interface GetReportByIdResponse {
        id: string
        reportContent: string
        overallScore: number
        categoryScores: { [key: string]: number }
        generationTimeMs: number | null
        createdAt: string
    }

    export interface GetReportHistoryRequest {
        page?: number
        pageSize?: number
    }

    export interface GetReportHistoryResponse {
        reports: {
            id: string
            overallScore: number
            categoryScores: { [key: string]: number }
            createdAt: string
        }[]
        total: number
    }

    export interface LatestReportResponse {
        report: {
            id: string
            reportContent: string
            overallScore: number
            categoryScores: { [key: string]: number }
            generationTimeMs: number | null
            createdAt: string
        } | null
        previousScore: number | null
        isCacheFresh: boolean
    }

    export interface ReportChatHandshake {
        token?: string
        accountId?: string
        /**
         * JSON-encoded overview data
         */
        accountData?: string

        /**
         * JSON-encoded chat history
         */
        history?: string

        /**
         * User's message
         */
        message?: string

        /**
         * Planning session ID for approval flow
         */
        planningSessionId?: string
    }

    export interface ReportChatMessage {
        type: string
        content?: string
        message?: string
        interactive?: {
            type: string
            prompt?: string
            options?: {
                id: string
                label: string
                description?: string
                value: string
                icon?: string
                url?: string
            }[]
            plannedActions?: {
                order: number
                method: string
                path: string
                params: { [key: string]: any }
                description?: string
            }[]
            missingScopes?: string[]
            reconnectUrl?: string
            sessionId?: string
        }
    }

    export interface SaveReportRequest {
        reportContent: string
        overallScore: number
        categoryScores: { [key: string]: number }
        rawData?: { [key: string]: any }
        generationTimeMs: number
    }

    export interface SaveReportResponse {
        id: string
        createdAt: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getLatestReportEndpoint = this.getLatestReportEndpoint.bind(this)
            this.getReportByIdEndpoint = this.getReportByIdEndpoint.bind(this)
            this.getReportHistoryEndpoint = this.getReportHistoryEndpoint.bind(this)
            this.getReportPdf = this.getReportPdf.bind(this)
            this.reportChat = this.reportChat.bind(this)
            this.saveReportEndpoint = this.saveReportEndpoint.bind(this)
        }

        public async getLatestReportEndpoint(): Promise<LatestReportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/report/latest`)
            return await resp.json() as LatestReportResponse
        }

        public async getReportByIdEndpoint(id: string): Promise<GetReportByIdResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/report/${encodeURIComponent(id)}`)
            return await resp.json() as GetReportByIdResponse
        }

        public async getReportHistoryEndpoint(params: GetReportHistoryRequest): Promise<GetReportHistoryResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                page:     params.page === undefined ? undefined : String(params.page),
                pageSize: params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/report/history`, undefined, {query})
            return await resp.json() as GetReportHistoryResponse
        }

        public async getReportPdf(method: "GET", id: string, body?: RequestInit["body"], options?: CallParameters): Promise<globalThis.Response> {
            return this.baseClient.callAPI(method, `/report/${encodeURIComponent(id)}/pdf`, body, options)
        }

        public async reportChat(params: ReportChatHandshake): Promise<StreamIn<ReportChatMessage>> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountData:       params.accountData,
                accountId:         params.accountId,
                history:           params.history,
                message:           params.message,
                planningSessionId: params.planningSessionId,
                token:             params.token,
            })

            return await this.baseClient.createStreamIn(`/report/chat`, {query})
        }

        public async saveReportEndpoint(params: SaveReportRequest): Promise<SaveReportResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/report/save`, JSON.stringify(params))
            return await resp.json() as SaveReportResponse
        }
    }
}

export namespace validation {
    export interface ApiCheck {
        name: string
        endpoint: string
        method: string
        expectedStatus: number
        expectedFields?: string[]
        expectedValues?: { [key: string]: any }
    }

    export interface ApiValidationConfig {
        checks: ApiCheck[]
    }

    export interface ApiValidationResult {
        type: "api"
        apiDetails?: {
            checksPerformed: number
            checksPassed: number
            checksFailed: number
        }
        id: string
        planId?: string
        stageId?: string
        status: "passed" | "failed" | "warning" | "skipped"
        startedAt: string
        completedAt: string
        results: ValidationStepResult[]
        summary: string
    }

    export interface ChatValidationConfig {
        widgetUrl: string
        scenario: string
        testMessages: string[]
        expectedResponses: string[]
        maxWaitTime: number
    }

    export interface ChatValidationResult {
        type: "chat"
        chatDetails?: {
            sessionId?: string
            messageCount: number
            responseTime: number
            agentConnected?: string
        }
        id: string
        planId?: string
        stageId?: string
        status: "passed" | "failed" | "warning" | "skipped"
        startedAt: string
        completedAt: string
        results: ValidationStepResult[]
        summary: string
    }

    export interface MenuOption {
        dtmf: string
        description: string
        expectedQueue?: string
    }

    export interface RunApiValidationRequest {
        planId?: string
        stageId?: string
        config: ApiValidationConfig
    }

    export interface RunChatValidationRequest {
        planId?: string
        stageId?: string
        config: ChatValidationConfig
    }

    export interface RunVoiceValidationRequest {
        planId?: string
        stageId?: string
        config: VoiceValidationConfig
    }

    export interface ValidationResult {
        id: string
        type: ValidationType
        planId?: string
        stageId?: string
        status: "passed" | "failed" | "warning" | "skipped"
        startedAt: string
        completedAt: string
        results: ValidationStepResult[]
        summary: string
    }

    export interface ValidationStepResult {
        step: string
        status: "passed" | "failed" | "warning" | "skipped"
        message?: string
        expected?: string
        actual?: string
        duration?: number
    }

    export type ValidationType = "voice" | "chat" | "api" | "manual"

    export interface VoiceValidationConfig {
        phoneNumber: string
        scenario: string
        expectedRouting: string
        maxWaitTime: number
        menuOptions?: MenuOption[]
    }

    export interface VoiceValidationResult {
        type: "voice"
        callDetails?: {
            callId?: string
            duration: number
            queueReached?: string
            agentConnected?: string
            ivrPath: string[]
        }
        id: string
        planId?: string
        stageId?: string
        status: "passed" | "failed" | "warning" | "skipped"
        startedAt: string
        completedAt: string
        results: ValidationStepResult[]
        summary: string
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.getValidationResult = this.getValidationResult.bind(this)
            this.getValidationResults = this.getValidationResults.bind(this)
            this.validateApi = this.validateApi.bind(this)
            this.validateChat = this.validateChat.bind(this)
            this.validateVoice = this.validateVoice.bind(this)
        }

        /**
         * Get a specific validation result by ID
         */
        public async getValidationResult(id: string): Promise<{
    result: ValidationResult
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/validation/results/${encodeURIComponent(id)}`)
            return await resp.json() as {
    result: ValidationResult
}
        }

        /**
         * Get validation results for a plan
         */
        public async getValidationResults(params: {
    planId?: string
    stageId?: string
    limit?: number
}): Promise<{
    results: ValidationResult[]
}> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:   params.limit === undefined ? undefined : String(params.limit),
                planId:  params.planId,
                stageId: params.stageId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/validation/results`, undefined, {query})
            return await resp.json() as {
    results: ValidationResult[]
}
        }

        /**
         * Run API validation to verify configuration via API calls
         */
        public async validateApi(params: RunApiValidationRequest): Promise<ApiValidationResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/validation/api`, JSON.stringify(params))
            return await resp.json() as ApiValidationResult
        }

        /**
         * Run chat validation to test webchat flows
         */
        public async validateChat(params: RunChatValidationRequest): Promise<ChatValidationResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/validation/chat`, JSON.stringify(params))
            return await resp.json() as ChatValidationResult
        }

        /**
         * Run voice validation to test IVR and call routing
         */
        public async validateVoice(params: RunVoiceValidationRequest): Promise<VoiceValidationResult> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/validation/voice`, JSON.stringify(params))
            return await resp.json() as VoiceValidationResult
        }
    }
}

export namespace verification {
    export interface VerifyRequest {
        executionResult: shared.ExecutionResult
        mode?: shared.VerificationMode
        options?: {
            readBackRetries?: number
            readBackDelayMs?: number
            webhookTimeoutMs?: number
            syntheticTestConfig?: {
                enabled: boolean
                testPhoneNumber?: string
                testAgentEmail?: string
            }
        }
    }

    export interface VerifyResponse {
        result: shared.VerificationResult
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.recordWebhook = this.recordWebhook.bind(this)
            this.registerWebhookExpectation = this.registerWebhookExpectation.bind(this)
            this.stateDiff = this.stateDiff.bind(this)
            this.verify = this.verify.bind(this)
            this.verifyResource = this.verifyResource.bind(this)
        }

        /**
         * Record received webhook
         */
        public async recordWebhook(params: {
    event: string
    payload: { [key: string]: any }
}): Promise<{
    processed: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/verification/webhooks/received`, JSON.stringify(params))
            return await resp.json() as {
    processed: boolean
}
        }

        /**
         * Register webhook expectations
         */
        public async registerWebhookExpectation(params: {
    resourceType: string
    resourceId: string
    expectedEvent: string
    timeoutMs?: number
}): Promise<{
    confirmation: shared.WebhookConfirmation
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/verification/webhooks/expect`, JSON.stringify(params))
            return await resp.json() as {
    confirmation: shared.WebhookConfirmation
}
        }

        /**
         * Run state diff for an account
         */
        public async stateDiff(params: {
    executionResult: shared.ExecutionResult
}): Promise<{
    diff: shared.StateDiff
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/verification/state-diff`, JSON.stringify(params))
            return await resp.json() as {
    diff: shared.StateDiff
}
        }

        /**
         * Verify an execution result
         */
        public async verify(params: VerifyRequest): Promise<VerifyResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/verification/verify`, JSON.stringify(params))
            return await resp.json() as VerifyResponse
        }

        /**
         * Run read-back verification for a single resource
         */
        public async verifyResource(params: {
    resourceType: string
    resourceId: string
    expectedFields: { [key: string]: any }
}): Promise<{
    verification: shared.ReadBackVerification
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/verification/resource`, JSON.stringify(params))
            return await resp.json() as {
    verification: shared.ReadBackVerification
}
        }
    }
}

export namespace zoom {
    export interface ApiRequest {
        method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE"
        endpoint: string
        data?: { [key: string]: any }
        credentials?: shared.ZoomCredentials
    }

    export interface ApiRequest {
        method: "GET" | "POST" | "PATCH" | "PUT" | "DELETE"
        endpoint: string
        data?: { [key: string]: any }
        credentials?: shared.ZoomCredentials
    }

    export interface ApiResponse {
        data: any
        status: number
    }

    export interface ResourceListResponse {
        resources: {
            id: string
            name: string
            type: string
            properties: { [key: string]: any }
        }[]
        nextPageToken?: string
        total?: number
    }

    export class ServiceClient {
        private baseClient: BaseClient

        constructor(baseClient: BaseClient) {
            this.baseClient = baseClient
            this.createQueue = this.createQueue.bind(this)
            this.createScorecard = this.createScorecard.bind(this)
            this.createSkill = this.createSkill.bind(this)
            this.deleteQueue = this.deleteQueue.bind(this)
            this.executeBatch = this.executeBatch.bind(this)
            this.executeRequest = this.executeRequest.bind(this)
            this.getAccount = this.getAccount.bind(this)
            this.getAccountInsights = this.getAccountInsights.bind(this)
            this.getAllUsersWithServices = this.getAllUsersWithServices.bind(this)
            this.getContactCenterSummary = this.getContactCenterSummary.bind(this)
            this.getDashboard = this.getDashboard.bind(this)
            this.getFlows = this.getFlows.bind(this)
            this.getProfile = this.getProfile.bind(this)
            this.getQueue = this.getQueue.bind(this)
            this.getQueues = this.getQueues.bind(this)
            this.getSkills = this.getSkills.bind(this)
            this.getUsers = this.getUsers.bind(this)
            this.getZoomAccountInfo = this.getZoomAccountInfo.bind(this)
            this.listAddressBooks = this.listAddressBooks.bind(this)
            this.listFlows = this.listFlows.bind(this)
            this.listQueues = this.listQueues.bind(this)
            this.listScorecards = this.listScorecards.bind(this)
            this.listSkills = this.listSkills.bind(this)
            this.searchUsers = this.searchUsers.bind(this)
            this.updateQueue = this.updateQueue.bind(this)
            this.verifyCredentials = this.verifyCredentials.bind(this)
        }

        /**
         * Create queue
         */
        public async createQueue(params: {
    name: string
    channel: string
    settings?: { [key: string]: any }
}): Promise<{
    id: string
    resource: any
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/contact-center/queues`, JSON.stringify(params))
            return await resp.json() as {
    id: string
    resource: any
}
        }

        /**
         * Create scorecard
         */
        public async createScorecard(params: {
    name: string
    description?: string
    sections: {
        name: string
        weight: number
        questions: any[]
    }[]
}): Promise<{
    id: string
    resource: any
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/quality-management/scorecards`, JSON.stringify(params))
            return await resp.json() as {
    id: string
    resource: any
}
        }

        /**
         * Create skill
         */
        public async createSkill(params: {
    name: string
    description?: string
}): Promise<{
    id: string
    resource: any
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/contact-center/skills`, JSON.stringify(params))
            return await resp.json() as {
    id: string
    resource: any
}
        }

        /**
         * Delete queue
         */
        public async deleteQueue(id: string): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("DELETE", `/zoom/contact-center/queues/${encodeURIComponent(id)}`)
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Batch execute multiple API requests
         */
        public async executeBatch(params: {
    requests: ApiRequest[]
}): Promise<{
    results: (ApiResponse | {
        error: string
    })[]
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/batch`, JSON.stringify(params))
            return await resp.json() as {
    results: (ApiResponse | {
        error: string
    })[]
}
        }

        /**
         * Generic Zoom API proxy - execute any API call
         */
        public async executeRequest(params: ApiRequest): Promise<ApiResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/request`, JSON.stringify(params))
            return await resp.json() as ApiResponse
        }

        /**
         * Get account information
         */
        public async getAccount(): Promise<account.GetAccountInfoResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/info`)
            return await resp.json() as account.GetAccountInfoResponse
        }

        /**
         * Get account insights and metrics
         */
        public async getAccountInsights(): Promise<account.GetInsightsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/insights`)
            return await resp.json() as account.GetInsightsResponse
        }

        /**
         * Get all users with their service assignments (Meetings, Phone, Contact Center, etc.)
         */
        public async getAllUsersWithServices(): Promise<account.GetUsersWithServicesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/users/services`)
            return await resp.json() as account.GetUsersWithServicesResponse
        }

        /**
         * Get Contact Center summary
         */
        public async getContactCenterSummary(): Promise<account.ContactCenterSummary> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/contact-center`)
            return await resp.json() as account.ContactCenterSummary
        }

        /**
         * Get dashboard data with metrics, activity, and recommendations
         */
        public async getDashboard(params: {
    /**
     * Get dashboard data with metrics, activity, and recommendations
     */
    accountId?: string
}): Promise<account.GetDashboardResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                accountId: params.accountId,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/dashboard`, undefined, {query})
            return await resp.json() as account.GetDashboardResponse
        }

        /**
         * List flows
         */
        public async getFlows(): Promise<account.ListFlowsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/flows`)
            return await resp.json() as account.ListFlowsResponse
        }

        /**
         * Get comprehensive Zoom account profile
         */
        public async getProfile(): Promise<{
    /**
     * Get comprehensive Zoom account profile
     */
    profile: account.ZoomAccountProfile
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/profile`)
            return await resp.json() as {
    /**
     * Get comprehensive Zoom account profile
     */
    profile: account.ZoomAccountProfile
}
        }

        /**
         * Get queue by ID
         */
        public async getQueue(id: string): Promise<{
    resource: any
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/queues/${encodeURIComponent(id)}`)
            return await resp.json() as {
    resource: any
}
        }

        /**
         * List queues
         */
        public async getQueues(): Promise<account.ListQueuesResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/queues`)
            return await resp.json() as account.ListQueuesResponse
        }

        /**
         * List skills
         */
        public async getSkills(): Promise<account.ListSkillsResponse> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/skills`)
            return await resp.json() as account.ListSkillsResponse
        }

        /**
         * List Contact Center users
         */
        public async getUsers(params: account.ListUsersRequest): Promise<account.ListUsersResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit:  params.limit === undefined ? undefined : String(params.limit),
                offset: params.offset === undefined ? undefined : String(params.offset),
                search: params.search,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/users`, undefined, {query})
            return await resp.json() as account.ListUsersResponse
        }

        /**
         * Get account info and licenses
         */
        public async getZoomAccountInfo(): Promise<shared.ZoomAccountInfo> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/account`)
            return await resp.json() as shared.ZoomAccountInfo
        }

        /**
         * List address books
         */
        public async listAddressBooks(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/address-books`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * List flows
         */
        public async listFlows(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/flows`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * List queues
         */
        public async listQueues(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/queues`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * List scorecards
         */
        public async listScorecards(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/quality-management/scorecards`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * List skills
         */
        public async listSkills(params: {
    pageSize?: number
    nextPageToken?: string
}): Promise<ResourceListResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                nextPageToken: params.nextPageToken,
                pageSize:      params.pageSize === undefined ? undefined : String(params.pageSize),
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/zoom/contact-center/skills`, undefined, {query})
            return await resp.json() as ResourceListResponse
        }

        /**
         * Search users
         */
        public async searchUsers(params: {
    /**
     * Search users
     */
    query: string

    /**
     * Search users
     */
    limit?: number
}): Promise<account.ListUsersResponse> {
            // Convert our params into the objects we need for the request
            const query = makeRecord<string, string | string[]>({
                limit: params.limit === undefined ? undefined : String(params.limit),
                query: params.query,
            })

            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("GET", `/account/users/search`, undefined, {query})
            return await resp.json() as account.ListUsersResponse
        }

        /**
         * Update queue
         */
        public async updateQueue(id: string, params: {
    updates: { [key: string]: any }
}): Promise<{
    success: boolean
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("PATCH", `/zoom/contact-center/queues/${encodeURIComponent(id)}`, JSON.stringify(params))
            return await resp.json() as {
    success: boolean
}
        }

        /**
         * Verify Zoom credentials and get account info
         */
        public async verifyCredentials(params: shared.ZoomCredentials): Promise<{
    valid: boolean
    account?: shared.ZoomAccountInfo
    error?: string
}> {
            // Now make the actual call to the API
            const resp = await this.baseClient.callTypedAPI("POST", `/zoom/verify`, JSON.stringify(params))
            return await resp.json() as {
    valid: boolean
    account?: shared.ZoomAccountInfo
    error?: string
}
        }
    }
}

export namespace account {
    export interface ContactCenterSummary {
        queues: {
            total: number
            byChannel: { [key: string]: number }
        }
        skills: {
            total: number
        }
        flows: {
            total: number
            byStatus: { [key: string]: number }
        }
        agents: {
            total: number
        }
    }

    export interface GetAccountInfoResponse {
        account: ZoomAccountInfo
    }

    export interface GetDashboardResponse {
        dashboard: ZoomDashboardData
    }

    export interface GetInsightsResponse {
        insights: ZoomAccountInsights
    }

    export interface GetUsersWithServicesResponse {
        users: ZoomUserWithServices[]
        total: number
        summary: {
            totalUsers: number
            byLicense: { [key: string]: number }
        }
        scopeErrors: string[]
    }

    export interface ListFlowsResponse {
        flows: ZoomFlowInfo[]
        total: number
    }

    export interface ListQueuesResponse {
        queues: ZoomQueueInfo[]
        total: number
    }

    export interface ListSkillsResponse {
        skills: ZoomSkillInfo[]
        total: number
    }

    export interface ListUsersRequest {
        limit?: number
        offset?: number
        search?: string
    }

    export interface ListUsersResponse {
        users: ZoomUser[]
        total: number
        hasMore: boolean
    }

    export interface ZoomAccountInfo {
        id: string
        name: string
        ownerEmail?: string
        type?: string
        planType?: string
        userCount?: number
        contactCenterEnabled: boolean
    }

    export interface ZoomAccountInsights {
        account: ZoomAccountInfo
        queues: number
        skills: number
        flows: number
        agents: number
        licenses: {
            total: number
            assigned: number
            available: number
        }
        products: ZoomProductAccess
    }

    export interface ZoomAccountProfile {
        /**
         * Identity
         */
        account: {
            id: string
            name: string
            type: string | "Pro" | "Business" | "Enterprise"
            owner: string
            vanityUrl?: string
        }

        /**
         * Licensing
         */
        subscription: {
            startDate: string
            endDate: string
            daysRemaining: number
        }

        plans: ZoomPlanInfo[]
        /**
         * Users
         */
        users: {
            total: number
            licensed: number
            basic: number
            stale: number
        }

        /**
         * Product Adoption
         */
        adoption: {
            meetings: {
                totalMeetings: number
                uniqueHosts: number
                avgParticipants: number
            }
            aiCompanion: {
                adoptionRate: number
                lowAdoptionUsers: {
                    email: string
                    rate: number
                }[]
            }
            teamChat: {
                activeUsers: number
                totalMessages: number
            }
            phone: {
                usersAssigned: number
                usersWithNumbers: number
            }
            contactCenter: {
                usersAssigned: number
                queuesConfigured: number
                flowsPublished: number
            }
        }

        /**
         * Issues
         */
        issues: ZoomProfileIssue[]
    }

    export interface ZoomDailyActivity {
        date: string
        meetings: {
            count: number
            participants: number
            aiCompanionRate: number
        }
        chat: {
            messages: number
            activeUsers: number
        }
        phone: {
            calls: number
            minutes: number
        }
        contactCenter: {
            interactions: number
            avgHandleTime: number
        }
        clips: {
            created: number
            views: number
        }
    }

    export interface ZoomDashboardData {
        account: {
            name: string
            type: string
            owner: string
        }
        /**
         * Key metrics (top row)
         */
        metrics: {
            adoptionScore: ZoomMetricWithTrend
            licenseUtilization: {
                value: number
                used: number
                total: number
                direction: "up" | "down" | "stable"
            }
            aiCompanion: ZoomMetricWithTrend
            seatsUsed: {
                used: number
                total: number
                warning: boolean
            }
            issues: {
                total: number
                high: number
                medium: number
                low: number
                change: number
                direction: "up" | "down" | "stable"
            }
        }

        /**
         * Product activity chart (180 days: -90 to +90)
         */
        activity: {
            past: ZoomDailyActivity[]
            future: ZoomFutureActivity[]
        }

        /**
         * Product adoption rates
         */
        adoption: {
            product: string
            rate: number
            trend: "up" | "down" | "stable"
        }[]

        /**
         * User product matrix
         */
        userMatrix: ZoomUserProductRow[]

        /**
         * Active issues
         */
        issues: ZoomProfileIssue[]

        /**
         * Recommendations
         */
        recommendations: ZoomRecommendation[]
    }

    export interface ZoomFlowInfo {
        id: string
        name: string
        type: string
        status: string
        channel: string
    }

    export interface ZoomFutureActivity {
        date: string
        meetings: {
            scheduled: number
            recurring: number
        }
    }

    export interface ZoomMetricWithTrend {
        value: number
        change: number
        direction: "up" | "down" | "stable"
    }

    export interface ZoomPlanInfo {
        name: string
        type: string | "addon" | "phone" | "zcc"
        seats: number
        used: number
        status: string | "trial"
        renewalDate?: string
    }

    export interface ZoomProductAccess {
        contactCenter: boolean
        virtualAgent: boolean
        qualityManagement: boolean
        workforceManagement: boolean
        expertAssist: boolean
        outboundDialer: boolean
    }

    export interface ZoomProductScore {
        score: number
        intensity: "high" | "medium" | "low" | "none"
    }

    export interface ZoomProfileIssue {
        severity: "high" | "medium" | "low"
        type: string
        message: string
        recommendation?: string
        chatPrompt?: string
    }

    export interface ZoomQueueInfo {
        id: string
        name: string
        channel: string
        status: string
        agentCount: number
    }

    export interface ZoomRecommendation {
        id: string
        type: "adoption" | "enablement" | "optimization" | "configuration" | "training"
        priority: "high" | "medium" | "low"
        title: string
        description: string
        impact: string
        product: string
        affectedUsers?: string[]
        actions: ZoomRecommendationAction[]
    }

    export interface ZoomRecommendationAction {
        label: string
        type: "chat" | "link" | "dismiss"
        chatPrompt?: string
        url?: string
    }

    export interface ZoomSkillInfo {
        id: string
        name: string
        description?: string
        agentCount: number
    }

    export interface ZoomUser {
        id: string
        email: string
        name: string
        role: string
        status: string
        queues: string[]
        skills: string[]
    }

    export interface ZoomUserProductRow {
        email: string
        name: string
        type: "licensed" | "basic"
        products: {
            meetings: ZoomProductScore
            aiCompanion: ZoomProductScore
            chat: ZoomProductScore
            phone: ZoomProductScore
            contactCenter: ZoomProductScore
            clips: ZoomProductScore
            rooms: ZoomProductScore
        }
        overallScore: number
    }

    export interface ZoomUserWithServices {
        id: string
        email: string
        name: string
        role: string
        status: string
        department?: string
        licenses: string[]
    }
}

export namespace changes {
    export interface CreatePlanRequest {
        goal: string
        conversationId?: string
        options?: {
            runFunctionalTests?: boolean
            dryRun?: boolean
        }
    }

    export interface CreatePlanResponse {
        plan: Plan
        steps: PlanStep[]
    }

    export interface ExecutePlanResponse {
        execution: PlanExecution
        steps: StepExecution[]
    }

    export type ExecutionStatus = "running" | "completed" | "failed" | "cancelled"

    export interface FunctionalTest {
        type: "call_test" | "chat_test" | "api_test"
        scenario: string
        setup?: { [key: string]: any }
        expectedBehavior: string
        verifyEndpoint?: string
        timeoutMs?: number
    }

    export interface Plan {
        id: string
        title: string
        goal: string
        status: PlanStatus
        createdAt: number
        updatedAt: number
        conversationId?: string
        userId?: string
        steps?: PlanStep[]
    }

    export interface PlanExecution {
        id: string
        planId: string
        status: ExecutionStatus
        startedAt: number
        completedAt?: number
        error?: string
        stepExecutions?: StepExecution[]
    }

    export type PlanStatus = "draft" | "approved" | "executing" | "completed" | "failed" | "cancelled"

    export interface PlanStatusResponse {
        plan: Plan
        execution?: PlanExecution
        steps: {
            id: string
            planId: string
            sequence: number
            description: string
            status: StepStatus
            dependsOn: string[]
            /**
             * Endpoint information (from KB)
             */
            endpoint?: {
                method: string
                path: string
                summary?: string
            }

            /**
             * Parameters for the API call
             */
            params?: { [key: string]: any }

            /**
             * Verification criteria (from KB VerificationRule)
             */
            verification?: StepVerification

            /**
             * Link to source guide step (optional)
             */
            guideStepId?: string

            execution?: StepExecution
        }[]
        progress: {
            total: number
            completed: number
            failed: number
            pending: number
        }
    }

    export interface PlanStep {
        id: string
        planId: string
        sequence: number
        description: string
        status: StepStatus
        dependsOn: string[]
        /**
         * Endpoint information (from KB)
         */
        endpoint?: {
            method: string
            path: string
            summary?: string
        }

        /**
         * Parameters for the API call
         */
        params?: { [key: string]: any }

        /**
         * Verification criteria (from KB VerificationRule)
         */
        verification?: StepVerification

        /**
         * Link to source guide step (optional)
         */
        guideStepId?: string
    }

    export interface RollbackPlanResponse {
        success: boolean
        rolledBack: number
        failed: number
        errors?: string[]
    }

    export interface StepExecution {
        id: string
        executionId: string
        stepId: string
        status: StepStatus
        startedAt: number
        completedAt?: number
        /**
         * Request/response details
         */
        request?: {
            method: string
            path: string
            body?: any
        }

        response?: {
            status: number
            body?: any
        }
        error?: {
            message: string
            code?: string
        }
        /**
         * Verification results
         */
        verificationResult?: {
            passed: boolean
            checks?: {
                field: string
                expected: any
                actual: any
                passed: boolean
            }[]
            functionalTestResult?: {
                passed: boolean
                details?: string
            }
        }

        /**
         * Created entities (for rollback)
         */
        createdEntities?: {
            type: string
            id: string
            name?: string
        }[]
    }

    export type StepStatus = "pending" | "in_progress" | "completed" | "failed" | "skipped"

    export interface StepVerification {
        level: VerificationLevel
        verifyEndpoint?: string
        extractId?: string
        checks?: {
            field: string
            source: string
            expected?: any
        }[]
        functionalTest?: FunctionalTest
    }

    export type VerificationLevel = "immediate" | "entity" | "relationship" | "functional" | "e2e"
}

export namespace experiments {
    export interface ApproachResult {
        matched: boolean
        endpoint?: {
            method: string
            path: string
        }
        latencyMs: number
        tokensUsed?: number
    }

    export interface BenchmarkResponse {
        totalQueries: number
        results: QueryResult[]
        summary: {
            embeddings: {
                accuracy: number
                avgLatencyMs: number
            }
            "llm_routing": {
                accuracy: number
                avgLatencyMs: number
            }
            structured: {
                accuracy: number
                avgLatencyMs: number
            }
        }
        winner: string
    }

    export interface ClarificationAnalysis {
        queryId: string
        query: string
        expectedEndpoint?: string
        /**
         * Embedding results
         */
        top1: TopKResult

        top2: TopKResult
        top3: TopKResult
        /**
         * Analysis
         */
        top1Correct: boolean

        ambiguityDetected: boolean
        ambiguityReason?: "close_scores" | "low_confidence"
        correctInTopK: boolean
        wouldClarify: boolean
        clarificationWouldHelp: boolean
        /**
         * Generated clarification (if ambiguous)
         */
        clarifyingQuestion?: string

        clarifyingOptions?: string[]
    }

    export interface ClarificationExperimentResponse {
        totalQueries: number
        results: ClarificationAnalysis[]
        summary: {
            baselineAccuracy: number
            ambiguityRate: number
            correctInTop3Rate: number
            theoreticalAccuracy: number
            clarificationWouldHelp: number
        }
    }

    export interface ContentStats {
        total: number
        withEmbeddings: number
        embeddingCoverage: number
        byProduct: { [key: string]: number }
        byContentType: { [key: string]: number }
        vectorIndexExists: boolean
        releaseFeatureEmbeddings: {
            total: number
            withEmbeddings: number
        }
        sampleEmbeddingLength: number | null
        sampleDocTitle: string | null
        embeddingModelUsed: string
        potentialModelMismatch: boolean
    }

    export interface CoverageGap {
        category: string
        resource: string
        issue: string
        impact: "high" | "medium" | "low"
    }

    export interface DetectorResponse {
        totalTests: number
        results: DetectorResult[]
        summary: {
            rulesAccuracy: number
            llmAccuracy: number
            hybridAccuracy: number
            rulesAvgLatency: number
            llmAvgLatency: number
            hybridAvgLatency: number
            hybridLLMCallRate: number
        }
    }

    export interface DetectorResult {
        id: string
        query: string
        expected: "simple" | "complex"
        rules: {
            prediction: "simple" | "complex"
            confidence: number
            correct: boolean
        }
        llm: {
            prediction: "simple" | "complex"
            confidence: number
            correct: boolean
            latencyMs: number
        }
        hybrid: {
            prediction: "simple" | "complex"
            confidence: number
            method: string
            correct: boolean
            latencyMs: number
        }
    }

    export interface EndpointDef {
        method: string
        path: string
        description: string
        exampleQueries?: string[]
    }

    export interface ExecutionStep {
        endpoint: string
        purpose: string
        storeAs: string
    }

    export interface ExperimentRequest {
        category?: string
        id?: string
    }

    export interface FeatureLabelDebug {
        featureOnlyCount: number
        releaseFeatureOnlyCount: number
        bothLabelsCount: number
        sampleFeature: { [key: string]: any } | null
        sampleReleaseFeature: { [key: string]: any } | null
    }

    export interface GraphStructureAnalysis {
        nodeTypes: { [key: string]: number }
        relationshipTypes: { [key: string]: number }
        issues: string[]
        strengths: string[]
        usabilityScore: number
        featureLabelDebug?: FeatureLabelDebug
    }

    export interface IntentExperimentResponse {
        totalTests: number
        results: TestResult[]
        summary: {
            intentDrivenAvgF1: number
            nativeToolsAvgF1: number
            planningModeAvgF1: number
            kbFirstAvgF1: number
            intentDrivenAvgLatency: number
            nativeToolsAvgLatency: number
            planningModeAvgLatency: number
            kbFirstAvgLatency: number
            intentDrivenWins: number
            nativeToolsWins: number
            planningModeWins: number
            kbFirstWins: number
            ties: number
        }
    }

    export interface KBReviewReport {
        timestamp: string
        summary: {
            overallHealth: "good" | "needs-attention" | "critical"
            mainIssue: string
            embeddingCoverage: number
            searchFunctional: boolean
        }
        contentStats: ContentStats
        relationshipStats: RelationshipStats
        graphStructure: GraphStructureAnalysis
        featureLabelDebug?: FeatureLabelDebug
        searchTests: SearchTestResult[]
        coverageGaps: CoverageGap[]
        recommendations: Recommendation[]
    }

    export interface MultiStepExperimentResponse {
        totalQueries: number
        results: PlanResult[]
        summary: {
            multiStepDetectionAccuracy: number
            endpointSelectionAccuracy: number
            operationAccuracy: number
            overallAccuracy: number
            avgPlanLatencyMs: number
        }
        samplePlans: {
            query: string
            plan: MultiStepPlan
        }[]
    }

    export interface MultiStepPlan {
        isMultiStep: boolean
        reasoning: string
        steps: ExecutionStep[]
        finalStep: {
            operation: "return" | "compare" | "aggregate" | "filter" | "count"
            logic: string
        }
    }

    export interface PlanResult {
        testId: string
        query: string
        expected: {
            multiStep: boolean
            endpoints: string[]
            operation: string
        }
        actual: {
            plan: MultiStepPlan
            latencyMs: number
        }
        evaluation: {
            multiStepCorrect: boolean
            endpointsCorrect: boolean
            operationCorrect: boolean
            overallCorrect: boolean
        }
    }

    export interface PlanStep {
        id: string
        operation: string
        endpoint: string
        method: "POST" | "PUT" | "PATCH" | "DELETE"
        description: string
        dependsOn: string[]
        payload: { [key: string]: any }
        outputVar?: string
    }

    export interface PlannedStep {
        tool: string
        params: { [key: string]: any }
        reason: string
    }

    export interface PlannerExperimentPlan {
        name: string
        description: string
        steps: PlanStep[]
        estimatedApiCalls: number
    }

    export interface PlannerResponse {
        plan: PlannerExperimentPlan
        validation: ValidationResult
        generationTimeMs: number
        kbContextUsed: boolean
    }

    export type Product = "contact_center" | "phone" | "virtual_agent" | "meetings" | "team_chat" | "quality_management" | "workforce_management"

    export interface ProductRoutingExperimentResponse {
        totalTests: number
        results: TestResult[]
        summary: {
            queryTypeAccuracy: number
            productFilterAccuracy: number
            disambiguationAccuracy: number
            overallAccuracy: number
            byCategory: { [key: string]: {
                total: number
                correct: number
                accuracy: number
            } }
        }
    }

    export interface QueryResult {
        id: string
        query: string
        expectedEndpoint?: string
        approaches: {
            embeddings: ApproachResult
            "llm_routing": ApproachResult
            structured: ApproachResult
        }
    }

    export interface Recommendation {
        priority: "P1" | "P2" | "P3"
        title: string
        description: string
        action: string
        estimatedEffort: string
    }

    export interface RelationshipStats {
        total: number
        byType: { [key: string]: number }
        dependencyRelationships: number
    }

    export interface SearchTestResult {
        query: string
        resultsFound: number
        topResult: string | null
        topScore: number | null
        passed: boolean
    }

    export interface TestResult {
        id: string
        query: string
        category: string
        description: string
        expected: {
            queryType: "knowledge" | "config"
            products: Product[]
            needsDisambiguation: boolean
        }
        actual: {
            queryType: "knowledge" | "config"
            products: Product[]
            needsDisambiguation: boolean
            disambiguationQuestion?: string
        }
        correct: {
            queryType: boolean
            products: boolean
            disambiguation: boolean
            overall: boolean
        }
    }

    export interface TestResult {
        id: string
        query: string
        expectedTools: string[]
        intentDriven: {
            tools: string[]
            intent: string
            f1: number
            latencyMs: number
            tokens: number
        }
        nativeTools: {
            tools: string[]
            f1: number
            latencyMs: number
            tokens: number
        }
        planningMode: {
            tools: string[]
            plan: PlannedStep[]
            f1: number
            latencyMs: number
            tokens: number
        }
        kbFirst: {
            tools: string[]
            kbUsedAlone: boolean
            f1: number
            latencyMs: number
            tokens: number
        }
        winner: string
    }

    export interface TopKResult {
        endpoint: EndpointDef
        similarity: number
    }

    export interface ValidationResult {
        valid: boolean
        errors: string[]
        warnings: string[]
        coverage: {
            skills: boolean
            queues: boolean
            flows: boolean
            addressBook: boolean
            virtualAgent: boolean
            knowledgeBase: boolean
            widgets: boolean
            expertAssist: boolean
            qualityManagement: boolean
            workforceManagement: boolean
            campaigns: boolean
        }
        dependencyOrder: boolean
    }
}

export namespace kb {
    export interface ApifyCrawlResult {
        url: string
        title: string
        markdown: string
        html?: string
        screenshotUrl?: string
        crawledAt: string
        loadedTime: string
    }

    export interface ApifyRunProgress {
        runId: string
        status: "READY" | "RUNNING" | "SUCCEEDED" | "FAILED" | "ABORTING" | "ABORTED" | "TIMING-OUT" | "TIMED-OUT"
        datasetId?: string
        /**
         * Progress info (available while RUNNING or after completion)
         */
        stats?: {
            pagesTotal: number
            pagesCrawled: number
            pagesQueued: number
            pagesFailed: number
            requestsTotal: number
            requestsFinished: number
            requestsFailed: number
        }

        /**
         * Timing
         */
        startedAt?: string

        finishedAt?: string
        durationSecs?: number
        /**
         * Resource usage
         */
        memoryUsedMb?: number

        memoryLimitMb?: number
        /**
         * Dataset size (items extracted so far)
         */
        itemCount?: number
    }

    export interface CapabilityInfo {
        name: string
        description: string
        since: string
        featureCount: number
    }

    export interface CatalogBuildResult {
        families: number
        categories: number
        products: number
        features: number
        pricingTiers: number
        pricingAddOns: number
        relationships: number
        embeddings: number
    }

    export interface CatalogProduct {
        id: string
        name: string
        aliases: string[]
        description: string
        tagline: string
        familyId: string
        categoryId: string
        features: string[]
        capabilities: string[]
        apiPrefix?: string
        licenseCheckEndpoint?: string
        releaseNotesQuery?: string
        productPageUrl?: string
        pricingPageUrl?: string
    }

    export interface CatalogQuality {
        completeness: {
            products: {
                total: number
                withDescription: number
                withFeatures: number
                withPricing: number
            }
            features: {
                total: number
                withEmbeddings: number
            }
        }
        linking: {
            toEndpoints: {
                linked: number
                avgSimilarity: number
            }
            toReleaseFeatures: {
                linked: number
                avgSimilarity: number
            }
        }
        freshness: {
            lastCrawled: string
            staleDays: number
        }
        provenance: {
            totalSources: number
            sourcesWithRawContent: number
            oldestSource: string
        }
        issues: string[]
    }

    export interface CatalogStats {
        families: number
        categories: number
        products: number
        catalogFeatures: number
        pricingTiers: number
        pricingAddOns: number
        productsByFamily: { [key: string]: number }
        featuresByProduct: { [key: string]: number }
    }

    export interface ComparisonResult {
        vision: {
            markdown: string
            length: number
            processingTimeMs: number
            tokenCount?: number
        }
        direct: {
            markdown: string
            length: number
        }
        analysis: {
            visionShorter: boolean
            lengthDifference: number
            visionHasNavGarbage: boolean
            directHasNavGarbage: boolean
        }
    }

    export interface ConceptCoverage {
        concept: string
        source: "document" | "api_resource" | "capability"
        documentCount: number
        hasGuide: boolean
    }

    export interface ContentDiff {
        url: string
        base: {
            title: string
            markdown: string
            crawledAt: string
        }
        compare: {
            title: string
            markdown: string
            crawledAt: string
        }
        lines: DiffLine[]
        stats: {
            added: number
            removed: number
            unchanged: number
        }
    }

    export interface ContentSample {
        url: string
        title: string
        contentPreview: string
        detectedProduct: string
    }

    export interface ContentTypeStats {
        type: string
        count: number
    }

    export interface CrawlDiff {
        summary: CrawlDiffSummary
        items: CrawlDiffItem[]
    }

    export interface CrawlDiffItem {
        url: string
        status: DiffStatus
        base?: {
            title: string
            contentLength: number
            contentPreview: string
        }
        compare?: {
            title: string
            contentLength: number
            contentPreview: string
        }
        contentLengthDelta?: number
    }

    export interface CrawlDiffSummary {
        sourceId: string
        baseRun: {
            runId: string
            crawledAt: string
            itemCount: number
        }
        compareRun: {
            runId: string
            crawledAt: string
            itemCount: number
        }
        added: number
        removed: number
        modified: number
        unchanged: number
    }

    export interface DataSource {
        id: string
        name: string
        type: DataSourceType
        description: string
        status: DataSourceStatus
        /**
         * Sync state machine state
         */
        syncState: SyncState

        /**
         * Detailed sync progress
         */
        syncProgress?: SyncProgress

        /**
         * Error message if sync failed
         */
        syncError?: string

        config: {
            /**
             * Apify sources
             */
            datasetId?: string

            runId?: string
            actorId?: string
            startUrls?: string[]
            preset?: "kb" | "developer_docs" | "library" | "release_notes" | "marketing" | "custom"
            maxCrawlPages?: number
            includeGlobs?: string[]
            excludeGlobs?: string[]
            /**
             * Import settings (for Apify sources)
             */
            contentType?: string

            minContentLength?: number
            deduplicationDays?: number
            /**
             * Sync tracking
             */
            syncStartedAt?: number

            /**
             * OpenAPI sources
             */
            specUrl?: string

            specPath?: string
            /**
             * File sources
             */
            filePath?: string

            /**
             * API sources
             */
            apiUrl?: string
        }
        stats: {
            itemCount: number
            lastSynced: number | null
            lastImported: number | null
            importedCount: number
            /**
             * Products/topics covered with document counts
             */
            topicsCovered?: { [key: string]: number }
        }
        lastError?: string
        enabled: boolean
        createdAt: number
        updatedAt: number
    }

    export interface DataSourceInput {
        id: string
        name: string
        type: DataSourceType
        description?: string
        config: {
            /**
             * Apify sources
             */
            datasetId?: string

            runId?: string
            actorId?: string
            startUrls?: string[]
            preset?: "kb" | "developer_docs" | "library" | "release_notes" | "marketing" | "custom"
            maxCrawlPages?: number
            includeGlobs?: string[]
            excludeGlobs?: string[]
            /**
             * Import settings (for Apify sources)
             */
            contentType?: string

            minContentLength?: number
            deduplicationDays?: number
            /**
             * Sync tracking
             */
            syncStartedAt?: number

            /**
             * OpenAPI sources
             */
            specUrl?: string

            specPath?: string
            /**
             * File sources
             */
            filePath?: string

            /**
             * API sources
             */
            apiUrl?: string
        }
        enabled?: boolean
        status?: DataSourceStatus
    }

    export interface DataSourceResponse {
        error?: string
        id?: string
        name?: string
        type?: DataSourceType
        description?: string
        status?: DataSourceStatus
        syncState?: SyncState
        syncProgress?: SyncProgress
        syncError?: string
        config?: {
            /**
             * Apify sources
             */
            datasetId?: string

            runId?: string
            actorId?: string
            startUrls?: string[]
            preset?: "kb" | "developer_docs" | "library" | "release_notes" | "marketing" | "custom"
            maxCrawlPages?: number
            includeGlobs?: string[]
            excludeGlobs?: string[]
            /**
             * Import settings (for Apify sources)
             */
            contentType?: string

            minContentLength?: number
            deduplicationDays?: number
            /**
             * Sync tracking
             */
            syncStartedAt?: number

            /**
             * OpenAPI sources
             */
            specUrl?: string

            specPath?: string
            /**
             * File sources
             */
            filePath?: string

            /**
             * API sources
             */
            apiUrl?: string
        }
        stats?: {
            itemCount: number
            lastSynced: number | null
            lastImported: number | null
            importedCount: number
            /**
             * Products/topics covered with document counts
             */
            topicsCovered?: { [key: string]: number }
        }
        lastError?: string
        enabled?: boolean
        createdAt?: number
        updatedAt?: number
    }

    export type DataSourceStatus = "defined" | "configured" | "syncing" | "available" | "importing" | "imported" | "error"

    export interface DataSourceSummaryItem {
        id: string
        name: string
        type: string
        status: string
        enabled: boolean
        itemCount: number
        importedCount: number
        lastSynced: string | null
        lastImported: string | null
        hasDataset: boolean
        lastError?: string
        description: string
        processingStats: {
            linked: number
            failed: number
            pending: number
            lastLinkedAt: string | null
        } | null
    }

    export interface DataSourceTotals {
        apify: {
            sources: number
            items: number
            imported: number
        }
        openapi: {
            sources: number
            items: number
            imported: number
        }
        other: {
            sources: number
            items: number
            imported: number
        }
    }

    export type DataSourceType = "apify" | "openapi" | "file" | "api"

    export interface DataSourcesSummaryResponse {
        sources: DataSourceSummaryItem[]
        totals: DataSourceTotals
    }

    export interface DatasetAnalysis {
        /**
         * Basic stats
         */
        totalItems: number

        uniqueUrls: number
        avgContentLength: number
        minContentLength: number
        maxContentLength: number
        /**
         * Content breakdown
         */
        urlPatterns: UrlPatternStats[]

        productBreakdown: ProductBreakdown[]
        contentTypes: ContentTypeStats[]
        /**
         * Quality indicators
         */
        quality: QualityIndicators

        /**
         * Graph impact preview
         */
        graphImpact: GraphImpact

        /**
         * Sample content
         */
        samples: ContentSample[]
    }

    export interface DiffLine {
        type: "added" | "removed" | "unchanged"
        content: string
        lineNumber?: {
            base?: number
            compare?: number
        }
    }

    export type DiffStatus = "added" | "removed" | "modified" | "unchanged"

    export interface DocumentSearchResult {
        url: string
        title: string
        snippet: string
        productId?: string
        documentType?: string
        similarity: number
    }

    export interface EndpointQueryRequest {
        resource?: string
        method?: string
        pathPattern?: string
        tag?: string
    }

    export interface EndpointRef {
        method: string
        path: string
        summary?: string
        similarity?: number
    }

    export interface EndpointWithSchema {
        resourceName: string
        requestSchema?: SchemaWithFields
        responseSchema?: SchemaWithFields
        errors?: ErrorResponseNode[]
        method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE"
        path: string
        summary: string
        description: string
        tags: string[]
        deprecated: boolean
        authType: string
        scopes: string[]
        classicScopes?: string[]
        granularScopes?: string[]
        prerequisites?: string[]
        productId?: string
        exampleRequest?: string
        exampleResponse?: string
        embedding?: number[]
        embeddingText?: string
        /**
         * Source provenance - tracks which OpenAPI spec this came from
         */
        source?: SourceMetadata
    }

    export interface ErrorResponseNode {
        code: string
        message: string
        description: string
        resolution?: string
    }

    export interface ExportedNode {
        labels: string[]
        properties: { [key: string]: any }
    }

    export interface ExportedRelationship {
        type: string
        startNodeKey: string
        endNodeKey: string
        properties: { [key: string]: any }
    }

    export interface FeatureTrendsResult {
        period: string
        features: number
        fixes: number
        improvements: number
        releases: number
    }

    export interface FieldNode {
        name: string
        type: string
        required: boolean
        description: string
        enumValues?: string[]
        defaultValue?: string
        format?: string
        example?: string
    }

    export interface GraphExport {
        exportedAt: string
        graphName: string
        version: string
        nodes: ExportedNode[]
        relationships: ExportedRelationship[]
        stats: {
            nodeCount: number
            relationshipCount: number
            nodeTypes: { [key: string]: number }
            relationshipTypes: { [key: string]: number }
        }
        pagination?: {
            offset: number
            limit: number
            hasMore: boolean
        }
    }

    export interface GraphHealth {
        /**
         * ISO timestamp of last crawl
         */
        lastCrawled: string

        /**
         * Days since last crawl
         */
        staleDays: number

        /**
         * Freshness indicator
         */
        freshness: "fresh" | "stale" | "critical"

        /**
         * Node statistics
         */
        nodes: {
            total: number
            byType: { [key: string]: number }
        }

        /**
         * Relationship statistics
         */
        relationships: {
            total: number
            byType: { [key: string]: number }
        }

        /**
         * Memory usage in MB (if available)
         */
        memoryMB?: number

        /**
         * Percentage of nodes with embeddings
         */
        embeddingCoverage: number

        /**
         * Percentage of features linked to endpoints
         */
        linkCoverage: number
    }

    export interface GraphImpact {
        /**
         * Would create new Document nodes
         */
        newDocuments: number

        /**
         * Would update existing nodes
         */
        updatedDocuments: number

        /**
         * Already in graph (< dedup window)
         */
        skippedDuplicates: number

        /**
         * Products that would get new content
         */
        productsAffected: string[]

        /**
         * Per-product coverage change
         */
        estimatedCoverage: {
            product: string
            currentDocs: number
            afterDocs: number
            change: string
        }[]
    }

    export interface GraphMapping {
        url: string
        status: "not_imported" | "imported"
        document?: {
            url: string
            title: string
            product: string | null
            contentType: string | null
            crawledAt: number | null
            crawlSource: string | null
            sourceId: string | null
            hasEmbedding: boolean
            markdownLength: number
        }
        relationships: {
            belongsToProduct: {
                id: string
                name: string
            } | null
            sections: {
                heading: string
                level: number
            }[]
            documentedFeatures: {
                id: string
                title: string
                product: string
            }[]
            documentedEndpoints: {
                path: string
                method: string
            }[]
            extractedGuides: {
                id: string
                title: string
            }[]
        }
        processingSteps: {
            step: string
            status: "completed" | "pending" | "skipped"
            details?: string
        }[]
    }

    export interface GuideExtractionResult {
        articlesProcessed: number
        guidesExtracted: number
        stepsExtracted: number
        errors: string[]
    }

    export interface GuideNode {
        id: string
        title: string
        product: string
        domain: string
        sourceUrl: string
        extractedAt: number
        confidence: number
    }

    export interface GuideSearchResult {
        guide: GuideNode
        similarity: number
    }

    export interface GuideWithLinks {
        guide: GuideNode
        prerequisites: PrerequisiteNode[]
        steps: StepWithEndpoint[]
        sourceContent?: {
            url: string
            title: string
        }
    }

    export interface HasCapabilityResult {
        has: boolean
        since?: string
        description?: string
    }

    export interface HealthCheckResult {
        id: string
        category: string
        question: string
        status: "pass" | "fail" | "warn" | "skip"
        message: string
        duration: number
        details?: {
            searchResults?: number
            validationResult?: number
            expectedMin?: number
        }
    }

    export interface HealthCheckSummary {
        timestamp: number
        duration: number
        total: number
        passed: number
        failed: number
        warnings: number
        skipped: number
        results: HealthCheckResult[]
        overallStatus: "healthy" | "degraded" | "unhealthy"
    }

    export type KGState = "empty" | "seeded" | "building" | "ready" | "degraded" | "stale"

    export interface KGStateInfo {
        state: KGState
        lastRebuildStartedAt: string | null
        lastRebuildCompletedAt: string | null
        lastRebuildDurationMs: number | null
        lastRebuildDocsProcessed: number | null
        lastRebuildDocsSkipped: number | null
        lastRebuildDocsFailed: number | null
        lastRebuildError: string | null
        updatedAt: string
    }

    export interface OperationCoverage {
        operationId: string
        operationName: string
        category: string
        covered: boolean
        strength: "strong" | "weak" | "none"
        topMatch?: {
            title: string
            url: string
            similarity: number
            sourceType: "document" | "endpoint" | "release_feature"
        }
    }

    export interface PipelineArtifact {
        url: string
        sourceId: string
        title: string | null
        productId: string | null
        documentType: string | null
        contentHash: string | null
        processingState: ProcessingState
        processingError: string | null
        processedAt: string | null
        committedAt: string | null
        linkedAt: string | null
        createdAt: string
        updatedAt: string
    }

    export interface PrerequisiteNode {
        id: string
        type: PrerequisiteType
        description: string
        required: boolean
        confidence: number
    }

    export type PrerequisiteType = "license" | "feature" | "setting" | "permission" | "other"

    export type ProcessingState = "pending" | "processed" | "committed" | "linked" | "failed"

    export interface ProductBreakdown {
        product: string
        count: number
        sampleUrls: string[]
    }

    export interface ProductCategory {
        id: string
        name: string
        familyId: string
        description?: string
    }

    export interface ProductConceptCoverage {
        productId: string
        productName: string
        concepts: ConceptCoverage[]
        documentedPercent: number
    }

    export interface ProductCoverageItem {
        id: string
        name: string
        category: string
        apiEndpoints: number
        kbArticles: number
        libraryDocs: number
        devDocs: number
        productPages: number
        pricingPages: number
        caseStudies: number
        releaseNotes: boolean
        releaseFeatures: number
        totalContent: number
    }

    export interface ProductFamily {
        id: string
        name: string
        tagline?: string
        url?: string
    }

    export interface ProductOperationCoverage {
        productId: string
        productName: string
        operations: OperationCoverage[]
        coveragePercent: number
        gaps: string[]
    }

    export interface ProductScopes {
        productId: string
        productName: string
        scopes: ScopeEntry[]
    }

    export interface QualityIndicators {
        /**
         * Items with < 200 chars (will be skipped)
         */
        shortContent: number

        /**
         * Items with no title
         */
        emptyTitle: number

        /**
         * Duplicate URLs in dataset
         */
        duplicateUrls: number
    }

    export interface QueryLogEntry {
        id: string
        requestId: string | null
        query: string
        createdAt: string
        topK: number
        threshold: number
        productFilter: string | null
        rerankEnabled: boolean
        docVectorCount: number | null
        docVectorLatencyMs: number | null
        featureVectorCount: number | null
        featureVectorLatencyMs: number | null
        mergedCount: number | null
        dedupRemoved: number | null
        preFilterCount: number | null
        postFilterCount: number | null
        filteredOut: number | null
        rerankInputCount: number | null
        rerankOutputCount: number | null
        rerankLatencyMs: number | null
        rerankScoreDeltas: any[] | null
        rerankTopPromoted: string | null
        rerankTopDemoted: string | null
        finalCount: number | null
        totalLatencyMs: number | null
        embeddingLatencyMs: number | null
    }

    export interface RebuildReport {
        runId: string
        startedAt: number
        completedAt: number
        duration: number
        sync: {
            products: {
                seeded: number
            }
            endpoints: {
                total: number
                byProduct: { [key: string]: number }
            }
            documents: {
                added: number
                updated: number
            }
            features: {
                added: number
            }
        }
        coverage: {
            productsWithEndpoints: number
            productsWithDocs: number
            productsWithFeatures: number
            totalProducts: number
        }
        health: {
            passed: number
            failed: number
            warnings: number
            failedChecks: string[]
        }
        documentStatus: { [key: string]: number }
        errors: string[]
    }

    export interface RebuildReportResponse {
        error?: string
        runId?: string
        startedAt?: number
        completedAt?: number
        duration?: number
        sync?: {
            products: {
                seeded: number
            }
            endpoints: {
                total: number
                byProduct: { [key: string]: number }
            }
            documents: {
                added: number
                updated: number
            }
            features: {
                added: number
            }
        }
        coverage?: {
            productsWithEndpoints: number
            productsWithDocs: number
            productsWithFeatures: number
            totalProducts: number
        }
        health?: {
            passed: number
            failed: number
            warnings: number
            failedChecks: string[]
        }
        documentStatus?: { [key: string]: number }
        errors?: string[]
    }

    export interface RecentFeatureResult {
        description: string
        type: string
        category?: string
        releaseDate: string
    }

    export interface ReleaseNotesSyncResult {
        product: string
        url: string
        releasesFound: number
        featuresStored: number
        tablesExtracted: number
        error?: string
    }

    export interface ReleaseVelocityResult {
        productId: string
        month: string
        releaseCount: number
        featureCount: number
        fixCount: number
    }

    export interface SchemaWithFields {
        fields: FieldNode[]
        name: string
        type: "request" | "response"
        description: string
    }

    export interface ScopeAuditResponse {
        summary: {
            totalScopes: number
            allGraphScopes: number
            usedEndpoints: number
            grantedCount: number
            missingCount: number
            products: number
            accountName?: string
        }
        products: ProductScopes[]
    }

    export interface ScopeEndpoint {
        method: string
        path: string
        summary: string
        description?: string
        usedBy?: ScopeEndpointUsageRef[]
    }

    export interface ScopeEndpointUsageRef {
        file: string
        function: string
        context: string
    }

    export interface ScopeEntry {
        scope: string
        scopeType: "classic" | "granular"
        granted: boolean | null
        endpoints: ScopeEndpoint[]
        usedBy?: ScopeEndpointUsageRef[]
    }

    export interface SearchResult {
        url: string
        title: string
        snippet: string
        similarity: number
        /**
         * Original vector similarity score before reranking
         */
        vectorSimilarity?: number

        sourceType: SourceType
        product?: string
        publishedAt?: string
        metadata?: { [key: string]: any }
    }

    export interface SourceAnalysis {
        sourceId: string
        sourceType: string
        totalItems: number
        topicsCovered: TopicCoverage[]
        contentTypes: {
            type: string
            count: number
        }[]
        quality: {
            withContent: number
            withoutContent: number
            avgContentLength: number
        }
        analyzedAt: string
    }

    export interface SourceMetadata {
        sourceUrl: string
        extractedAt: number
        rawContentHash: string
        extractionMethod: "tavily_extract" | "tavily_search" | "openapi_spec" | "direct_fetch"
    }

    export type SourceType = "release_note" | "kb_article" | "config_guide" | "api_docs"

    export interface StepWithEndpoint {
        endpoint?: EndpointRef
        id: string
        order: number
        action: string
        description: string
        uiPath?: string
        apiHint?: string
        confidence: number
        embedding?: number[]
    }

    export interface StoredCrawlSummary {
        sourceId: string
        runId: string
        datasetId: string
        crawledAt: string
        itemCount: number
        actorId: string
        memoryMb: number
    }

    export interface SubTopic {
        name: string
        count: number
    }

    export interface SyncAllResult {
        results: ReleaseNotesSyncResult[]
        totalReleases: number
        totalFeatures: number
        duration: number
    }

    export interface SyncProgress {
        /**
         * Pages crawled so far (CRAWLING state)
         */
        pagesCrawled?: number

        /**
         * Total pages expected (CRAWLING state)
         */
        pagesTotal?: number

        /**
         * Items fetched from dataset (FETCHING state)
         */
        itemsFetched?: number

        /**
         * Items imported to graph (IMPORTING state)
         */
        itemsImported?: number

        /**
         * Current phase message
         */
        message?: string
    }

    export type SyncState = "IDLE" | "CRAWLING" | "FETCHING" | "STORING" | "IMPORTING" | "DONE" | "ERROR"

    export interface TopicCoverage {
        topic: string
        count: number
        sampleItems: string[]
        subTopics?: SubTopic[]
    }

    export interface UrlPatternStats {
        pattern: string
        count: number
        avgLength: number
    }
}

export namespace lib {
    export interface AccountData {
        id: string
        name: string
        email: string
        type: number
        typeName: string
        picUrl?: string
        timezone?: string
        createdAt?: string
        vanityUrl?: string
        managedDomains?: string[]
        scopeWarning?: string
        ownerName?: string
        ownerPicUrl?: string
    }

    export interface ArchiveData {
        "_status": "provisioned" | "not_provisioned"
        totalFiles?: number
        totalSize?: number
    }

    export interface DailyUsage {
        date: string
        meetings: number
        participants: number
        meetingMinutes: number
        newUsers: number
        uniqueParticipants?: number
        participantDetails?: ParticipantDetail[]
    }

    export interface GroupSummary {
        id: string
        name: string
        totalMembers: number
    }

    export interface GroupsData {
        totalGroups: number
        groups: GroupSummary[]
    }

    export interface LiveMeetingsData {
        "_scope": Scope
        totalLive: number
        meetings: {
            uuid: string
            topic: string
            host: string
            startTime: string
            participants: number
            hasIssues: boolean
        }[]
    }

    export interface MarketplaceData {
        totalApps: number
        apps: {
            name: string
            status?: string
        }[]
    }

    export interface MeetingQualityData {
        "_scope": Scope
        totalMeetings: number
        qualityDistribution: {
            good: number
            fair: number
            poor: number
            bad: number
        }
        avgQualityScore?: number
        recentMeetings: {
            uuid: string
            topic: string
            startTime: string
            duration: number
            participants: number
            quality: string
        }[]
    }

    export interface MonthlyUsage {
        month: string
        meetings: number
        participants: number
        meetingMinutes: number
        newUsers: number
        uniqueParticipants?: number
        participantDetails?: ParticipantDetail[]
    }

    export interface NotAvailable {
        "_status": "not_available"
        message: string
    }

    export interface OperationLogsData {
        "_scope": Scope
        totalLogs: number
        logs: {
            operator: string
            action: string
            categoryType: string
            time: string
        }[]
    }

    export interface ParticipantDetail {
        email: string
        name: string
    }

    export interface PhoneCallLogsData {
        "_scope": Scope
        totalCalls: number
        avgDurationSeconds: number
        byDirection: {
            inbound: number
            outbound: number
        }
        recentCalls: {
            callerName?: string
            callerNumber?: string
            calleeName?: string
            calleeNumber?: string
            direction: string
            duration: number
            startTime: string
            callType?: string
        }[]
    }

    export interface PhoneData {
        "_status": "provisioned" | "not_provisioned"
        companyName?: string
        autoCallRecording?: boolean
        emergencyServiceEnabled?: boolean
        voicemailEnabled?: boolean
        totalUsers?: number
    }

    export interface PlansData {
        "_scope": Scope
        planBase?: {
            type: string
            hosts: number
        }
        planLargeMeeting?: {
            type: string
            hosts: number
        }[]
        planWebinar?: {
            type: string
            hosts: number
        }[]
        planZoomRooms?: {
            type: string
            hosts: number
        }
    }

    export interface QosMetrics {
        bitrate?: string
        latency?: string
        jitter?: string
        packetLoss?: string
        resolution?: string
        frameRate?: string
    }

    export interface RecordingsData {
        "_scope": Scope
        totalRecords: number
        totalSize: number
        cloudRecordings: {
            topic: string
            startTime: string
            duration: number
            totalSize: number
            recordingCount: number
        }[]
    }

    export interface RoleSummary {
        id: string
        name: string
        description?: string
        totalMembers: number
    }

    export interface RolesData {
        totalRoles: number
        roles: RoleSummary[]
    }

    export interface RoomMetricsData {
        "_scope": Scope
        totalRooms: number
        online: number
        offline: number
        issues: {
            roomName: string
            issue: string
        }[]
    }

    export interface RoomsData {
        "_status": "provisioned" | "not_provisioned"
        totalRooms?: number
        rooms?: {
            id: string
            name: string
            status: string
        }[]
    }

    export interface SatisfactionData {
        "_scope": Scope
        totalResponses: number
        goodCount: number
        notGoodCount: number
        goodPercent: number
        dateRange: {
            from: string
            to: string
        }
    }

    export type Scope = "admin" | "user"

    export interface SettingsData {
        "_scope": Scope
        security: {
            waitingRoom?: boolean
            requirePassword?: boolean
            embedPasswordInLink?: boolean
            e2eEncryption?: boolean
            signedLogin?: boolean
            approvedDomains?: string[]
        }
        meeting: {
            hostVideo?: boolean
            participantVideo?: boolean
            joinBeforeHost?: boolean
            muteUponEntry?: boolean
            autoRecording?: string
            screenSharing?: boolean
            whoCanShare?: string
            breakoutRoom?: boolean
        }
        recording: {
            localRecording?: boolean
            cloudRecording?: boolean
            autoDelete?: boolean
            autoDeleteDays?: number
            recordingDisclaimer?: boolean
        }
    }

    export interface TelephoneData {
        "_scope": Scope
        totalMinutes: number
        totalCalls: number
        byType: { [key: string]: number }
    }

    export interface TopMeeting {
        topic: string
        occurrences: number
        avgParticipants: number
        avgDuration: number
        totalDuration: number
        lastOccurred: string
        host: string
    }

    export interface UsageData {
        "_scope": Scope
        year: number
        month: number
        totalMeetings: number
        totalParticipants: number
        totalMeetingMinutes: number
        dailyBreakdown: DailyUsage[]
        monthlyBreakdown: MonthlyUsage[]
        topMeetings?: TopMeeting[]
    }

    export interface UserSummary {
        email: string
        name: string
        type: number
        typeName: string
        role?: string
        status?: string
        lastLogin?: string
        department?: string
    }

    export interface UsersData {
        "_scope": Scope
        totalRecords: number
        users: UserSummary[]
        byType: { [key: string]: number }
        byStatus: { [key: string]: number }
    }

    export interface ZoomOverviewData {
        fetchedAt: string
        scope: Scope
        account: AccountData
        settings: SettingsData
        plans: PlansData | NotAvailable
        users: UsersData
        roles: RolesData | NotAvailable
        groups: GroupsData | NotAvailable
        usage: UsageData | NotAvailable
        recordings: RecordingsData
        phone: PhoneData
        rooms: RoomsData
        marketplace: MarketplaceData | NotAvailable
        archive: ArchiveData
        meetingQuality?: MeetingQualityData | NotAvailable
        satisfaction?: SatisfactionData | NotAvailable
        phoneCallLogs?: PhoneCallLogsData | NotAvailable
        telephone?: TelephoneData | NotAvailable
        liveMeetings?: LiveMeetingsData | NotAvailable
        roomMetrics?: RoomMetricsData | NotAvailable
        operationLogs?: OperationLogsData | NotAvailable
        aiSummary?: {
            scores: {
                security: number
                adoption: number
                usage: number
                configuration: number
                overall: number
            }
            keyPoints: string[]
            suggestions: string[]
            overallEvaluation: string
        }
    }
}

export namespace shared {
    export interface ApiCheck {
        description: string
        endpoint: string
        method: string
        expectedStatus: number
        expectedValues?: { [key: string]: any }
    }

    export interface ApiValidation {
        checks: ApiCheck[]
    }

    export interface Artifact {
        id: string
        type: ArtifactType
        title?: string
        content: string
        metadata?: { [key: string]: any }
    }

    export type ArtifactType = "mermaid" | "code" | "table" | "insights" | "config" | "markdown" | "plan"

    export interface ChatValidation {
        widgetUrl: string
        testMessages: string[]
        expectedResponses?: string[]
        testEscalation: boolean
    }

    export interface CompletedTask {
        taskId: string
        resourceId?: string
        resourceType: string
        resourceName?: string
        response: any
        duration: number
    }

    export type ConfigurationAction = "create" | "update" | "delete" | "configure"

    export type ConfigurationDomain = "voice_routing" | "chat_routing" | "video_routing" | "ivr" | "queues" | "skills" | "flows" | "zva_flows" | "knowledge_base" | "escalation" | "data_collection" | "scorecards" | "evaluations" | "sampling" | "alerts" | "reports" | "scheduling" | "forecasting" | "pto" | "shift_swaps" | "shift_bidding" | "kb_triggers" | "greeting_scripts" | "auto_disposition" | "auto_notes" | "campaigns" | "contact_lists" | "calling_windows" | "voicemail" | "call_queues" | "auto_receptionists" | "call_handling" | "phone_users" | "meeting_settings" | "webinar_settings" | "channels" | "room_devices"

    export interface ConfigurationIntent {
        id: string
        product: ZoomProduct
        domain: ConfigurationDomain
        action: ConfigurationAction
        entity: string
        parameters: { [key: string]: any }
        sourceText?: string
        confidence: number
    }

    export interface ConfigurationTask {
        id: string
        intentId: string
        operation: HttpMethod
        endpoint: string
        payload?: { [key: string]: any }
        dependencies: string[]
        resourceIdMapping?: ResourceIdMapping[]
        resourceType: string
        resourceName?: string
        rollbackOperation?: HttpMethod
        rollbackEndpoint?: string
    }

    export interface CreatedResource {
        type: string
        id: string
        name: string
    }

    export interface ExecutionPlan {
        id: string
        intents: ConfigurationIntent[]
        tasks: ConfigurationTask[]
        executionOrder: string[]
        estimatedApiCalls: number
        warnings: string[]
        blockers: string[]
    }

    export interface ExecutionResult {
        planId: string
        executionId: string
        status: ExecutionStatus
        startedAt: string
        completedAt: string
        completedTasks: CompletedTask[]
        failedTask?: FailedTask
        createdResources: CreatedResource[]
        dryRun: boolean
    }

    export type ExecutionStatus = "success" | "partial" | "failed" | "rolled_back" | "dry_run"

    export interface FailedTask {
        taskId: string
        error: string
        errorCode?: string
        rollbackPerformed: boolean
    }

    export interface FieldMismatch {
        field: string
        expected: any
        actual: any
        severity: MismatchSeverity
    }

    export type HttpMethod = "GET" | "POST" | "PATCH" | "PUT" | "DELETE"

    export interface ImplementationPlan {
        id: string
        tenantId: string
        conversationId?: string
        name: string
        description?: string
        sourceDocumentId?: string
        stages: PlanStage[]
        status: PlanStatus
        createdAt: string
        updatedAt: string
        approvedAt?: string
        completedAt?: string
    }

    export interface ManualValidation {
        instructions: string
        checklistItems: string[]
    }

    export type MismatchSeverity = "critical" | "warning" | "info"

    export interface PlanStage {
        id: string
        name: string
        description: string
        order: number
        dependencies: string[]
        actions: PlannedAction[]
        validation?: ValidationConfig
        status: StageStatus
        startedAt?: string
        completedAt?: string
        errorMessage?: string
    }

    export type PlanStatus = "draft" | "approved" | "executing" | "paused" | "completed" | "failed" | "rolled_back"

    export interface PlannedAction {
        id: string
        type: string
        description: string
        endpoint?: string
        method?: string
        payload?: { [key: string]: any }
        rollbackAction?: {
            id: string
            type: string
            description: string
            endpoint?: string
            method?: string
            payload?: { [key: string]: any }
        }
    }

    export interface ReadBackVerification {
        taskId: string
        resourceType: string
        resourceId: string
        expectedFields: { [key: string]: any }
        actualFields: { [key: string]: any }
        matches: boolean
        mismatches: FieldMismatch[]
        attempts: number
        duration: number
    }

    export interface ResourceIdMapping {
        placeholder: string
        sourceTaskId: string
        outputPath: string
    }

    export interface ResourceState {
        type: string
        id: string
        name: string
        properties: { [key: string]: any }
    }

    export type StageStatus = "pending" | "in_progress" | "completed" | "failed" | "skipped" | "rolled_back"

    export interface StateDiff {
        planId: string
        timestamp: string
        desiredState: ResourceState[]
        actualState: ResourceState[]
        missing: ResourceState[]
        unexpected: ResourceState[]
        modified: {
            resource: ResourceState
            differences: FieldMismatch[]
        }[]
        matching: ResourceState[]
    }

    export interface SyntheticTest {
        id: string
        type: string
        target: {
            type: string
            id: string
            name?: string
        }
        steps: {
            action: string
            parameters: { [key: string]: any }
            expectedResult: string
            actualResult?: string
            passed?: boolean
        }[]
        status: "pending" | "running" | "passed" | "failed" | "skipped"
        error?: string
        duration?: number
    }

    export interface ValidationConfig {
        type: "voice" | "chat" | "api" | "manual"
        config: VoiceValidation | ChatValidation | ApiValidation | ManualValidation
        expectedOutcome: string
    }

    export interface VerificationIssue {
        layer: VerificationLayer
        severity: MismatchSeverity
        resourceType: string
        resourceId?: string
        message: string
        remediation?: string
    }

    export type VerificationLayer = "read_back" | "state_diff" | "webhook" | "synthetic" | "health"

    export type VerificationMode = "full" | "standard" | "quick" | "async" | "none"

    export type VerificationOverallStatus = "verified" | "partial" | "failed"

    export interface VerificationResult {
        planId: string
        executionId: string
        timestamp: string
        mode: VerificationMode
        layers: {
            readBack: ReadBackVerification[]
            stateDiff?: StateDiff
            webhooks: WebhookConfirmation[]
            synthetic: SyntheticTest[]
        }
        overallStatus: VerificationOverallStatus
        summary: {
            totalChecks: number
            passed: number
            failed: number
            warnings: number
            skipped: number
        }
        issues: VerificationIssue[]
    }

    export interface VoiceValidation {
        phoneNumber: string
        scenario: string
        expectedRouting: string
        maxWaitTime: number
        testOptions?: number[]
    }

    export interface WebhookConfirmation {
        resourceType: string
        resourceId: string
        expectedEvent: string
        receivedEvent?: {
            event: string
            payload: { [key: string]: any }
            timestamp: string
        }
        status: "pending" | "confirmed" | "timeout" | "unexpected"
        waitStarted: string
        timeout: number
    }

    export interface ZoomAccountInfo {
        id: string
        name: string
        licenses: {
            contactCenter: boolean
            virtualAgent: boolean
            qualityManagement: boolean
            workforceManagement: boolean
            expertAssist: boolean
            outboundDialer: boolean
        }
    }

    export interface ZoomCredentials {
        accountId: string
        clientId: string
        clientSecret: string
    }

    export interface ZoomCredentials {
        accountId: string
        clientId: string
        clientSecret: string
    }

    export type ZoomProduct = "contact_center" | "virtual_agent" | "quality_management" | "workforce_management" | "expert_assist" | "outbound" | "phone" | "meetings" | "team_chat" | "rooms"
}



function encodeQuery(parts: Record<string, string | string[]>): string {
    const pairs: string[] = []
    for (const key in parts) {
        const val = (Array.isArray(parts[key]) ?  parts[key] : [parts[key]]) as string[]
        for (const v of val) {
            pairs.push(`${key}=${encodeURIComponent(v)}`)
        }
    }
    return pairs.join("&")
}

// makeRecord takes a record and strips any undefined values from it,
// and returns the same record with a narrower type.
// @ts-ignore - TS ignore because makeRecord is not always used
function makeRecord<K extends string | number | symbol, V>(record: Record<K, V | undefined>): Record<K, V> {
    for (const key in record) {
        if (record[key] === undefined) {
            delete record[key]
        }
    }
    return record as Record<K, V>
}

function encodeWebSocketHeaders(headers: Record<string, string>) {
    // url safe, no pad
    const base64encoded = btoa(JSON.stringify(headers))
      .replaceAll("=", "")
      .replaceAll("+", "-")
      .replaceAll("/", "_");
    return "encore.dev.headers." + base64encoded;
}

class WebSocketConnection {
    public ws: WebSocket;

    private hasUpdateHandlers: (() => void)[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        let protocols = ["encore-ws"];
        if (headers) {
            protocols.push(encodeWebSocketHeaders(headers))
        }

        this.ws = new WebSocket(url, protocols)

        this.on("error", () => {
            this.resolveHasUpdateHandlers();
        });

        this.on("close", () => {
            this.resolveHasUpdateHandlers();
        });
    }

    resolveHasUpdateHandlers() {
        const handlers = this.hasUpdateHandlers;
        this.hasUpdateHandlers = [];

        for (const handler of handlers) {
            handler()
        }
    }

    async hasUpdate() {
        // await until a new message have been received, or the socket is closed
        await new Promise((resolve) => {
            this.hasUpdateHandlers.push(() => resolve(null))
        });
    }

    on(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.addEventListener(type, handler);
    }

    off(type: "error" | "close" | "message" | "open", handler: (event: any) => void) {
        this.ws.removeEventListener(type, handler);
    }

    close() {
        this.ws.close();
    }
}

export class StreamInOut<Request, Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamIn<Response> {
    public socket: WebSocketConnection;
    private buffer: Response[] = [];

    constructor(url: string, headers?: Record<string, string>) {
        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            this.buffer.push(JSON.parse(event.data));
            this.socket.resolveHasUpdateHandlers();
        });
    }

    close() {
        this.socket.close();
    }

    async next(): Promise<Response | undefined> {
        for await (const next of this) return next;
        return undefined;
    }

    async *[Symbol.asyncIterator](): AsyncGenerator<Response, undefined, void> {
        while (true) {
            if (this.buffer.length > 0) {
                yield this.buffer.shift() as Response;
            } else {
                if (this.socket.ws.readyState === WebSocket.CLOSED) return;
                await this.socket.hasUpdate();
            }
        }
    }
}

export class StreamOut<Request, Response> {
    public socket: WebSocketConnection;
    private responseValue: Promise<Response>;

    constructor(url: string, headers?: Record<string, string>) {
        let responseResolver: (_: any) => void;
        this.responseValue = new Promise((resolve) => responseResolver = resolve);

        this.socket = new WebSocketConnection(url, headers);
        this.socket.on("message", (event: any) => {
            responseResolver(JSON.parse(event.data))
        });
    }

    async response(): Promise<Response> {
        return this.responseValue;
    }

    close() {
        this.socket.close();
    }

    async send(msg: Request) {
        if (this.socket.ws.readyState === WebSocket.CONNECTING) {
            // await that the socket is opened
            await new Promise((resolve) => {
                this.socket.ws.addEventListener("open", resolve, { once: true });
            });
        }

        return this.socket.ws.send(JSON.stringify(msg));
    }
}
// CallParameters is the type of the parameters to a method call, but require headers to be a Record type
type CallParameters = Omit<RequestInit, "method" | "body" | "headers"> & {
    /** Headers to be sent with the request */
    headers?: Record<string, string>

    /** Query parameters to be sent with the request */
    query?: Record<string, string | string[]>
}

// AuthDataGenerator is a function that returns a new instance of the authentication data required by this API
export type AuthDataGenerator = () =>
  | auth.AuthParams
  | Promise<auth.AuthParams | undefined>
  | undefined;

// A fetcher is the prototype for the inbuilt Fetch function
export type Fetcher = typeof fetch;

const boundFetch = fetch.bind(this);

class BaseClient {
    readonly baseURL: string
    readonly fetcher: Fetcher
    readonly headers: Record<string, string>
    readonly requestInit: Omit<RequestInit, "headers"> & { headers?: Record<string, string> }
    readonly authGenerator?: AuthDataGenerator

    constructor(baseURL: string, options: ClientOptions) {
        this.baseURL = baseURL
        this.headers = {}

        // Add User-Agent header if the script is running in the server
        // because browsers do not allow setting User-Agent headers to requests
        if (!BROWSER) {
            this.headers["User-Agent"] = "zac-2w8i-Generated-TS-Client (Encore/v1.54.0)";
        }

        this.requestInit = options.requestInit ?? {};

        // Setup what fetch function we'll be using in the base client
        if (options.fetcher !== undefined) {
            this.fetcher = options.fetcher
        } else {
            this.fetcher = boundFetch
        }

        // Setup an authentication data generator using the auth data token option
        if (options.auth !== undefined) {
            const auth = options.auth
            if (typeof auth === "function") {
                this.authGenerator = auth
            } else {
                this.authGenerator = () => auth
            }
        }
    }

    async getAuthData(): Promise<CallParameters | undefined> {
        let authData: auth.AuthParams | undefined;

        // If authorization data generator is present, call it and add the returned data to the request
        if (this.authGenerator) {
            const mayBePromise = this.authGenerator();
            if (mayBePromise instanceof Promise) {
                authData = await mayBePromise;
            } else {
                authData = mayBePromise;
            }
        }

        if (authData) {
            const data: CallParameters = {};

            data.headers = makeRecord<string, string>({
                authorization: authData.authorization,
                "x-tenant-id": authData.tenantId,
            });

            return data;
        }

        return undefined;
    }

    // createStreamInOut sets up a stream to a streaming API endpoint.
    async createStreamInOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamInOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamInOut(this.baseURL + path + queryString, headers);
    }

    // createStreamIn sets up a stream to a streaming API endpoint.
    async createStreamIn<Response>(path: string, params?: CallParameters): Promise<StreamIn<Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamIn(this.baseURL + path + queryString, headers);
    }

    // createStreamOut sets up a stream to a streaming API endpoint.
    async createStreamOut<Request, Response>(path: string, params?: CallParameters): Promise<StreamOut<Request, Response>> {
        let { query, headers } = params ?? {};

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                headers = {...headers, ...authData.headers};
            }
        }

        const queryString = query ? '?' + encodeQuery(query) : ''
        return new StreamOut(this.baseURL + path + queryString, headers);
    }

    // callTypedAPI makes an API call, defaulting content type to "application/json"
    public async callTypedAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        return this.callAPI(method, path, body, {
            ...params,
            headers: { "Content-Type": "application/json", ...params?.headers }
        });
    }

    // callAPI is used by each generated API method to actually make the request
    public async callAPI(method: string, path: string, body?: RequestInit["body"], params?: CallParameters): Promise<Response> {
        let { query, headers, ...rest } = params ?? {}
        const init = {
            ...this.requestInit,
            ...rest,
            method,
            body: body ?? null,
        }

        // Merge our headers with any predefined headers
        init.headers = {...this.headers, ...init.headers, ...headers}

        // Fetch auth data if there is any
        const authData = await this.getAuthData();

        // If we now have authentication data, add it to the request
        if (authData) {
            if (authData.query) {
                query = {...query, ...authData.query};
            }
            if (authData.headers) {
                init.headers = {...init.headers, ...authData.headers};
            }
        }

        // Make the actual request
        const queryString = query ? '?' + encodeQuery(query) : ''
        const response = await this.fetcher(this.baseURL+path+queryString, init)

        // handle any error responses
        if (!response.ok) {
            // try and get the error message from the response body
            let body: APIErrorResponse = { code: ErrCode.Unknown, message: `request failed: status ${response.status}` }

            // if we can get the structured error we should, otherwise give a best effort
            try {
                const text = await response.text()

                try {
                    const jsonBody = JSON.parse(text)
                    if (isAPIErrorResponse(jsonBody)) {
                        body = jsonBody
                    } else {
                        body.message += ": " + JSON.stringify(jsonBody)
                    }
                } catch {
                    body.message += ": " + text
                }
            } catch (e) {
                // otherwise we just append the text to the error message
                body.message += ": " + String(e)
            }

            throw new APIError(response.status, body)
        }

        return response
    }
}

/**
 * APIErrorDetails represents the response from an Encore API in the case of an error
 */
interface APIErrorResponse {
    code: ErrCode
    message: string
    details?: any
}

function isAPIErrorResponse(err: any): err is APIErrorResponse {
    return (
        err !== undefined && err !== null &&
        isErrCode(err.code) &&
        typeof(err.message) === "string" &&
        (err.details === undefined || err.details === null || typeof(err.details) === "object")
    )
}

function isErrCode(code: any): code is ErrCode {
    return code !== undefined && Object.values(ErrCode).includes(code)
}

/**
 * APIError represents a structured error as returned from an Encore application.
 */
export class APIError extends Error {
    /**
     * The HTTP status code associated with the error.
     */
    public readonly status: number

    /**
     * The Encore error code
     */
    public readonly code: ErrCode

    /**
     * The error details
     */
    public readonly details?: any

    constructor(status: number, response: APIErrorResponse) {
        // extending errors causes issues after you construct them, unless you apply the following fixes
        super(response.message);

        // set error name as constructor name, make it not enumerable to keep native Error behavior
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/new.target#new.target_in_constructors
        Object.defineProperty(this, 'name', {
            value:        'APIError',
            enumerable:   false,
            configurable: true,
        })

        // fix the prototype chain
        if ((Object as any).setPrototypeOf == undefined) {
            (this as any).__proto__ = APIError.prototype
        } else {
            Object.setPrototypeOf(this, APIError.prototype);
        }

        // capture a stack trace
        if ((Error as any).captureStackTrace !== undefined) {
            (Error as any).captureStackTrace(this, this.constructor);
        }

        this.status = status
        this.code = response.code
        this.details = response.details
    }
}

/**
 * Typeguard allowing use of an APIError's fields'
 */
export function isAPIError(err: any): err is APIError {
    return err instanceof APIError;
}

export enum ErrCode {
    /**
     * OK indicates the operation was successful.
     */
    OK = "ok",

    /**
     * Canceled indicates the operation was canceled (typically by the caller).
     *
     * Encore will generate this error code when cancellation is requested.
     */
    Canceled = "canceled",

    /**
     * Unknown error. An example of where this error may be returned is
     * if a Status value received from another address space belongs to
     * an error-space that is not known in this address space. Also
     * errors raised by APIs that do not return enough error information
     * may be converted to this error.
     *
     * Encore will generate this error code in the above two mentioned cases.
     */
    Unknown = "unknown",

    /**
     * InvalidArgument indicates client specified an invalid argument.
     * Note that this differs from FailedPrecondition. It indicates arguments
     * that are problematic regardless of the state of the system
     * (e.g., a malformed file name).
     *
     * This error code will not be generated by the gRPC framework.
     */
    InvalidArgument = "invalid_argument",

    /**
     * DeadlineExceeded means operation expired before completion.
     * For operations that change the state of the system, this error may be
     * returned even if the operation has completed successfully. For
     * example, a successful response from a server could have been delayed
     * long enough for the deadline to expire.
     *
     * The gRPC framework will generate this error code when the deadline is
     * exceeded.
     */
    DeadlineExceeded = "deadline_exceeded",

    /**
     * NotFound means some requested entity (e.g., file or directory) was
     * not found.
     *
     * This error code will not be generated by the gRPC framework.
     */
    NotFound = "not_found",

    /**
     * AlreadyExists means an attempt to create an entity failed because one
     * already exists.
     *
     * This error code will not be generated by the gRPC framework.
     */
    AlreadyExists = "already_exists",

    /**
     * PermissionDenied indicates the caller does not have permission to
     * execute the specified operation. It must not be used for rejections
     * caused by exhausting some resource (use ResourceExhausted
     * instead for those errors). It must not be
     * used if the caller cannot be identified (use Unauthenticated
     * instead for those errors).
     *
     * This error code will not be generated by the gRPC core framework,
     * but expect authentication middleware to use it.
     */
    PermissionDenied = "permission_denied",

    /**
     * ResourceExhausted indicates some resource has been exhausted, perhaps
     * a per-user quota, or perhaps the entire file system is out of space.
     *
     * This error code will be generated by the gRPC framework in
     * out-of-memory and server overload situations, or when a message is
     * larger than the configured maximum size.
     */
    ResourceExhausted = "resource_exhausted",

    /**
     * FailedPrecondition indicates operation was rejected because the
     * system is not in a state required for the operation's execution.
     * For example, directory to be deleted may be non-empty, an rmdir
     * operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FailedPrecondition, Aborted, and Unavailable:
     *  (a) Use Unavailable if the client can retry just the failing call.
     *  (b) Use Aborted if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FailedPrecondition if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FailedPrecondition
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FailedPrecondition if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     *
     * This error code will not be generated by the gRPC framework.
     */
    FailedPrecondition = "failed_precondition",

    /**
     * Aborted indicates the operation was aborted, typically due to a
     * concurrency issue like sequencer check failures, transaction aborts,
     * etc.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     */
    Aborted = "aborted",

    /**
     * OutOfRange means operation was attempted past the valid range.
     * E.g., seeking or reading past end of file.
     *
     * Unlike InvalidArgument, this error indicates a problem that may
     * be fixed if the system state changes. For example, a 32-bit file
     * system will generate InvalidArgument if asked to read at an
     * offset that is not in the range [0,2^32-1], but it will generate
     * OutOfRange if asked to read from an offset past the current
     * file size.
     *
     * There is a fair bit of overlap between FailedPrecondition and
     * OutOfRange. We recommend using OutOfRange (the more specific
     * error) when it applies so that callers who are iterating through
     * a space can easily look for an OutOfRange error to detect when
     * they are done.
     *
     * This error code will not be generated by the gRPC framework.
     */
    OutOfRange = "out_of_range",

    /**
     * Unimplemented indicates operation is not implemented or not
     * supported/enabled in this service.
     *
     * This error code will be generated by the gRPC framework. Most
     * commonly, you will see this error code when a method implementation
     * is missing on the server. It can also be generated for unknown
     * compression algorithms or a disagreement as to whether an RPC should
     * be streaming.
     */
    Unimplemented = "unimplemented",

    /**
     * Internal errors. Means some invariants expected by underlying
     * system has been broken. If you see one of these errors,
     * something is very broken.
     *
     * This error code will be generated by the gRPC framework in several
     * internal error conditions.
     */
    Internal = "internal",

    /**
     * Unavailable indicates the service is currently unavailable.
     * This is a most likely a transient condition and may be corrected
     * by retrying with a backoff. Note that it is not always safe to retry
     * non-idempotent operations.
     *
     * See litmus test above for deciding between FailedPrecondition,
     * Aborted, and Unavailable.
     *
     * This error code will be generated by the gRPC framework during
     * abrupt shutdown of a server process or network connection.
     */
    Unavailable = "unavailable",

    /**
     * DataLoss indicates unrecoverable data loss or corruption.
     *
     * This error code will not be generated by the gRPC framework.
     */
    DataLoss = "data_loss",

    /**
     * Unauthenticated indicates the request does not have valid
     * authentication credentials for the operation.
     *
     * The gRPC framework will generate this error code when the
     * authentication metadata is invalid or a Credentials callback fails,
     * but also expect authentication middleware to generate it.
     */
    Unauthenticated = "unauthenticated",
}
